/**
 * @title product_helper.js: utility module
 * @description This module is fabulous. A utility
 * module for the product page.
 * @author kmedz
 */
define([], function() {
	var itemIdMap= new Map();
	var listOfObjects = [];
	 var OOSMap= new Map();
	var Product = {
    /**
     * This variable corresponds with the kind of product we're looking
     * at. It gets set in mathtable.js.init as part of the product.module.js.init
     * process.
     * @type {[string]}
     */
    item_type: undefined,
    chatWindow: undefined,
    
    /**
     * This constant represents top value that can be set for quantity for BD
     */
    MAX_QUANTITY_BD: 9999,
    
    /**
     * This constant represents bottom value that can be set for quantity
     */
    MIN_QUANTITY: 1,
    
    SKIP_EDD: false,
    isLocCtrlSmallPck : false,
    isEDDStatusAvailable :true,
    isEddItem : false,

    /**
     * The initializing function modules use
     * to call.
     * @return {[type]} [description]
     */
    init: function() {
    	
    	if (isBDApplication && isBDApplication === 'BC'){
    		var pageNames="";
    		if(window.currentPageName !== undefined) {
    			pageNames = window.currentPageName;
    		}
    		if ($("#left-side-content") != undefined && pageNames === 'pdp' ) {
    			  $(window).scroll(function () {
    		      var windowWidth = parseInt(window.innerWidth);
    			  if (window.pageYOffset > parseFloat($("#left-side-content").offset().top - 50)) {
    			      if (windowWidth > 768){
    			    	  $("#left-side-content").css({
    			          "position": "sticky",
    			          "top": "20px",
    			          "background": "#fff"
    			        });
    			        if ($("#product-details").height() > $("#zoomViewer").height()){
    			          if ($(".bottom-content").offset().top - window.pageYOffset - $("#product-details").height() < 0) {
    			        	  $("#left-side-content").css({
    			              "position": "sticky",
    			              "top": `${$(".bottom-content").offset().top - window.pageYOffset - $("#product-details").height() + 20}px`,
    			              "background": "#fff"
    			            });
    			          }
    			        }
    			        else {
	    			          if ($(".bottom-content").offset().top - window.pageYOffset - $("#zoomViewer").height() < 0) {
	    			        	  $("#left-side-content").css({
	    			              "position": "sticky",
	    			              "top": `${$(".bottom-content").offset().top - window.pageYOffset - $("#zoomViewer").height() + 20}px`,
	    			              "background": "#fff"
	
	    			            });
	    			          }
    			        }
    			      }
    			      else {
		    			     $("#left-side-content").css({
		    			      "position": "static",
		    			      "top": "20px",
		    			      "background": "#fff"
		    			      });
		    			      $(".top-content").css({"background-color": "#fff"});
		    			      $(".product-interaction").css({"background-color": "#fff"});
		    			      $("#fulfillments").css({"background-color": "#fff"});
		    			      $(".buyinstoreonly").css({"background-color": "#fff"});
    			      }
    			      if(COSTCO.CMath.iskitsbundle){
    			    	 $(".style-select").addClass("kits-pdp-margin");
    			      }
    			   
    			      $("#product-page").css({"padding-bottom": "0px"})
    			      $("#product-info").css({ "background": "#fff" });
    			      $("#merkle-recommendations").css({ "background-color": "#fff" });
    			      $("#product-vendor-content > div").css({ "background-color": "#fff" });
    			    } else {
		    			      $("#left-side-content").css({
		    			      "position": "static",
		    			      "top": "20px",
		    			      "background": "transparent"
		    			      });
    			    }
    			  });
    		}      
    	
    	}
      $('#product-page').attr("data-onloadTracker","true");
      if(isBVv2Enabled === 'false') {
    	  this.hide_writereview();    	  
      }
      this.maskQuantityInput();
      this.product_details_view_more();
      this.enablePlainPackagingMessage();
      this.pop_overs();
      this.set_option_price_text();
      this.injectHiddenSwatchesDiv();
      this.showViewMore();
      this.setEDDZipCode();
      if(COSTCO.util.checkElementById('#liveChatEnabled', 'true')){
    	  this.enableChatFeature();
      }
      this.scrollToElementOnPdpWithOffset();
      
      if ($('#liveEDD').length > 0 && $('#liveEDD').val() === 'true') {
    	COSTCO.Product.eddMutationObserverState = Product.eddObserver.state.STOPPED;
    	if($('#backOrdered').val() !== 'true') {
		    COSTCO.Product.eddFormDisplayed = true;
		}
        $('#minQtyText').bind("change", function() {
          if (COSTCO.Product.eddFormDisplayed === false && $.cookie('invCheckPostalCode') != null  ) {
            COSTCO.Product.retrieveEDD();
          }
        });
      }
      $('#minQtyText').bind("click", function() {
    	  $('#minQtyText').focus();
  		});
      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
    	  this.pdpMakeElementSticky();
    	  if ( COSTCO.Product.item_type == 'bundle' ) {
    		  this.bundlePageReload();
    		  this.bundle_backorder_check();
    	  }
    	  this.initializeAdaForTabPanel();
    	  this.makeTextNonClicableForSR();
    	  this.initShippingStatementPopover();
      }
      
      document.addEventListener("CostcoSubModulesLoaded", COSTCO.Product.startMutationObserver, false);

      /** INC6205314 - Below code will resize the PDP Review tab content after the BV call back. */
      window.bvCallback = function (BV) {
    	  BV.configure('global', {
			  events : {
				  bvRender : function (data) {
					  // JavaScript code that executes when the Bazaarvoice application renders.
					  COSTCO.Product.showViewMore();
				  }
			  }
    	  });
      };
	  
      // Binding for Success Notification element Close Icon
      $('#product-page').on(
				'click',
				'.success-notification .co-close',
				function(event) {
					$('#product-page .success-notification').remove();
				});	
      this.makeSocialIconsAdaCompliant();

      COSTCO.Product.setShareButtonWidth();
      COSTCO.Product.startProductActionV2MutationObserver();
      COSTCO.Product.startVendorActionV2MutationObserver();
      var ctaEspotAttr = $('.product-cta-espot div').attr('data-bi-placement');
      if (!(typeof ctaEspotAttr !== typeof undefined && ctaEspotAttr !== false)) {
    	  $('.product-cta-espot').addClass("hide");
      }
      $('.unit-content').unbind().on('click', function(e) {
        $('#minQtyText').focus();
      });
      let sessionStorageDataModal = sessionStorage.getItem('AddedToCartModalData');
      if (sessionStorageDataModal && sessionStorageDataModal != null) {
    	  this.invokeAddedToCartModalData(sessionStorageDataModal);
      }
      
      $('#mattress-statement').hide();
      
      COSTCO.Product.toggleDeliveryMoleculeOnComingSoon();
      
      $(window).on('load', function() {
		  COSTCO.Product.unsetBreadcrumbPadding();
    	  
    	  $( '.lcrelatedvideos-e2' ).each(function () {
    		    this.style.setProperty( 'margin-left', '0px', 'important' );
    		});
    	  try{
    		  COSTCO.Product.mobileSharePdp();
    	  }catch(e){}
    	  //3 level item variants
    	  if(!COSTCO.CMath.iskitsbundle){
    	  for(var i = $('.varis[data-product=0]').length-1; i > 0 ; i--) {
    		  if ($('#swatches-productOption0'+i+' .selection-box-v2 input:disabled').length > 0) {
        		  let firstSelectedVariant  = $('#swatches-productOption0'+i+' .selection-box-v2 input:not(:disabled)')[0];

        		  $('#productOption0'+i).val($(firstSelectedVariant).val());
        		  $('#productOption0'+i).change(); 
        	  }
    	  }
    	  if ($('#swatches-productOption00 .selection-box-v2 input:disabled').length > 0) {
  			let firstSelectedVariant  = $('#swatches-productOption00 .selection-box-v2 input:not(:disabled)')[0];

  			$('#productOption00').val($(firstSelectedVariant).val());
  			$('#productOption00').change();  
  			
  		  } else if ($('.varis-v2').length > 0) { 
  			let selectedOptionSpanText = $('.selectedOptionValue').text().trim();
  			let selectedOptionDropdownText = $('.varis-v2').find(":selected").text().trim();

  			if (selectedOptionSpanText != selectedOptionDropdownText) {
  				$('.varis-v2 option').filter(function() {
  				return $(this).text() == selectedOptionSpanText;
  				}).prop('selected', true);

  				let selectedOptionValue = $('.varis-v2').find(":selected").val();
  				$('.varis').find('option[value=' + selectedOptionValue + ']').prop('selected', true);
  				$('#productOption00').change();
  				}
  			}
      	}
		});
		
		//SFSTRY0014266 - SOK iFrame analytics change
		if($('ul#tablist a#reqConsultTab').length > 0 && typeof digitalDataEvents !== 'undefined'){
			digitalDataEvents.push({update:{product:{inventoryStatus:"Request Consultation"}}});
		}
    },
    	
    hide_writereview: function() {
    	if(COSTCO.CMath.iskitsbundle){
    		var targetObject = (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) ? $('#product-info')[0] : $('#accordion-product-details')[0];
    		var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
    			mutationRecordsList.forEach(function(mutation) {
    				if ("childList" === mutation.type && $(mutation.target).find('.bv-content-list-container').length > 0) {
    					$('.bv-submission-button').removeClass("bv-write-review");
    	                $('.bv-submission-button').removeClass("bv-first-to-review");
    	                $('.bv-submission-button').html("");
    	                $('.bv-action-bar').html("");
    	                $('.bv-action-bar').removeClass("bv-action-bar");
    				}
    			});
    	    });
    		observerObject.observe(targetObject, {attributes: true,attributeOldValue: true,
    			childList: true,
    			subtree: true,
    			characterData: true
    		});
    	}
    },
    	
	unsetBreadcrumbPadding: function() {
		$('#crumbs_ul > div').css('padding', 'unset');
	},
    
    mobileSharePdp: function(){
    	try{

    		if(typeof Android != 'undefined' 
    			&& typeof Android.onSharePopup != 'undefined') {
				$("#pdp-share-android-native").show();
				$(".social-share").hide();
				$("#pdp-share-android-native").unbind("click").bind( "click", function() {
					Android.onSharePopup($(document).attr('title'), window.location.href);
				});

			}else if(typeof webkit != 'undefined' 
						&& typeof  webkit.messageHandlers != 'undefined' 
						&& typeof  webkit.messageHandlers.onSharePopup != 'undefined' 
						&& typeof  webkit.messageHandlers.onSharePopup.postMessage != 'undefined') {				

				$("#pdp-share-ios-native").show();
				$(".social-share").hide();
				$("#pdp-share-ios-native").unbind("click").bind( "click", function() {
					webkit.messageHandlers.onSharePopup.postMessage(window.location.href);
				});
				
				//iOS behaves strange, it needs timeout to run async
	    		setTimeout(function() { 
					if($("#pdp-share-ios-native").is(":hidden") && $("#pdp-share-android-native").is(":hidden")){
	    				$(".social-share").show();
	    			}			
			 	}, 1000);
				
			}
    		


    	}catch(e){
			$("#pdp-share-android-native").hide();
			$("#pdp-share-ios-native").hide();
			$(".social-share").show();
		}
    	
    },

    eddObserver: {
      state: {
        STARTED: 'STARTED',
        STOPPED: 'STOPPED'
      },
      observer: null
    },
    
    productActionV2Observer: {
      state: {
        STARTED: 'STARTED',
        STOPPED: 'STOPPED'
      },
      observer: null
    },

    productActionV2ObserverState: '',
    
    vendorActionV2Observer: {
      state: {
        STARTED: 'STARTED',
        STOPPED: 'STOPPED'
      },
      observer: null
    },
    
    vendorActionV2ObserverState: '',

    eddMutationObserverState: '',

    eddFormDisplayed: '',

    displayEDDForm: true,
    
    sortVariantOptions: false,
    
    sortVariantOptions_V2: false,
    

    /**
     * Function used to watch for changes of catEntryId, calling retrieveEDD in case of observing
    */
    startEDDMutationObserver: function() {
      let targetObject = $('#ProductForm #catEntryId');
        if (targetObject.length > 0 && this.displayEDDForm === true){
          targetObject = targetObject[0];
          let observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
            mutationRecordsList.forEach(function(mutation) {
              if ("attributes" === mutation.type) {
                COSTCO.Product.showEddForm();
              }
            });
          });
          // Register the target node to observe and specify which DOM changes to watch
          observerObject.observe(targetObject, {
            attributes: true,
          });

          this.eddObserver.observer = observerObject;

        }
        COSTCO.Product.eddMutationObserverState = Product.eddObserver.state.STARTED;
    },
    
    /**
     * Function used to watch for changes of #ctas content, calling changeContentOfExternalButton in case of observing change in first loop
    */
    startVendorActionV2MutationObserver: function() {
      let targetObject = $('#ctas');
      if (targetObject.length > 0) {
        targetObject = targetObject[0];
        let observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
          mutationRecordsList.forEach(function(mutation) {
            if ("childList" === mutation.type && COSTCO.Product.vendorActionV2ObserverState !== 'STOPPED') {
              if ($('#ctas ul li a').length) {
                COSTCO.Product.changeContentOfExternalButton();
              }
              COSTCO.Product.vendorActionV2ObserverState = Product.vendorActionV2Observer.state.STOPPED;
            }
          });
        });
        // Register the target node to observe and specify which DOM changes to watch
        observerObject.observe(targetObject, {
          childList: true,
          subtree: true,
        });
        this.vendorActionV2Observer.observer = observerObject;
      }
      COSTCO.Product.vendorActionV2ObserverState = Product.vendorActionV2Observer.state.STARTED;
    },

    /**
     * Function used to watch for changes of #mr-registry-container content, calling setShareButtonWidth in case of observing
    */
    startProductActionV2MutationObserver: function() {
      let targetObject = $('#mr-registry-container');
        if (targetObject.length > 0) {
          targetObject = targetObject[0];
          let observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
            mutationRecordsList.forEach(function(mutation) {
            if ("childList" === mutation.type) {
                COSTCO.Product.setShareButtonWidth();
                COSTCO.Product.makeGiftRegistryAdaCompliant();
                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.item_type == 'bundle' ) {
              	  COSTCO.Product.arrangeBundleButtons();
                }
              }
            });
          });
          // Register the target node to observe and specify which DOM changes to watch
          observerObject.observe(targetObject, {
            childList: true, 
          });
          this.productActionV2Observer.observer = observerObject;
        }
        productActionV2ObserverState = Product.productActionV2Observer.state.STARTED;
    },
    
    /**
     * Mask quantity input field for PDP page
     */
    maskQuantityInput: function() {
    	$("input[name*='quantity']").unmask().mask(COSTCO.util.isBusinessDelivery() ? '0000' : '000');
    },

    /**
     * Function used to change state eddMutationObserverState and disconnect observer in case of showing edd form.
    */
    stopEDDMutationObserver: function() {

    	COSTCO.Product.eddMutationObserverState = Product.eddObserver.state.STOPPED;
      if(!typeof(this.eddObserver.observer) === "undefined"){
    	  this.eddObserver.observer.disconnect();
      }

      
    },
    	
    
    /**
     * Function used to show Live Chat Us feature on the PDP page
    */
    enableChatFeature: function() {
    	if('BC'=== $('#applicationType').val() && $("input[name='productBeanId']").length>0 ){
    		/* Get Catentry Id and partnumber of the Product */ 
    		var catentryid=$( "input[name='productBeanId']" ).val();
    		var partnumber=$("input[name='productPartnumber']").val();
    		if (!(typeof catentryid === "undefined")) {
    			
    			COSTCO.util.ajax({
					url: '/AjaxGetChatDetails',
					method: 'GET',
    				dataType: 'json',
    				data: {
    					productId: catentryid,
    					signedIn:COSTCO.util.getMemberCookie().signedIn,
    					hostname:window.location.protocol+"//"+window.location.hostname,
    					partnumber:partnumber
    				},
    				done: function(data, textStatus, jqXHR, options) {
    					if (data.errorMessageKey) {
    					    console.log('Error Occured ' + data.errorMessage);
    					} else if (data.showChatURL) {
    			    		var windowHeight = window.innerHeight;
	 			    	    var feedbackWidth = $('button.chat-button').width()+10;/* 10px spacing between feedback and chat */
	 			    	    var feedbackConverted = (feedbackWidth*100)/windowHeight;
	 			    	    var finalHeight = 49+feedbackConverted; /* 49 top of feedback button */ 
	 			    	    $('button.chat-button').css('top',finalHeight+"%")
    			    		var chatUrl = new DOMParser().parseFromString(data.chatURL, "text/html");
    			    		var finalChatUrl = chatUrl.body.textContent;
    			    		COSTCO.Product.showChatWindow(finalChatUrl);
    					} else{
    					    var chatButton = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? 'button.chat-button-v2' : 'button.chat-button';
    					    $(chatButton).addClass('hidden');
    					}
    				},fail: function(data) {
    					console.log('Unexpected Error Occured');
    				}		        
    			});
    			       			
    		}}		   	
      }, 
      /**
       * This method is used to render a new Chat Window and load the Chat Us Link
       */
      showChatWindow: function(customURL) {
    	var liveChatButton;
    	if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
			liveChatButton ='button.chat-button-v2';
		} else {
			liveChatButton = 'button.chat-button';
		}
  		$(liveChatButton).click(function(event) {
  			/**
  			 * If chat window already open then focus existing one
  			 * else open new window
  			 */
  			if(customURL.length>0){
  				if(COSTCO.Product.chatWindow != undefined && !COSTCO.Product.chatWindow.closed)
				{
					COSTCO.Product.chatWindow.focus();
				}
				else{
  	        	var chatWindowWidth=320;
  	        	var chatWindowHeight=800;
  	        	var left = $(window).width()-chatWindowWidth;
	  	        	COSTCO.Product.chatWindow = window.open(customURL,'chatWindow','width='+chatWindowWidth+',height='+chatWindowHeight+',scrollbars=1,top=0,left='+left);
	  	        	COSTCO.Product.chatWindow.moveTo(left, 0);
	  	        	COSTCO.Product.chatWindow.focus();
  			}
  			}
		});
      },
    
    /**
     * Setting width for button share on pdp
     * @return void
     */
    setShareButtonWidth: function() {
      if ($('#add-to-list').html() == undefined && ($('#mr-registry-container').html() == undefined || $('#mr-registry-container').html().contents == undefined)) {
            $('#mr-registry-container').remove(); //remove container if it is empty
        $('#product-social-print-mobile').css('width', '100%');
      }
    },
    
    /**
     * Changing content of external button
     * @return void
     */
    changeContentOfExternalButton: function() {
      let selector = $('div#ctas').find('a').children('input.primary').length ? $('div#ctas').find('a').children('input.primary') : $('div#ctas').find('a.external').children('span');
      if (selector.length > 0 && selector.text() !== messages.RWD_VENDOR_CTA_BUTTON_TEXT_ORDER_HERE) {
        if (selector.is('span')) {
          selector.text(messages.RWD_VENDOR_CTA_BUTTON_TEXT);
        } else {
          selector.val(messages.RWD_VENDOR_CTA_BUTTON_TEXT);
        }
      }
      COSTCO.Product.vendorActionV2ObserverState = Product.vendorActionV2Observer.state.STOPPED;
    },
    /**
     * Update the EDD zip code based on the current zip code cookie value.
     */
    setEDDZipCode: function() {
    	$("#eddZipCodeField").val($.cookie('invCheckPostalCode'));
    },
    
    /**
     * change prive from base 64 to a decimal value
     */
    processPrice: function(value) {
      value = typeof value !== 'undefined' && value != null ?
        value : "";
      value = typeof value == "string" ?
        COSTCO.util.base64test.test(value) ?
        COSTCO.util.decode(value) :
        value :
        value
      if ($.type(value) === 'string') {
        value = value.split(',').join('');
      }
      return this.parseCurrency(value);
    },
    /**
     * round a number down to 2 decimal places
     */
    parseCurrency: function(num) {
      if (typeof num == "number") {
        num = num.toString();
      }
      num = parseFloat(Math.round(num.replace(/\s/g, '') * 100) / 100)
        .toFixed(2).toLocaleString();
      return num;
    },
    focusToNavPdpTabHeader1() {
    	$("#nav-pdp-tab-header-1").attr("tabindex",-1).focus();
    },
    focusToNavPdpTabHeader2() {
    	$("#nav-pdp-tab-header-2").attr("tabindex",-1).focus();
    },
    focusToNavPdpTabHeader3() {
    	$("#nav-pdp-tab-header-3").attr("tabindex",-1).focus();
    },
    focusToNavPdpTabHeader4() {
    	$("#nav-pdp-tab-header-4").attr("tabindex",-1).focus();
    },
    focusToNavPdpTabHeader5() {
    	$("#nav-pdp-tab-header-5").attr("tabindex",-1).focus();
    },
    focusToNavPdpTabHeader6() {
    	$("#nav-pdp-tab-header-6").attr("tabindex",-1).focus();
    },
    focusToNavPdpTabHeader7() {
    	$("#nav-pdp-tab-header-7").attr("tabindex",-1).focus();
    },
    focusToNavPdpTabHeader8() {
    	$("#nav-pdp-tab-header-8").attr("tabindex",-1).focus();
    },
    focusToNavPdpTabHeader9() {
    	$("#nav-pdp-tab-header-9").attr("tabindex",-1).focus();
    },    
    focusToNavPdpTabHeader10() {
    	$("#nav-pdp-tab-header-10").attr("tabindex",-1).focus();
    },
    focusToNavPdpTabHeader11() {
    	$("#nav-pdp-tab-header-11").attr("tabindex",-1).focus();
    },
    focusToNavPdpTabHeader12() {
    	$("#nav-pdp-tab-header-12").attr("tabindex",-1).focus();
    },
    focusToNavPdpTabHeader13() {
    	$("#nav-pdp-tab-header-13").attr("tabindex",-1).focus();
    },focusToNavPdpTabHeader14(){
    	$('html, body').scrollToElem($('.bottom-content'), 500);
    	setTimeout(function() {
    		$('#tablist li').removeClass('active');
        	$('.tab-content div').removeClass('active in');
        	$('#tab-header-bundle').addClass('active');
        	$('.build-bundle-tab').addClass('active in');
    	}, 500);
    	$("#buildabundleTitle").attr("tabindex",-1).focus();
    },
    focusToNavPdpTabHeader15() {
    	$("#selectedKbOffScreenSwatch").attr("tabindex",-1).focus();
    },
    formatMoney: function(number, has_symbol) {
      var number = number.toString(),
        dollars = number.split('.')[0],
        cents = (number.split('.')[1] || '') + '00';
      dollars = dollars.split('').reverse().join('')
        .replace(/(\d{3}(?!$))/g, '$1,')
        .split('').reverse().join(''),
        symbol = has_symbol ? '$' : "";
      var locale = COSTCO.util.getLocale();
      var appType = $('#applicationType').val();
      
      if (locale == 'fr-CA' && appType=='BD') {
        return dollars.split(",").join(" ") + ',' + cents.slice(0, 2) + ' ' + symbol;
      }else if(locale == 'fr-CA' && appType=='BC') {
    	return dollars.split(",").join(" ") + ',' + cents.slice(0, 2) + symbol;
      }
      
      return symbol + dollars + '.' + cents.slice(0, 2);
    },
    /**
     * This function iterates through every variant on a product page and sorts
     * its option, first by sequence, then price (if single variant) else alphabetically.
     * @return {[type]} [description]
     */
    sort_variant_options: function() {
      $('.variantContainer').each(function(i, vContainer) {
        $(vContainer).find('select.varis').each(function(j, select) {
          var $options = $(select).find('option:not([value=unselected])'),
            product_num = $(select).data('product');
          if(!COSTCO.CMath.iskitsbundle){
        	  $options.detach().sort(function(option_a, option_b) {
        	  
            var seq_a = parseFloat(this.get_item_sequence(option_a.value, product_num)),
              seq_b = parseFloat(this.get_item_sequence(option_b.value, product_num));
            if (seq_a == seq_b) { // Same sequences, try sorting by price
              var item_a = this.findItem(products[product_num], this.get_selected_array($(option_a))),
                item_b = this.findItem(products[product_num], this.get_selected_array($(option_b)));
              if (item_a && item_b) {
                var price_a = parseFloat(COSTCO.util.decode(item_a.price).split(',').join('')),
                  price_b = parseFloat(COSTCO.util.decode(item_b.price).split(',').join(''));
                return price_b - price_a
              } else {
                return option_a.text.toLowerCase() > option_b.text.toLowerCase() ? 1 : -1
              }
            } else {
              return seq_a > seq_b ? 1 : -1
            }
          }.bind(this));
        	  $options.removeAttr("selected");
              $options.appendTo(select);
          }
          
          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
        	  this.displayVarianceView(select); 
        	  if($(vContainer).find('select.varis').length == j+1) {
        	  		COSTCO.Product.sortVariantOptions_V2 = true;
        	  		var preselectOption = COSTCO.util.getParameterByName('preselectOption');
        	  		if (typeof preselectOption !== 'undefined' && preselectOption != null) {
        	  			COSTCO.CMath.bindVariantProducts('',preselectOption);
        	  		}else{
        	  			COSTCO.CMath.bindVariantProducts();
        	  		}
        	  }
        	  
          } else {
        	  if($(vContainer).find('select.varis').length == j+1) {
        	  	COSTCO.Product.sortVariantOptions = true;
          	  }
        	  COSTCO.CMath.bindVariantProducts();
          }
          
          
        }.bind(this));
      }.bind(this));
    },
    
    sort_secondary_variant_options : function (selectedVariant) {
    	$('.variantContainer').find('select.varis').each(function(j, select) {
    		if($(select).attr('id') !== $(selectedVariant).attr('id')){
    			var $options = $(select).find('option:not([value=unselected])'),
                product_num = $(select).data('product');
    			var selectedOptionVal = $(select).find('option:selected').val();
    			$options.detach().sort(function(option_a, option_b) {
    	            var seq_a = parseFloat(COSTCO.Product.get_item_sequence_selectVariant(option_a.value, $(selectedVariant).val(),  product_num)),
    	              seq_b = parseFloat(COSTCO.Product.get_item_sequence_selectVariant(option_b.value, $(selectedVariant).val(),  product_num));
    	            
    	            if(isNaN(seq_a)){
    	            	seq_a = 0;
    	            } else if (isNaN(seq_b)){
    	            	seq_b = 0;
    	            }
    	            if (seq_a == seq_b) { // Same sequences, try sorting by price
    	              var item_a = COSTCO.Product.findItem(products[product_num], COSTCO.Product.get_selected_array($(option_a))),
    	                item_b = COSTCO.Product.findItem(products[product_num], COSTCO.Product.get_selected_array($(option_b)));
    	              if (item_a && item_b) {
    	                var price_a = parseFloat(COSTCO.util.decode(item_a.price).split(',').join('')),
    	                  price_b = parseFloat(COSTCO.util.decode(item_b.price).split(',').join(''));
    	                return price_b - price_a
    	              } else {
    	                return option_a.text.toLowerCase() > option_b.text.toLowerCase() ? 1 : -1
    	              }
    	            } else {
    	              return seq_a > seq_b ? 1 : -1
    	            }
    	          }.bind(this));
    	    	
    	    	$options.removeAttr("selected");
    	        $options.appendTo(select);
    	        let rePrintSortedTiles ='<legend id="variantLegend-productOption0'+j+'" class="sr-only">'+$(select).closest('.vari').find('label').text() +'</legend>';
    	        $options.each(function(i, option) {
      	      	  	let optionValue = $(option).text();
      	      	  	if($(option).val() === selectedOptionVal){
      	      	  		$(option).prop('selected', true)
      	      	  	}
      	      	  	var templateName;
      	      	if(COSTCO.CMath.iskitsbundle){
      	      		templateName = 'tmpl_KB_product_variants_v2';
      	      	}else{
      	      		templateName = 'tmpl_product_variants_v2';
      	      	}
      	      rePrintSortedTiles += COSTCO.util.tmpl(templateName, {
				  inputName: $(select).prop('name'),
				  inputValue: $(option).val(),
				  variantName: optionValue,
				  disabled: $(select).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? 'disabled' : '',
				  tabindex: $(select).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? '-1' : '0',
				  checkedValue: $(option).is(':selected')? 'checked' : '',
				  ariaChecked: $(option).is(':selected')? 'true' : 'false'
			  });
    	        });
    	        let sortedVariantFieldset =  $('#swatches-'+$(select).prop('name')).find('fieldset label.variant-v2').parent();
    	        sortedVariantFieldset.html('');
    	        sortedVariantFieldset.html(rePrintSortedTiles);
    	        
    	        $('#swatches-' + $(select).prop('name') + ' label.selection-box-v2').on('click keypress',(function() {
					$('#isPriceCallInvokedForPickup').val('false');
    	            let radioValue = $(this).find('input').val();
    	            $('#' + $(select).prop('name')).val(radioValue);
    	            $('#' + $(select).prop('name')).trigger('change.vari');
    	            $(this).find('input').each(function() {
    	              $(this).prop('checked', 'false');
    	            });
    	            $(this).find('input').prop('checked','true');
    	           }));
				   
    		}
    	}.bind(this));
    	
    	
    },
    
    /**
     * Generate variance view for a PDP Redesign page
     * @param selectVariant variant selection to generate view from
     * @return void
     */
    displayVarianceView: function(selectVariant) {	
    	let tileHtml = '';
    	let variantLabelHtml  = '';
    	let selectVariantName = $(selectVariant).prop('name');
    	let selectVariantOptions = $(selectVariant).find('option:not([value=unselected])');
    	let variantSelected = $(selectVariant).find('option:selected').hasClass('opt');
    	let isBundle = $('.bundleQty').length > 0;
    	let variantLabelText = $(selectVariant).closest('.vari').find('label').text().trim();
     	var templateName;
    	if(COSTCO.CMath.iskitsbundle){
    		templateName = 'tmpl_KB_product_variants_v2_label';
    		
    	}else{
    		templateName = 'tmpl_product_variants_v2_label';
    	}

		variantLabelHtml += COSTCO.util.tmpl(templateName, {
  		  selectedOptionKey: variantLabelText,
  		  optionId: $(selectVariant).attr('id')
		});
    	
    	if ($(selectVariant).parents('.vari').is('.swatchDropdown[data-swatch-mode=2]')) {
    		if(COSTCO.CMath.iskitsbundle){
    			let theSwatchesCloned =  $('#theKBSwatches').clone(true);
    			$('#theKBSwatches').remove();
    			let $labelForSwatches = $('label[for="theKBSwatches"]');
    			$labelForSwatches.removeClass('hide');
    			$labelForSwatches.after(theSwatchesCloned);
    			$('#theKBSwatches').removeClass('hide');
    		}else{
    			let theSwatchesCloned =  $('#theSwatches').clone(true);
    			$('#theSwatches').remove();
    			$('#pdpSwatches').remove();
    			let $labelForSwatches = $('label[for="theSwatches"]');
    			$labelForSwatches.removeClass('hide');
    			$labelForSwatches.after(theSwatchesCloned);

    			let $labelForPdpSwatches = $('label[for="pdpSwatches"]');
    			$labelForPdpSwatches.removeClass('hide'); 
    			$labelForPdpSwatches.after(theSwatchesCloned);

    		}
			
		
    	} else if (numberOfOptionsToDisplayAsTiles && selectVariantOptions.length < numberOfOptionsToDisplayAsTiles && !isBundle) {
		
    		selectVariantOptions.each(function(i, option) {
    	      	  let optionValue = $(option).text();
    	      	  if(COSTCO.CMath.iskitsbundle){
    	      		  tileHtml += COSTCO.util.tmpl('tmpl_KB_product_variants_v2', {
    					  inputName: selectVariantName,
    					  inputValue: $(option).val(),
    					  variantName: optionValue,
    					  disabled: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? 'disabled' : '',
    					  tabindex: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? '-1' : '0',
    					  checkedValue: $(option).is(':selected')? 'checked' : '',
    					  ariaChecked: $(option).is(':selected')? 'true' : 'false',
    					  i: i+1
    				  });
    	      	  }else{
    	      		  tileHtml += COSTCO.util.tmpl('tmpl_product_variants_v2', {
    					  inputName: selectVariantName,
    					  inputValue: $(option).val(),
    					  variantName: optionValue,
    					  disabled: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? 'disabled' : '',
    					  tabindex: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? '-1' : '0',
    					  checkedValue: $(option).is(':selected')? 'checked' : '',
    					  ariaChecked: $(option).is(':selected')? 'true' : 'false'
    				  });
    	      	  }
				
    		});
    		var templateName;
    		if(COSTCO.CMath.iskitsbundle){
    			templateName = 'tmpl_KB_product_variants_v2_row';
    			
    		}else{
    			templateName = 'tmpl_product_variants_v2_row';
    		}
    		$('#product-details').append(COSTCO.util.tmpl(templateName, {
	        	swatchesId: selectVariantName,
	        	tileDisplay: tileHtml,
	        	variantLabel: variantLabelHtml,
	        	selectedOptionKey: $(selectVariant).closest('.vari').find('label').text()
	        	
	        }));

    		if (variantSelected) {
        		COSTCO.CMath.update_selected_option_label($(selectVariant).find('option:selected').val());
        	}

			$('#swatches-' + selectVariantName + ' input[type=radio]').change(function() {
		        let radioValue = $(this).val();
		        $('#' + selectVariantName).val(radioValue);
		        $('#isPriceCallInvokedForPickup').val('false');
		        if(selectVariantName === 'productOption00'){
		        	COSTCO.Product.sort_secondary_variant_options($(selectVariant));
		        }
		        if(COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete){
    				//Following code for reload page if user is clicking dropdown
					COSTCO.CMath.redirectPDP();
		        }else{
		        	$('#' + selectVariantName).trigger('change.vari');
		        }
		    });
	       
		  if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
        $('#swatches-' + selectVariantName + ' label.selection-box-v2').on('keypress',(function() {
		  $('#isPriceCallInvokedForPickup').val('false');
          let radioValue = $(this).find('input').val();
          $('#' + selectVariantName).val(radioValue);
          $('#' + selectVariantName).trigger('change.vari');
		  $(this).find('input').each(function() {
			$(this).prop('checked', 'false');
		  });
		  $(this).find('input').prop('checked','true');
         }));
        };
           	
    	} else {
 
    		let styleSelect = $(selectVariant).parent('.style-select');
    		if (!isBundle) {
    			$('#product-details').append(variantLabelHtml);
    		}
    		if($('#isBDAppVar').val() != 'BD' && isPDPVariantGreyOutEnabled == 'true' ){
			let dropdownSkeleton = '<div class="style-select form-group dropdown-skeleton-'+selectVariantName+'" id="PDP-dropdown-skeleton"> <select class="dropdown-skeleton-load loading" disabled></select></div>';
			$('#product-details').append(dropdownSkeleton);
			$('[name='+selectVariantName+']').hide();
    		}
    		let styleSelectCloned = styleSelect.clone();
    		let optionsCloned = styleSelectCloned.find('.varis');
    		optionsCloned.removeAttr('id');
    		optionsCloned.addClass('varis-v2');
    		optionsCloned.removeClass('varis');
    		optionsCloned.attr('autocomplete', 'off');
    		optionsCloned.attr('aria-label', variantLabelText);
    		
    		$('#product-details').append(styleSelectCloned);
    		
    		if (isBundle) {
    			styleSelectCloned.hide();
    			let bundleArr = document.getElementsByClassName('bundle-info-container');
    			let varArr = document.getElementsByClassName('varis-v2');
    			for (var i = 0; i < bundleArr.length; i++) {
    				if (varArr[i]!= undefined) {
    					varArr[i].id="cloned"+varArr[i].name;
    					varArr[i].classList.add("cloned");
    					//Append select to the bundle container
    					for (var a = 0; a < bundleArr.length; a++) {
    	 					if(varArr[i].dataset.product == bundleArr[a].dataset.product && !bundleArr[a].classList.contains("input-field-v2")) {
    	 						bundleArr[a].classList.add("input-field-v2");
    		                    bundleArr[a].appendChild(varArr[i]);
        					}    					
    	 				}
    				}
    			}
    			let clonedVarArr = document.getElementsByClassName('cloned');
    			let varianceLabel = $(selectVariant).closest('.vari').find('label').text();
				for (let i = 0; i < clonedVarArr.length; i++) {
				  if ($('label[for="'+clonedVarArr[i].id+'"]').length === 0) {
					this.add_label_to_variance_select(clonedVarArr[i], varianceLabel);
				    $('#' + clonedVarArr[i].id).change(function () {
				      var labels = $("label[for='" + this.id + "']");
				      var selectedValue = $(this).children("option:selected").val();
					  var item;
					  var p = products[$(this).data('product')];
					  labels.removeClass("label-outline-error");
					  labels.filter('.error').hide();
			    	  $(this).removeClass("error-in-bundle");
					  for (var i = 0; i < p.length; i++) {
					    if ($(this).val() == p[i].options || $(this).val() == p[i].catentry) {
						  item = p[i];
						 }
					  }    
					  if (item) {
					    let catentryid = item.catentry;
						let opPrice = COSTCO.util.decode($('.online-price[data-catentry=' + catentryid + ']').data('opvalue'));
						let container = this.parentElement.parentElement;
						let bundle = container.parentElement;
						let checkbox = $(bundle).find('input:checkbox');
						let isBackordered = false;
						let varianceBackorderMessage = null;
						$(container).find('.price').find('span').text(COSTCO.Product.formatMoney(opPrice,true));
						$(bundle).parent().find('#backorder-message').remove();
						products.forEach(function (product, index){
							products[index].forEach(function (pro, ind){
					    		if(selectedValue === pro.options[0]){
					    			if(pro.inventory === "BACK_ORDER"){
					    				isBackordered = true;
					    				if (typeof pro.backorderMessage !== "undefined" && pro.backorderMessage != null){
							            	$(bundle).parent().append($('<div id="backorder-message" class="warning"></div>').text(pro.backorderMessage)); 
							            	varianceBackorderMessage = pro.backorderMessage;
						            	} else{
							            	$(bundle).parent().append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
							            	varianceBackorderMessage = messages.BACKORDER_TEXT_MSG5;
						            	}
					    			 }
					    		 }				 
							});		
						});
						if ($(checkbox).is(':checked')) {
							  $('#' + selectVariantName).val(selectedValue);
							  $('#' + selectVariantName).trigger('change.vari');
							  COSTCO.Product.changeBundleItemVarianceValue($(this).data('product')+1,varianceLabel.trim(),$(this).children("option:selected").text(),opPrice,isBackordered,varianceBackorderMessage);
						} 
					  } else if (selectedValue == "unselected") {
					    let container = this.parentElement.parentElement;
						let bundle = container.parentElement;
						let checkbox = $(bundle).find('input:checkbox');
						if ($(checkbox).is(':checked')) {
						  $('#' + selectVariantName).val(selectedValue);
						  $('#' + selectVariantName).trigger('change.vari');
						  $(container).find('.price').find('span').text('');
						  $(checkbox).click();
						}
					 } 	  				    
				  });
			    }
				$('#' + clonedVarArr[i].id).trigger('change');
		      }
			  if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE)	{
				styleSelectCloned.show();
			  }
	    		this.add_ellipsis_to_variance_select();	 
    		}
    		
    		styleSelectCloned.find('.varis-v2').change(function(event) {
    			var selectedOptionValue = $(event.target).find('option:selected').val();
    			$('.varis').find('option[value=' + selectedOptionValue + ']').prop('selected', true);
    			if(COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete ){
    				//Following code for reload page if user is clicking dropdown
					COSTCO.CMath.redirectPDP();
    			}else{
    				$('#' + selectVariantName).trigger('change.vari');
    			}
    			
    		});
    	}	
        $(selectVariant).parents('#variants').addClass('visually-hidden');
    },
    
    /**
     * Check if bundle option is backordered
     */
    bundle_backorder_check: function() {
    	$('#backorder-message').hide();
    	var containers = $('.variantContainer');
    	var bundleProducts = $('.bundle-product')
    	$(bundleProducts).find('#backorder-message').remove();
    	products.forEach(function (product, index){
    	if ($(containers[index]).find('select').length) {
    		//Single item with one select box
    		selectedValue = $(containers[index]).find('select > option:selected').val();
    		if(selectedValue === products[index][0].options[0]){
    			if(products[index][0].inventory === "BACK_ORDER"){
    				if (typeof products[index][0].backorderMessage !== "undefined"){
		            	$(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(products[index][0].backorderMessage));
	            	} else{
		            	$(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	            	}
    			 }
    		 }
    	}else if (parseInt($(containers[index]).find('input').val()) != null) {
	            // Single item with no select box (just quantity input shown)
    			var test = $(containers[index]).find('input').val();
	            if (products[index][0].inventory === "BACK_ORDER"){
		            if(bundleProducts[index] != null){
		            	if (typeof backorderMessage !== "undefined"){
			            	$(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(backorderMessage));
		            	} else{
			            	$(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
		            	}
		            }
	            }            
	        }
    	});
    },
    
    /**
     *  Adds ellipsis to variance when text overflows select element size
     */
    add_ellipsis_to_variance_select: function(){
		 $('.varianceContainer').each(function () {
			 if($(this).find(".viewport").length === 0) {
    			 var newDiv = document.createElement("div"); 
    			 newDiv.className = "viewport"; 
    			 var innerDiv = document.createElement("div"); 
    			 innerDiv.className = "innerViewport"; 
    			 innerDiv.innerHTML =  $(this).find('select option:selected').get(0).textContent;
    			 newDiv.appendChild(innerDiv);
    			 this.insertBefore(newDiv, this.firstChild);
 	            $(this).find('select').change(function () {
	                $(this).parent().find('.innerViewport').text($("option:selected", this).text());
	            });  
			 }
		 });  		 
    },
    
    
    /**
     * Adds label and error label to cloned variance select list
     * @param  varianceArray
     * @param  varianceLabel
     */
    add_label_to_variance_select: function(varianceArray, varianceLabel) {
		let $label =  $("<label>").text(varianceLabel);
		let $errorLabel = $("<label>").text(messages.ERR_SELECT_VARIANCE+" "+ varianceLabel);
		let wrapper = document.createElement('div');
		wrapper.classList.add("varianceContainer");
		varianceArray.parentNode.insertBefore(wrapper, varianceArray);
		wrapper.appendChild(varianceArray);
		$label.attr('for',varianceArray.id);
		$label.addClass("label-outline ");
		$errorLabel.attr('for', varianceArray.id);
		$errorLabel.addClass("error");
		$errorLabel[0].style.display = "none";
	    varianceArray.parentNode.insertBefore($label[0], varianceArray.nextSibling);
	    varianceArray.parentNode.insertBefore($errorLabel[0], varianceArray.nextSibling);
    },
    
    /**
     * Gets the item sequence of a product using the option value
     * of a variant item select
     * @param  {[type]} optionVal  [description]
     * @param  {[type]} productNum [description]
     * @return {[type]}            [description]
     */
    get_item_sequence: function(optionVal, productNum) {
      var _sequence = "";
      for (var i = 0, len = products[productNum].length; i < len; i++) {
        var item = products[productNum][i];
        if (COSTCO.util.hasElem(optionVal, item.options)) {
          _sequence = item.itemSequence;
          break;
        }
      }
      return _sequence;
    },
    
    /**
     * Gets the item sequence of a product using the option value1 and option value2
     * of a variant item select
     * @param  {[type]} optionVal  [description]
     * @param  {[type]} productNum [description]
     * @return {[type]}            [description]
     */
    get_item_sequence_selectVariant: function(optionVal1, optionVal2, productNum) {
      var _sequence = "";
      for (var i = 0, len = products[productNum].length; i < len; i++) {
        var item = products[productNum][i];
        if (COSTCO.util.hasElem(optionVal1, item.options) && COSTCO.util.hasElem(optionVal2, item.options)) {
          _sequence = item.itemSequence;
          break;
        }
      }
      return _sequence;
    },


    /**
     * Validates EDD zip code format. Returns true if zip code format is valid.
     */
    validateZipCode: function(form) {
    	
    	if ($('#edd-form').find('.edd-error').length > 0) {
		    $('#edd-form').find('.edd-error').empty();        
      }
      $.validator.addMethod("countrySpecificZipcode",
        function(value, element) {
          if (wcs.storeId == '10301')
            return /^(\d{5}(-\d{4})?$)$/.test($.trim(value));
          if (wcs.storeId == '10302')
            return /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/.test($.trim(value));
        },
        messages.ERR_GROCERY_INVALID_ZIP
      );

      $(form).validate({
        rules: {
          eddZipCodeField: {required: true, countrySpecificZipcode:true}
        },
        messages: {
          eddZipCodeField: "<span class=\"sr-only\">" + messages.ERROR + "</span>" + messages.ERR_GROCERY_INVALID_ZIP
        },
        errorPlacement: function(error, element) {
          error.insertAfter(element);
        },
        highlight: function(element, errorClass, validClass) {
    			$(element).addClass(errorClass).removeClass(validClass);
    			let enterZipMessageId = $('[id^=enterZipMessage]')[0].id;
    			$(element).attr("aria-describedby", enterZipMessageId);
    	},
        unhighlight: COSTCO.util.unhighlightWithErrorLabel
      });

      return $(form).valid();
    },
    
    /**
     * Function to validate delivery zip code
     * 2 validation will be done
     * 	 1. Standard form validation postal regex and required
     *   2. Pass the zipcode to bing to also lookup country and state
     *   	which we will pass to the command to valid zipcode
     */
    validateRefreshEDDZipCode: function(element){
    	 event.preventDefault();
         let form = event.currentTarget;
         
    	if (COSTCO.Product.validateZipCode(form)) {
	  	  	if(typeof document.getElementById("isEDDNonNarvarFlow") !== "undefined" && document.getElementById("isEDDNonNarvarFlow") !== null)
			{
	  	  		document.getElementById("isEDDNonNarvarFlow").value=true;
			}
	  	  let deliveryFormZipCode =null;
	  	  	if(wcs.storeId === '10302')
	  	  		{
	  	  			if($('#eddZipCodeField') !== undefined && $('#eddZipCodeField') !== null)
	  	  				{
	  	  					 deliveryFormZipCode = $('#eddZipCodeField').val().toUpperCase();
	  	  				}
	  	  		}
	  	  	else
	  	  		{
	  	  			 deliveryFormZipCode  = $(form).find("input[name=eddZipCodeField]").val().toUpperCase();
	  	  		}
	  	  
	  	  	window.wioEventBus.publish('changeDeliveryLocation', deliveryFormZipCode);
  	  	}
  	  	else
  	  		{
		  	  	let errorContainer = $('#edd-form-block').find('.edd-error');
		        errorContainer.empty();
		        errorContainer.append(messages.ERR_INVALID_ZIP);
		        errorContainer.show();
		        $('#edd-form-block').removeClass('hide');
		  	}
    },
    

    /** 
     * Validates zip code. If valid calls bing and updates cookies for: zip code, state, city.
     * Then, it invokes get edd service, and update UI with appropriate edd date or error message
     */ 
    refreshEDD: function(event) {

      event.preventDefault();
      let form = event.currentTarget;
      let serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;

      // clear errors
      if ($('#edd-form').find('.edd-error').length > 0) {
		    $('#edd-form').find('.edd-error').empty();        
      }

      if (COSTCO.Product.validateZipCode(form)) {
        let zipCode = $(form).find("input[name=eddZipCodeField]").val();
        
        if (typeof zipCode !== 'undefined') {
        	zipCode = zipCode.toUpperCase();
        }

        serviceToUpdateCookies(zipCode)
         .then(() => {
            let qty = $('#minQtyText').val();
            COSTCO.Product.callServiceAndRefreshEDD(qty, COSTCO.Product.refreshEDDServiceCallback);
         })
        .fail((data) => {
          // bing failed
          let errorContainer = $('#edd-form-block').find('.edd-error');
          errorContainer.empty();
          errorContainer.append(messages.ERR_INVALID_ZIP);
          errorContainer.show();
        });
      }
    },

    /**
     * Shows zip code form whenever change zip is clicked in EDD widget, hides previously
	 * displayed scenario, and resets the states of Add to cart button and OOS overlay
     */
    showEddForm: function() {
    	COSTCO.Product.hideEddMessagecode();
    	$('#edd-form-block').removeClass('hide');
    	$('#add-to-cart-btn').attr("disabled", true);
    	$('#add-to-cart-btn').attr("value", messages.ADDTOCART);
    	$('.oos-overlay').addClass('hide');
    	$('#eddZipCodeField').focus();
    	if (COSTCO.Product.eddMutationObserverState === Product.eddObserver.state.STARTED) {
    	  COSTCO.Product.stopEDDMutationObserver();
    	}
    	$('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
    	$('#link-membership-for-price').removeClass('primary-button-v2').addClass('secondary-button-v2');
    	
    	COSTCO.Product.eddFormDisplayed = true;
    },
    
    retrieveEDD: function() {
      let qty = $('#minQtyText').val();
	  COSTCO.Product.callServiceAndRefreshEDD(qty, COSTCO.Product.refreshEDDServiceCallback);
	  var eddStockStatusUpdateDelay =$('#eddStockStatusUpdateDelay').val();
	  //To capture EDD response for local storage stock status we need this async
	  setTimeout(function () {
	        var itemPartNumber = COSTCO.Product.getPartnumber();
	        COSTCO.Product.updateEDDStockstatusforvariant(itemPartNumber);
	        
	      }, eddStockStatusUpdateDelay);
      
    },

    callServiceAndRefreshEDD: function(quantity,callback) {
    	
    	if(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag){
			//If the product coming soon flag is true, no need to check for EDD
			return;
		}
    	if(typeof quantity !== 'undefined' && parseInt(quantity) > 0 ){
	    	$(" #edd-check-button, #eddZipCodeField").attr("disabled", true);
		    COSTCO.Product.invokeEDDServices(quantity,callback);
    	}
       },
       /**
        *  Method to invoke EDD service
       **/
	    invokeEDDServices: function invokeEDDServices(quantity,callback) {
	    	var itemPartNumber = COSTCO.Product.getPartnumber();
	    	var baseUri = $('#baseUriForEDD').val();
	    	var clientIdentifier=$('#apigeeClientIdentifierHeader').val();
			var eddConnectionTime = $('#connectionTimeOutForEDD').val();
			var smallPackConnectionTime=$('#baseUriConnectionTimeOutForSmallPack').val();
			var serviceTimeOut='';
			var costcoEnv = COSTCO.Product.validateCostcoEnv();
			var country = COSTCO.Product.getCountry();
			eddInstallationServicesJSON = {};
			COSTCO.Product.hideEddMessagecode();
			var zipCode  =  COSTCO.Product.getZipcode();
			var costcoService="restInventory";			
			var eddVendor;
			var isGroceryProduct = $('#groceryIdentifier').val();
			var eddUrl ='';
			var shipcode=$('#defaultShipCode').val();
			eddUrl = baseUri + '/' +itemPartNumber+"?destinationState="+$.cookie('invCheckStateCode')+"&destinationPostalCode="+zipCode+
	             "&destinationCountryCode="+ country+"&quantity="+ quantity+"&orderItemId="+"0"+"&shippingCodes="+shipcode+"&action=EDD";
  		         serviceTimeOut=eddConnectionTime;
			
		     const timeOutController = COSTCO.util.getTimeoutController();
		     timeOutController(serviceTimeOut, fetch(eddUrl, {
				method: 'GET',
				headers: {
                  "costco.env": costcoEnv,
                  "client-identifier" : clientIdentifier,
                  "costco.service" : costcoService
				}
				}))
			   .then(response => response.json())
			     .then(jsonResponse => {
			    	
		    	 //identify backordered or presell status from edd response to prevent edd message display in PDP
		    	 var skipEddMessage = (jsonResponse.availability=== COSTCO.util.productConstants.edd_backordered ||
		    			 					jsonResponse.availability=== COSTCO.util.productConstants.edd_presell);	
		    	 var itemNumber = jsonResponse.itemNumber;
		    	 		    	 
		    	 if($("#displaybundle").length) {
		    		 if(null !== jsonResponse.virtualBundleId && undefined !== jsonResponse.virtualBundleId){
			    		 $('#displaybundle').removeClass('hidden');
			    		 COSTCO.CMath.invokeBundleSetForPDP(jsonResponse.virtualBundleId);
	 				 } else {
	 					$('#displaybundle').addClass('hidden');
	 				 }
		    	 }
		    	 
		    	 
		    	 SKIP_EDD=skipEddMessage;
		    	 //Set estimatedDeliveryDate if shipmodeDates has valid values present
		    	 var estimatedDeliveryDate = (null!==jsonResponse.shipmodeDates && undefined!==jsonResponse.shipmodeDates && jsonResponse.shipmodeDates.length >0)?
		    			 jsonResponse.shipmodeDates[0].estimatedDeliveryDate : undefined;

			     if ($('#vendorName').length > 0 && $('#vendorName').val().toLowerCase().includes('smallpack') ) {
			    	 if(jsonResponse.itemClassification === 'SMALLPACK' && null !== estimatedDeliveryDate 
			    			 && undefined !== estimatedDeliveryDate){
			    		 COSTCO.Product.populateSmallPackEDD(estimatedDeliveryDate); 
			    		 COSTCO.Product.isEDDStatusAvailable=true;
					 } else if (skipEddMessage){
						 jsonResponse.messageCode = "EDD_BACKORDERED_PRESELL_ITEM";
						 COSTCO.Product.isEDDStatusAvailable=true;
					 } else if(undefined !== isGroceryProduct && isGroceryProduct === 'true') {
						 jsonResponse.messageCode = "EDD_SMALLPACK_GROCERY_UNAVAILABLE";
					 } else {
						 if ('ShipRestricted' === jsonResponse.fulfilledBy || COSTCO.util.productConstants.edd_shiprestricted === jsonResponse.availability) {
						 	jsonResponse.messageCode = 'MSG_CODE_POSTAL_CODE_RESTRICTED';
						 	COSTCO.Product.isEDDStatusAvailable=false;
						  } else {
							 jsonResponse.messageCode = "EDD_SMALLPACK_UNAVAILABLE";
							 COSTCO.Product.isEDDStatusAvailable=true;
						 }
					 }
			    	 callback(jsonResponse);
			     } else if ($('#vendorName').length > 0 &&  $('#vendorName').val().toLowerCase().includes('chubltl')) {
			    	 if(jsonResponse.itemClassification === 'CHUBLTL' && null !== estimatedDeliveryDate  && undefined !== estimatedDeliveryDate){
			    		 COSTCO.Product.populateChubLTLEDD(estimatedDeliveryDate); 
			    		 COSTCO.Product.isEDDStatusAvailable=true;
					 } else {
						  if ('ShipRestricted' === jsonResponse.fulfilledBy || COSTCO.util.productConstants.edd_shiprestricted === jsonResponse.availability) {
							 	jsonResponse.messageCode = 'MSG_CODE_POSTAL_CODE_RESTRICTED';
							 	COSTCO.Product.isEDDStatusAvailable=false;
							  } else {
								 jsonResponse.messageCode = "EDD_SMALLPACK_UNAVAILABLE";
								 COSTCO.Product.isEDDStatusAvailable=true;
							 }
					 }
			    	 callback(jsonResponse);
			     } else{
					 var msgCode = COSTCO.Product.buildMessageCodeForEDD(jsonResponse);
				        COSTCO.Product.setEDDdisplay(msgCode,jsonResponse);
				        if(jsonResponse !== undefined && jsonResponse.status !== undefined && jsonResponse.status === "SUCCESS" ){
				        	if (!COSTCO.util.isCAStore()) {
				        		COSTCO.Product.prepareAndCallDeliveryServices()
				        	}	
						}
				        callback(jsonResponse);
				        COSTCO.Product.executeAlways();
				 }
			        })
					.catch((err) => {
						COSTCO.Product.externalServiceDown();
						if(err.message !== undefined && err.message ==='API_TIMEOUT'){
							console.log('API TIMEOUT');
							
						}else {
							console.log('API Service Fault');
						}});
		    }, populateSmallPackEDD: function(estimatedDeliveryDate){
		    	var date = estimatedDeliveryDate.split('T')[0];
				var dateToDisplay = COSTCO.Product.getDateFormattedToDisplay(date);
				document.getElementById('estimatedDeliveryDate').innerHTML = dateToDisplay;
				document.getElementById('edd-postal-code').innerHTML = $.cookie('invCheckPostalCode');
				document.getElementById('edd-heading-text').innerHTML = messages.DATE_TEXT_SMALL_PACK;
				document.getElementById('edd-heading-text-suffix').innerHTML = messages.DATE_TEXT_ORDER_NOW_SUFFIX;
				COSTCO.Product.setZipInErrMsg('edd-date-msg');
				$('#edd-date-msg').removeClass('hide');
				$('.edd-carrier-text').addClass('hidden');
		    } , populateChubLTLEDD: function(estimatedDeliveryDate){
		    	var date = estimatedDeliveryDate.split('T')[0];
				var dateToDisplay = COSTCO.Product.getDateFormattedToDisplay(date);
				document.getElementById('estimatedDeliveryDate').innerHTML = dateToDisplay;
				document.getElementById('edd-postal-code').innerHTML = $.cookie('invCheckPostalCode');
				document.getElementById('edd-heading-text').innerHTML = messages.DATE_TEXT_SMALL_PACK;
				document.getElementById('edd-heading-text-suffix').innerHTML = messages.DATE_TEXT_ORDER_NOW_SUFFIX;
				COSTCO.Product.setZipInErrMsg('edd-date-msg');
				$('#edd-date-msg').removeClass('hide');
				document.getElementById('edd-disclaimer-text').innerHTML = messages.EDD_CHUB_LTL_GUARANTEE_PRECONDITION;
				$('.edd-carrier-text').removeClass('hidden');
				
		    } ,
		    /**
	           *  Method to get selected partnumber for variant items and normal line items
	         **/
		    getPartnumber: function(){
		    	var itemPartnumber ='';
		    	var variantItem = COSTCO.Header.itemPartNumberSelcted;
		    	var normalItem= $('#resultingItemNumbers').val();
		    	if(variantItem!== undefined && variantItem !== ''){
		    		itemPartnumber = variantItem;
		    	}else{
		    		itemPartnumber = normalItem.replace(/[[\]]/g,'');
		    	}
		    	return itemPartnumber;
		    },
		    /**
	           *  Method to get Zipcode for EDD and installation service call
	         **/
		    getZipcode : function(){
		    var zipCode =$.cookie('invCheckPostalCode');
		    var finalZip ='';
		    if (zipCode != null && zipCode != '') {
				var zipCodeWithoutExtraFour = zipCode.split('-');
				if (zipCodeWithoutExtraFour.length > 1) {
					finalZip = zipCodeWithoutExtraFour[0];
				} else {
					finalZip = zipCode;
				}
			}
			return finalZip;
		    },
		    /**
	           *  Method to hide message code components
	         **/
		    hideEddMessagecode : function(){
		    	$('#edd-date-msg').addClass('hide');
		    	$('#edd-postal-code-restricted').addClass('hide');
		    	$('#edd-oos-select-option').addClass('hide');
		    	$('#edd-outofstock').addClass('hide');
		    	$('#edd-unknown-error').addClass('hide');
		    	$('#edd-addit-trans-time').addClass('hide');
		    	$('#edd-msg-code-available-house').addClass('hide');
		    	$('#edd-msg-code-external-service-down').addClass('hide');
		    	$('#edd-transit-block').addClass('hide');
		    	$(" #edd-check-button, #eddZipCodeField").attr("disabled", false);
		    	$('#edd-back-order-msg').addClass('hide');
		    	$('#edd-form-block').addClass('hide');
		    	$('#edd-msg-code-smallpack').addClass('hide');
		    	$('#edd-msg-code-grocery-smallpack').addClass('hide');
		    },
		    /**
	           *  Method to disable zipcode field based on refresh edd param
	         **/
		    executeAlways : function(){
		    	$('#product-page').attr("data-onloadTracker", "false");
		        COSTCO.Product.pdpMakeElementSticky();
		    },
		    /**
	           *  Method to set EDD value from edd response to JSP page
	         **/
		    setEDDdisplay: function(msgCode,jsonResponse) {
		    	if(msgCode !== undefined && msgCode !== ''){
					var status = msgCode.split('+')[0];
					var messageCode = msgCode.split('+')[1];
					jsonResponse.status=status;
					jsonResponse.messageCode=messageCode;
					if (jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== undefined && jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== null && status === "SUCCESS"
						&& COSTCO.Product.checkIfEDDInValidRange(jsonResponse.shipmodeDates[0].estimatedDeliveryDate)) {
						var date = jsonResponse.shipmodeDates[0].estimatedDeliveryDate.split('T')[0];
						var dateToDisplay = COSTCO.Product.getDateFormattedToDisplay(date);
						jsonResponse.shipmodeDates[0].estimatedDeliveryDate=dateToDisplay;
						document.getElementById('estimatedDeliveryDate').innerHTML = dateToDisplay;
						document.getElementById('edd-postal-code').innerHTML = $.cookie('invCheckPostalCode');
						$('#edd-date-msg').removeClass('hide');
						document.getElementById('edd-disclaimer-text').innerHTML = messages.EDD_AND_CALENDAR_GUARANTEE_PRECONDITION;
						$('.edd-carrier-text').removeClass('hidden');
					}
				}
		    },
		    /**
	           *  Method to disable add to cart button and enable edd form if edd service is down
	           *  NOTE: If item is smallpack, we do not want to disable add to cart button on external service down or timeout
	         **/
			  externalServiceDown: function() {
				  if ($('#vendorName').length > 0 && ($('#vendorName').val().toLowerCase().includes('smallpack') || $('#vendorName').val().toLowerCase().includes('chubltl')) ) {
					   $('#add-to-cart-btn').attr("disabled", false);
				  } else {
					  $('#add-to-cart-btn').attr("disabled", true);
					  COSTCO.CMath.addBorderToShipItMolecule('outOfStock'); 
				  }
			        $('#add-to-cart-btn').attr("value", messages.ADDTOCART);
			        $('.oos-overlay').addClass('hide');
			        $('#edd-msg-code-external-service-down').removeClass('hide');
			        $('#product-page').attr("data-onloadTracker", "false");
			        COSTCO.Product.pdpMakeElementSticky();
			  },
			  /**
	            *  Method to get country from lang id
	          **/
		    getCountry: function() {
		    	var langId = COSTCO.util.getLangId();
				var country = 'US';
				if (langId === '-24' || langId === '-25') {
					country = 'CA';
				}
				return country;
		    },
		    /**
	           * Method to set costco environment for service header
	         **/
		    validateCostcoEnv : function() {
		    	var costcoEnv = $('#costcoEnvironmentForEDD').val();
		    	const higherEnv = 'QA2';
		    	const ecomEnv = 'ECOM';
		    	const devEnv = 'DEV';
		    if (costcoEnv === "" ) {
				costcoEnv = ecomEnv;
			} else if (costcoEnv == devEnv) {
				costcoEnv = higherEnv ;
			}
		    return costcoEnv;
		    },
		    /**
	           * Method to invoke installation API service
	         **/
		    invokeInstallationServices: function invokeInstallationServices(eddServiceResponse,itemPartNumber,zipCode) {
		    	var installationServiceUri = $('#baseUriForEDDInstallationServices').val();
		    	var clientIdentifier=$('#apigeeClientIdentifierHeader').val();
		    	var installationConnetionTime = $('#connectionTimeOutForEDD').val();
				var costcoEnv = COSTCO.Product.validateCostcoEnv();
				const installationUri =installationServiceUri + '/' + itemPartNumber+"?destinationPostalCode="+zipCode+"&fulfilledBy="+eddServiceResponse.fulfilledBy+"&orderItemId="+"0";
				const timeOutController = COSTCO.util.getTimeoutController();
                timeOutController(installationConnetionTime, fetch(installationUri, {
						method: 'GET',
						headers: {
                           "costco.env": costcoEnv,
                           "client-identifier" : clientIdentifier
						 }
                }))
 			   .then(response => response.json())
 			     .then(data => {
		        eddInstallationServicesJSON = data.services;
		        })
					.catch((err) => {
					if(err.message !== undefined && err.message === 'API_TIMEOUT'){
						console.log('API TIMEOUT');
					}else {
						console.log('API Service Fault');
						}
					});
				 },
			    /**
			     * Callback function which updates Add to cart button state and OOS overlay based on service response
			     */
			    refreshEDDServiceCallback: function refreshEDDServiceCallback(response) {
			    	if (typeof response !== 'undefined' && !SKIP_EDD) {
			    						    	   
				        if (COSTCO.util.islocationControlledInventoryFlow()) {
				        	//fetch inventory from inventory service response
				        	var inventoryStatus = $('.online-price[data-catentry='+$('#catEntryId').val()+']').data('inv');
				        	// Handling of EDD messages of location controlled items - to avoid multiple message displays
				        	// Item failing in CMath.handleContractSpecificRules() will not display EDD messages.
				        	if(inventoryStatus === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
				        		$('.edd-container').hide();
			        			$('#edd-message-block').hide();
				        	}
				        	if (inventoryStatus !== COSTCO.util.productConstants.inv_backorderd
				        			&& inventoryStatus !== COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail){
				        		if(response.messageCode === "MSG_CODE_POSTAL_CODE_RESTRICTED") {
				        			COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
							        document.getElementById('postal-code-restricted-zip-code').innerHTML = $.cookie('invCheckPostalCode')+'.';
							        $('#edd-postal-code-restricted').removeClass('hide');
				        		} else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK" && COSTCO.Product.isVariantAvailable()){
				        			if(isPDPVariantGreyOutEnabled == 'false'){
				        			$('.oos-overlay').removeClass('hide');
				        			}
				        			$('#edd-oos-select-option').removeClass('hide');
				        		} else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK"){
				        			if(isPDPVariantGreyOutEnabled == 'false'){
					        			$('.oos-overlay').removeClass('hide');
					        			}
				        			$('#edd-oos-select-option').addClass('hide');
							    	document.getElementById('out-of-stock-zip-code').innerHTML = $.cookie('invCheckPostalCode')+'.';
								    $('#edd-outofstock').removeClass('hide');
				        		} else if (response.messageCode === "MSG_CODE_EXTERNAL_SERVICE_DOWN") {
				        			$('.oos-overlay').addClass('hide');
				        			$('#edd-msg-code-external-service-down').removeClass('hide');
				        		} else if (response.messageCode === "MSG_CODE_ADDITIONAL_TRANSIT_TIME" ){
				        			$('.oos-overlay').addClass('hide');
				        			document.getElementById('edd-postal-code-transit-time').innerHTML = $.cookie('invCheckPostalCode');
				    			   	$('#edd-addit-trans-time').removeClass('hide');
				    		    } else if (response.messageCode === "MSG_CODE_AVAILABLE_INHOUSE" ){
				    		    	$('.oos-overlay').addClass('hide');
				    		    	document.getElementById('edd-postal-code-available-inhouse').innerHTML = $.cookie('invCheckPostalCode');
				    		    	$('#edd-msg-code-available-house').removeClass('hide');
				    		    } else if(response.messageCode === "EDD_SMALLPACK_GROCERY_UNAVAILABLE"){
				    		    	$('.oos-overlay').addClass('hide');
				    		    	document.getElementById('edd-postal-code-grocery-smallpack').innerHTML = $.cookie('invCheckPostalCode');
				    		    	$('#edd-msg-code-grocery-smallpack').removeClass('hide');
				    		    } else if (response.messageCode === "EDD_SMALLPACK_UNAVAILABLE") {
				    		    	COSTCO.Product.isLocCtrlSmallPck =true;
				    		    	$('.oos-overlay').addClass('hide');
				    		    	if(COSTCO.CMath.invAvailableAjax){//condition for depozipin small pck edd msg hide
				    		    	$('#edd-msg-code-smallpack').removeClass('hide');
				    		    	document.getElementById('edd-postal-code-smallpack').innerHTML = $.cookie('invCheckPostalCode');
				    		    	}else{
				    		    		$('#edd-msg-code-smallpack').addClass('hide');
				    		    	}
				    		    } else if ((response.status === "FAILURE" || response.messageCode === "MSG_CODE_UNKNOWN_ERROR")){
				    		    	$('#edd-unknown-error').removeClass('hide');
				    		    } else{
				    		    	$('.oos-overlay').addClass('hide');
				    		    }
				        	}
				        }
				        else if (response.messageCode === "MSG_CODE_POSTAL_CODE_RESTRICTED") {
				        	$('.edd-container').show();
                            $('#edd-message-block').show();
			        		COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
			        		document.getElementById('postal-code-restricted-zip-code').innerHTML = $.cookie('invCheckPostalCode')+'.';
			        		$('#edd-postal-code-restricted').removeClass('hide');
				        }else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK" && COSTCO.Product.isVariantAvailable()){
				        	COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
				        	if(isPDPVariantGreyOutEnabled == 'false'){
			        			$('.oos-overlay').removeClass('hide');
			        			}
				          	$('#edd-oos-select-option').removeClass('hide');
				        }else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK") {
				            COSTCO.Product.disableAddtoCart(messages.ADDTOCART_OUTOFSTOCK);
				            if(isPDPVariantGreyOutEnabled == 'false'){
			        			$('.oos-overlay').removeClass('hide');
			        			}
				          	$('#edd-oos-select-option').addClass('hide');
				          	document.getElementById('out-of-stock-zip-code').innerHTML = $.cookie('invCheckPostalCode')+'.';
				          	$('#edd-outofstock').removeClass('hide');
				        }else if (response.messageCode === "MSG_CODE_EXTERNAL_SERVICE_DOWN") {
				        	COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
				          	$('#edd-msg-code-external-service-down').removeClass('hide');
				        }else if (response.messageCode === "MSG_CODE_ADDITIONAL_TRANSIT_TIME" ){
				        	  $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
					          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
				    	  	document.getElementById('edd-postal-code-transit-time').innerHTML = $.cookie('invCheckPostalCode');
				    	  	$('#edd-addit-trans-time').removeClass('hide');
				        }else if (response.messageCode === "MSG_CODE_AVAILABLE_INHOUSE" ){
				        	  $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
					          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
				    	  	document.getElementById('edd-postal-code-available-inhouse').innerHTML = $.cookie('invCheckPostalCode');
				    	  	$('#edd-msg-code-available-house').removeClass('hide');
				        }else if(response.messageCode === "EDD_SMALLPACK_GROCERY_UNAVAILABLE"){
				        	  $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
					          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
				    	  	document.getElementById('edd-postal-code-grocery-smallpack').innerHTML = $.cookie('invCheckPostalCode');
				    	  	$('#edd-msg-code-grocery-smallpack').removeClass('hide');
				        }else if (response.messageCode === "EDD_SMALLPACK_UNAVAILABLE") {
				        	  $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
					          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
				    	  	$('#edd-msg-code-smallpack').removeClass('hide');
				    	  	document.getElementById('edd-postal-code-smallpack').innerHTML = $.cookie('invCheckPostalCode');
				        }else if (response.status === "FAILURE" || response.messageCode === "MSG_CODE_UNKNOWN_ERROR") {
				        	COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
                          	$('#edd-unknown-error').removeClass('hide');
				        }else{
				        	if(!COSTCO.CMath.siteControllOOS){
				        		$('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
						         $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
						     	$('.oos-overlay').addClass('hide');
				        	}
				        	
				        }
			    	}
                        COSTCO.Product.eddFormDisplayed = false;
				    },
				    
				    prepareAndCallDeliveryServices: function() {
				    	
				    	var deliveryServicesRequestMap = new Map();
				    	var itemPartNumber = COSTCO.Product.getPartnumber();
				    	var zipCode = COSTCO.Product.getZipcode();
						var deliveryServicesUri = $('#baseUriForEDDDeliveryServices').val();
						installationUri = deliveryServicesUri + '/' + itemPartNumber+"?destinationPostalCode=" + zipCode+"&orderItemId=0";
				    	var defaultShipcode = $('#defaultShipCode').val();
						if (defaultShipcode) {
							installationUri += "&shipMode=" + defaultShipcode;
						}
				    	deliveryServicesRequestMap.set(0,installationUri);
						COSTCO.EDD.invokeDeliveryServices(deliveryServicesRequestMap,{});
				    }, 
				    
				    isVariantAvailable: function() {
				        return $('#product-page').attr('data-onloadTracker') === "true" &&
				          !COSTCO.Product.isSingleAvailableSKU(products) &&
				          (COSTCO.Product.item_type === 'single_variant' || COSTCO.Product.item_type === 'multi_variant') ? true : false;
				    },
				    enableAddtoCart:function(){
				      $('#add-to-cart-btn').attr("disabled", false);
			          $('#add-to-cart-btn').attr("value", messages.ADDTOCART);
			          $('.oos-overlay').addClass('hide');
			          $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
			          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
			          $('#add-to-list').show();
			          COSTCO.CMath.addBorderToShipItMolecule(); 
				    },
				    disableAddtoCart:function(buttonMessage){
				      $('#add-to-cart-btn').attr("disabled", true);
				      $('#add-to-cart-btn').attr("value", buttonMessage);
				      $('.oos-overlay').addClass('hide');
				      COSTCO.CMath.addBorderToShipItMolecule(); 
				      
				      if(buttonMessage == messages.ADDTOCART_OUTOFSTOCK){
				    	  $('#add-to-list').hide(); 
				    	  COSTCO.CMath.addBorderToShipItMolecule('outOfStock'); 
				      } else {
				    	  $('#add-to-list').show();
				      }
				    },
				    /**
			           * Method used to replace latest zipcode in message code string
			         **/
				    setZipInErrMsg:function(component){
				    	var zipCode =$.cookie('invCheckPostalCode');
				      var prevZipcode = document.getElementById('prevZipCode').value;
				      var str = document.getElementById(component).innerHTML;
				      if(prevZipcode !== undefined && prevZipcode  !== "" && zipCode!== prevZipcode){
				          document.getElementById(component).innerHTML = str.replace(prevZipcode, zipCode);
				          document.getElementById('prevZipCode').value =zipCode;
				      }else if (prevZipcode === "") {
				          document.getElementById(component).innerHTML = str.replace("null", zipCode);
				          document.getElementById('prevZipCode').value =zipCode;
				      }
				    },
				    /**
	    		     * Method return EDD Date in Day,Month date (Thursday, October 1) format
	    		     **/
			 getDateFormattedToDisplay: function(date) {
				  var splitDate = date.split('-');
		          var year = splitDate[0];
		          var month = splitDate[1] - 1;
		          var day = splitDate[2];
		          var langId = COSTCO.util.getLangId();
		          var daysOfWeek;
		          var monthName;
		          if(langId === '-25'){
		        	  dateFormat = new Date(year, month, day).toLocaleDateString('fr-CA',{weekday: 'long', month : 'long', day:'numeric'});
		          }else{
		        	  dateFormat = new Date(year, month, day).toLocaleDateString('en-US',{weekday: 'long', month : 'long', day:'numeric'}); 
		          }
		          return dateFormat;
		      },
		         /**
  		           *    Method return true if EDD date is in range after validating xapp entry EDD_MAX_FUTURE_DATE_DIFF
  		          **/
				checkIfEDDInValidRange: function (date) {
					if(null != date) {
						date = date.split('T')[0].split('-');
						var rangeValid = false;
						var eddMaxFutureDateDiff = parseInt($('#eddMaxFutureDateDiff').val());
						var year = date[0];
						var month = date[1] - 1;
						var day = date[2];
						const eddDate = new Date(year, month, day);
						const today = new Date();
						const diffTime = Math.abs(eddDate - today);
						const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
						if (diffDays <= eddMaxFutureDateDiff) {
							rangeValid = true;
						}
						return rangeValid;
					}
				},
				/**
		           * Method used to form and return  message code from EDD response
		         **/
				buildMessageCodeForEDD: function (jsonResponse) {
					var msgString = '';
					if (jsonResponse.availability=== COSTCO.util.productConstants.edd_backordered ||
							jsonResponse.availability=== COSTCO.util.productConstants.edd_presell){
						//Backordered or Presell item messages will be displayed by inventory service flow
						msgString = 'SUCCESS+EDD_BACKORDERED_PRESELL_ITEM';
						COSTCO.Product.isEDDStatusAvailable=true;
					} else if (typeof jsonResponse.availableForSale != 'undefined' && jsonResponse.availableForSale) {
						if (typeof jsonResponse.shipmodeDates[0].estimatedDeliveryDate === 'undefined' 
							|| jsonResponse.shipmodeDates[0].estimatedDeliveryDate == null
							||jsonResponse.shipmodeDates[0].estimatedDeliveryDate !=null 
							&& jsonResponse.shipmodeDates[0].estimatedDeliveryDate.trim().length === 0) {
							if (COSTCO.Product.isAdditionalTransitTimeRequired()) {
								msgString = 'SUCCESS+MSG_CODE_ADDITIONAL_TRANSIT_TIME';
								COSTCO.Product.isEDDStatusAvailable=true;
							} else {
								msgString = 'SUCCESS+MSG_CODE_AVAILABLE_INHOUSE';
								COSTCO.Product.isEDDStatusAvailable=true;
							}
						} else if (COSTCO.Product.checkIfEDDInValidRange(jsonResponse.shipmodeDates[0].estimatedDeliveryDate)) {
							msgString = 'SUCCESS+';
							COSTCO.Product.isEDDStatusAvailable=true;
						} else {
							msgString = 'FAILURE+MSG_CODE_ITEM_OUT_OF_STOCK';
							 COSTCO.Product.isEDDStatusAvailable=false;
						}
					} else if ('ShipRestricted' === jsonResponse.fulfilledBy 
							|| COSTCO.util.productConstants.edd_shiprestricted === jsonResponse.availability) {
						// If fulfilled by comes back with "ship restricted", show a different error message
						msgString = 'FAILURE+MSG_CODE_POSTAL_CODE_RESTRICTED';
						COSTCO.Product.isEDDStatusAvailable=false;
						} else if (jsonResponse.fulfilledBy !=null && 'UNKNOWN' === jsonResponse.fulfilledBy.toUpperCase()) {
						// if fulfilledBy = 'UNKNOWN' then an exception happened - date will be null
						msgString = 'FAILURE+MSG_CODE_UNKNOWN_ERROR';
						COSTCO.Product.isEDDStatusAvailable=false;
						} else {
						msgString = 'FAILURE+MSG_CODE_ITEM_OUT_OF_STOCK';
						 COSTCO.Product.isEDDStatusAvailable=false;
           }
					return msgString;
				},
				
				updateEDDStockstatusforvariant: function ( itemNumber){
					  if( (COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant') &&  isPDPVariantGreyOutEnabled == 'true' ){	
				var uptitemarrayStatus = {};
       			  var uptvariantitemArray ={};
       			let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
       		 var len = optionsSelected.length;
       			var lowerSwatch=$('#swatches-productOption0'+parseInt(len-1)+'').length > 0 ;
      			var lowerDropDown=$('.varis-v2[automation-id=varisSwatch_0'+parseInt(len-1)+']').length>0 ;
       			  if(COSTCO.CMath.variantJSON.length >0){
       			 for(var i in COSTCO.CMath.variantJSON){
       				var val = COSTCO.CMath.variantJSON[i];
       			    for(var j in val){
       			        var sub_key = j;
       			        var sub_val = val[j];
       			        if(sub_key == itemNumber && (!COSTCO.Product.isEDDStatusAvailable ||COSTCO.CMath.isErrorlocationControlleditem)){
   		        		 uptitemarrayStatus ["OL"] = '0';
   		        		 uptitemarrayStatus ["WH"] =sub_val.WH;
       			        	 uptvariantitemArray[itemNumber] =uptitemarrayStatus;
       			        	 COSTCO.CMath.variantJSON[i] =uptvariantitemArray;
       			        	 localStorage.setItem('variantStatus',JSON.stringify( COSTCO.CMath.variantJSON));
       			        }
       			    }
       			}
       			for(var i in COSTCO.CMath.variantJSON){
    				var val = COSTCO.CMath.variantJSON[i];
    			    for(var j in val){
    			        var sub_key = j;
    			        var sub_val = val[j];
    			       if(sub_key == itemNumber){
    			        	 if(sub_val.OL == '0' && sub_val.WH == '0'){
    			        		 if(COSTCO.Product.item_type === 'multi_variant'  ){
    		        				 if(lowerSwatch){
    		        					 COSTCO.CMath.ajaxStrikeSwatches();
    		        				 } else if(lowerDropDown){
    		        					 COSTCO.CMath.ajaxGrayOutDropDown(); 
    		        				 }
    		        			 }else if(COSTCO.Product.item_type === 'single_variant'){
    		        				 if($('#swatches-productOption00').length > 0 ){
    		        					 COSTCO.CMath.ajaxStrikeSwatches();
    		        				 } else if($('.varis-v2[data-product=0]').length>0 ){
    		        					 COSTCO.CMath.ajaxGrayOutDropDown(); 
    		        				 }
    		        			}
    			        	 }else{
    			        	//Following code for remove css of previous selected swatches
 	        			
 	        			 if(lowerSwatch){// pills
 	        				 if(COSTCO.Product.item_type === 'multi_variant'  ){
 		        				
 		        				 variable= $('input[value=' +optionsSelected[len-1]+ ']').next().attr("automation-id");
 		        				 
 		        			 }else if(COSTCO.Product.item_type === 'single_variant'){
 		        				 $('.selection-item').removeClass("select-span1-OOS");
 		        				 variable= $('input[value=' +optionsSelected[0]+ ']').next().attr("automation-id");  
 		        			 }
 	        			 $('span[automation-id='+variable+']').removeClass("select-span1-OOS");
 	        			 $('span[automation-id='+variable+']').removeClass("span1-outofstock");	
 	        			 $('span[automation-id='+variable+']').children("p").remove();// for removing P tag
 	        			 }else if(lowerDropDown){// lower level drop-down
 	        				 $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-1]+']').removeClass("out-of-stock");
 	        				 $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[len-1]+']').children("span").remove();
 	        				
 	        			 }
 	        			 COSTCO.CMath.update_selected_option_label(optionsSelected[len-1]);
    			        	 }
 	        			 if($('#swatches-productOption0'+parseInt(optionsSelected.length-2)+'').length > 0 ){
 	        					COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
 	        				}else if($('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-2)+']').length>0 ){
 	        					COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
 	        				}
    			        }
    			     }
    			}
       			  }
					  }	
				},
				/**
		           * Method return true if additional transit time  required for selected state by checking  xapp entry EDD_STATES_THAT_REQUIRE_ADDITIONAL_TRANSIT_TIME
		         **/
				isAdditionalTransitTimeRequired: function () {
					var additionalTransitTimeStates = $('#additionalTransitTimeStates').val();
					var additionTransitTimeRequired = false;
					var state = $.cookie('invCheckStateCode');
					if (null !== state) {
						state = state.toUpperCase();
						if (additionalTransitTimeStates != null) {
							for (var stateFromConf of additionalTransitTimeStates.split(",")) {
								if (stateFromConf.toUpperCase() === state) {
									additionTransitTimeRequired = true;
									break;
								}
							}
						}
					}
					return additionTransitTimeRequired;
				},

    /**
     * This function appends price (and backordered text) to every Single Variant product's
     * We will only show price if the item is not member only pricing if the member is not signed in
     * select options so that they show something like this Color: "Brown - $194.99".
     * @return {[void]}
     */
    set_option_price_text: function() {
      $('.variantContainer').each(function(i, vContainer) {
        var product_num = $(vContainer).find('[data-product]').data('product');
        if (this.isSingleVariant([products[product_num]], true)) {
          $(vContainer).find('select.varis option').each(function(i, option) {
            if ($(option).val() != 'unselected') {
              var item = this.findItem(products[product_num], this.get_selected_array($(option))),
                back_ordered = item.inventory == 'BACK_ORDER' ? ' - ' + messages.BACKORDER_TEXT : item.inventory == 'OUT_STOCK' ? ' - ' + messages.OUT_OF_STOCK_TEXT  : "";
              	let memberOnly =  $('#memberItem').val()=="true"? true:false, userInfo = COSTCO.util.getMemberCookie(), signedIn = userInfo.signedIn, costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false;
              	let variantOptionText = $(option).text() + back_ordered;
              	if (!memberOnly || (memberOnly && signedIn && costcoMember)) {
              		 if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
                   		variantOptionText = variantOptionText;
              		 } else {
                   		variantOptionText = variantOptionText + ' - ' + this.formatMoney(this.processPrice(item.price), true);
              		 }
              	}
              $(option).text(variantOptionText);
              	$variant_option_input = $('input[value=' + $(option)[0].value + ']');
				if(typeof ($variant_option_input.siblings('.selection-item')[0]) !== "undefined"){
					$variant_option_input.siblings('.selection-item')[0].innerHTML = variantOptionText;
					$variant_option_input.removeAttr('checked');
					if($('.variantContainer select.varis').find('option:selected').val() == $(option).val()){
						$('label[for=' + $('.variantContainer select.varis').find('option:selected').parent().attr('id') + ']').find('.selectedOptionValue').html(' ' + variantOptionText);
						$variant_option_input.prop('checked', true);
					}
				} 
              if (back_ordered.includes(messages.OUT_OF_STOCK_TEXT)) {
            	  $(option).attr("disabled","disabled");
            	  $variant_option_input.attr("disabled","disabled");
            	  $variant_option_input.parents('label.variant-v2').addClass('disabled');
              }else {
            	  $variant_option_input.removeAttr('disabled');
            	  $variant_option_input.parents('label.variant-v2').removeClass('disabled');
              }
            }
          }.bind(this));
        }
      }.bind(this));
      
    },
    /**
     * The popover for fees associated with a product. These are the "tool-tips" part
     * of the line items in math table.
     * @return {[void]}
     */
    pop_overs: function() {
      $('.co-info').popover({
        container: '.math-table'
      });
      
      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
    	  COSTCO.util.socialNetworksPopover('social-share-link'); 
      }
    },
    /**
     * If span.view-more-height is set by the business within
     * a product's long description, this function sets the
     * product details product-info-description to that designated
     * max-height and appends a "View More Details" button.
     * @return {[void]}
     */
    product_details_view_more: function() {
      $('#product-page .panel-body').each(function(index, el) {
          var tab_max_height = $(el).find('.view-more-height').length > 0 ?
          $(el).find('.view-more-height').data('height') :
          $(el).find('.view-more-height-default').data('height'),
          $content = $(el).find('.product-info-description');
      	var productType = $('#product-info').data('product');
      	//for BD specific, we want to show the content in its entirety
        if (tab_max_height && productType !== 'tobacco') {
          // Append the view more html
          if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
        	  $content.after(COSTCO.util.tmpl('tmpl_view_more', {}));
          }
          else {
        	  $content.after(COSTCO.util.tmpl('tmpl_view_more_v2', {}));
          }
          // Set the max-height to the business controlled max-height
          $content.css({
            'max-height': tab_max_height
          })
      	}
      });
    },
    /**
     * Event listener for button allocated by product_details_view_more
     * that removes the max-height attribute and then removes itself to
     * view the entire product details.
     * @return {[void]}
     */
    view_more: function() {
    	 if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
    		 $(this).parents('.view-more').siblings('.product-info-description').css({
         	    'max-height': 'none'
         	 });
         	 $(this).parents('.view-more').remove();
         }
         else {
        	 $(this).parents('.view-more-v2').siblings('.product-info-description').css({
 		        'max-height': 'none'
 		     });
 		     try {
 		     	let focusableElements = $(this).parents('.view-more-v2').siblings('.section-title');
 		     	focusableElements.attr('tabindex','0');
 		     	$(focusableElements).focus();
 		     	if ($(this).parents('.panel-body').attr('id') === "nav-pdp-tab-header-13") {
 		     	  COSTCO.Product.changeVisibilityOfReviewContents("show");
 		     	}
 		     	focusableElements.removeAttr('tabindex');
 		     }
 		     catch(err) {
 		     }
 		     $(this).parents('.view-more-v2').remove();
         }
    },
    findItem: function(p, o) {
      if (o.length == 0 && p.length > 0) {
        return p[0];
      }
      for (var i = 0; i < p.length; i++) {
        if (this.areArraysEqual(o, p[i].options) || (o == p[i].catentry)) {
          return p[i];
        }
      }
      return null;
    },
    areArraysEqual: function(array1, array2) {
      var temp = new Array();
      if ((!array1[0]) || (!array2[0])) { // If either is not an array
        return false;
      }
      if (array1.length != array2.length) {
        return false;
      }
      for (var i = 0; i < array1.length; i++) {
        key = (typeof array1[i]) + "~" + array1[i];
        if (temp[key]) {
          temp[key]++;
        } else {
          temp[key] = 1;
        }
      }
      for (var i = 0; i < array2.length; i++) {
        key = (typeof array2[i]) + "~" + array2[i];
        if (temp[key]) {
          if (temp[key] == 0) {
            return false;
          } else {
            temp[key]--;
          }
        } else { // Key didn't appear in array1, arrays are not equal.
          return false;
        }
      }
      return true;
    },
    isSingleItem: function(productsArray) {
      var no_variant_container = $('.variantContainer').length == 0;
      return productsArray.length === 1 &&
        productsArray[0].length === 1 &&
        no_variant_container ? true : false;
    },
    isSingleAvailableSKU: function(productsArray) {
        return productsArray.length === 1 &&
          productsArray[0].length === 1  ? true : false;
    },
    
    isBundle: function(productsArray) {
      return productsArray.length > 1 || $('.bundleQty').length > 0
    },
    /**
     * On product page search for collection tab.
     * 
     * @return true if collection tab exist, otherwise false
     */
    isCollectionPage: function() {
    	return $('#product-page').find('.collection-tab').length > 0 ? true : false;
    },
    isSingleVariant: function(productsArray, override) {
      if (productsArray !=undefined && productsArray[0] !=undefined  && productsArray.length === 1 && $('.bundleQty').length === 0 || override) {
        for (var i = 0, len = productsArray[0].length; i < len; i++) {
          if (productsArray[0][i].options)
            if (productsArray[0][i].options.length === 1)
              return true;
        }
      } else {
        return false;
      }
      return false;
    },
    isMultiVariant: function(productsArray, override) {
      if (productsArray.length === 1 && $('.bundleQty').length === 0 || override) {
        for (var i = 0, len = productsArray[0].length; i < len; i++) {
          if (productsArray[0][i].options)
            if (productsArray[0][i].options.length > 1)
              return true;
        }
      } else {
        return false;
      }
      return false;
    },
    isSelectedSingleVariantBackOrdered: function(selectedOption, product) {
      var isBackordered = false,
        selectedOptionValue = selectedOption.val();
      product.forEach(function(opt, i) {
        if (selectedOptionValue === opt.options[0]) {
          if (opt.inventory === "BACK_ORDER") isBackordered = true;
          return;
        }
      });
      return isBackordered;
    },
    isSelectedMultiVariantBackOrdered: function(selectedOptions, product) {
      var isBackordered = false;
      product.forEach(function(opt, i) {
        var options = opt.options,
          count = 0;
        selectedOptions.each(function(chosen, k) {
          if (COSTCO.util.hasElem(this.value, options)) count++;
        })
        if (count === options.length) {
          if (opt.inventory === "BACK_ORDER") isBackordered = true;
          return;
        }
      });
      return isBackordered;
    },
    areAnySelectedFromBundleBackordered: function(containers) {
      var isBackordered = false;
      products.forEach(function(product, index) { // interogate each product from 'products' array; find out what kind of item it is
        var selectedValue;
        if (this.isSingleItem([products[index]])) {
          if ($(containers[index]).find('select').length) { // Single item with a select box with only one option
            selectedValue = $(containers[index]).find('select > option:selected').val()
            if (selectedValue === products[index][0].options[0])
              if (products[index][0].inventory === "BACK_ORDER") isBackordered = true;
            return;
          } else if (parseInt($(containers[index]).find('input').val()) > 0) { // Single item with no select box (just quantity input shown)
            if (products[index][0].inventory === "BACK_ORDER") isBackordered = true;
            return;
          }
        } else if (this.isSingleVariant([products[index]], true)) {
          if (this.isSelectedSingleVariantBackOrdered($(containers[index]).find('select > option:selected'), products[index])) {
            isBackordered = true;
            return;
          }
        } else if (this.isMultiVariant([products[index]], true)) {
          if (this.isSelectedMultiVariantBackOrdered($(containers[index]).find('select > option:selected'), products[index])) {
            isBackordered = true;
            return;
          }
        }
      }.bind(this));
      return isBackordered;
    },
    bindSubmitToBackOrderModal: function() {
      $("#ProductForm input[name='add-to-cart']").unbind('click').click(function() {
        if (this.item_type == 'single') { // Its a single product aka only "add to cart" button exists
          typeof products[0][0].inventory !== "undefined" && (products[0][0].inventory === 'BACK_ORDER') ?
            this.backorder_modal(products[0][0]) :
            $('#ProductForm').submit()
        } else if (this.item_type == 'single_variant') { // Its a single item with options (ie color or size, etc.)
          var $options = $('#ProductForm select option:selected'),
            selected_arr = this.get_selected_array($options);
          this.isSelectedSingleVariantBackOrdered($options, products[0]) ?
            this.backorder_modal(this.findItem(products[0], selected_arr)) :
            $('#ProductForm').submit()
        } else if (this.item_type == 'multi_variant') { // Its a single item with multiple options (ie color and size, etc.)
          var $options = $('#ProductForm select option:selected'),
            selected_arr = this.get_selected_array($options);
          this.isSelectedMultiVariantBackOrdered($options, products[0]) ?
            this.backorder_modal(this.findItem(products[0], selected_arr)) :
            $('#ProductForm').submit()
        } else if (this.item_type == 'bundle') { // Its bundle which can contain variants/singleItems - check the option(s) selected and see if they're backordered
          this.areAnySelectedFromBundleBackordered($('.variantContainer')) ?
            this.backorder_modal() :
            $('#ProductForm').submit()
        } else { // fallback - always try to add to cart.
          $('#ProductForm').submit();
        }
      }.bind(this));
    },
    is_sku_resolved: function(item_type, quantity_obj) {
      var resolved = false;
      if (item_type == 'single_variant' || item_type == 'multi_variant') {
        // Get values of variant options selected
        var selected_arr = this.get_selected_array($('.varis option:selected'));
        // Are any of the select options "unselected"?
        var any_unselected = COSTCO.util.any(selected_arr, function(value) {
          return value == 'unselected'
        })
        if (!any_unselected) resolved = true;
      } else if (item_type == 'bundle') {
        quantity_obj.product_indices.forEach(function(indice) {
          var product_num = indice;
          var productArray = products && products[product_num] ? products[product_num] : [];
          var optionsSelected = this.get_selected_array($('.varis[data-product=' + product_num + ']').find('option:selected'));
          var product_selected = this.findItem(productArray, optionsSelected);
          if (product_selected) { // If at least one product is resolved, we're good.
            resolved = true;
            return;
          }
        }.bind(this));
      } else { // We're a single item. We always resolve.
        resolved = true;
      }
      return resolved;
    },
    /**
     * Returns the option:selected ($options) values as an array of strings
     * aka ['7000000000000053', '7000000000000623']
     * @param  {[object]} $options - The jQuery selector representing option:selected
     * @return {[array]} Returns an array of strings
     */
    get_selected_array: function($options) {
      return $.map($options, function(option) {
        return $(option).val();
      })
    },
    maxQuantity: function() {
        return COSTCO.util.isBusinessDelivery() ? COSTCO.Product.MAX_QUANTITY_BD : Number($('#cartTotalLimitBC').val());
    },
    /**
     * Returns an object with two properties. The first property, 'valid',
     * is set to true/false based on whether or not we have (at least one) valid
     * quantity. The product_indices property correlates with bundles; specifically
     * their 'data-product=' attributes and is used to validate skus in the next step
     * of validation.
     * @param  {[string]} item_type - string representing item type. Corresponds
     * with phelper.item_type
     * @param quantityId quantity input element reference
     * @return {[object]} quantity_obj - The object containing valid quantity p
     * property (and product_indicies in case of bundles)
     */
    is_valid_quantity: function(item_type, quantityId) {
      let quantityStep = COSTCO.Product.getQuantityStep(quantityId);
      let unitOfMeasure = COSTCO.Product.getUnitOfMeasure(quantityId);
      var err_msgs = {
    		  min : "<p class='sr-only'>" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_INVALID_QTY.replace("{0}", COSTCO.Product.getQuantityStep(quantityId, unitOfMeasure)),
              max : "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_HIGHER_QTY_2.replace("{0}", COSTCO.Product.maxQuantity()),
              badQtyIncrement : "<p class='sr-only'>" + messages.ERROR + "</p>" + quantityId.data("error-message") + ' ' + COSTCO.Product.getQuantityStep(quantityId, unitOfMeasure)
      };
      var quantity_obj = {
        valid: true,
        message: err_msgs.min
      };
      var product_indices = [];
      var maxQnty = COSTCO.Product.maxQuantity();
      let bundleQuantity = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE == true ? 'input[name^=bundle-quantity-]' : 'input[name^=quantity-]'
      if (item_type == 'bundle') { // At least one quantity must be valid
        $(bundleQuantity).each(function(i, input) {
          var quantity_str = $(input).val();
          var quantity_int = parseInt(quantity_str);
          if (!(COSTCO.Product.testInput(quantity_str, quantity_int, maxQnty, quantityStep)))
          {
            product_indices.push($(input).data('product'));
            $(input).attr('aria-invalid','false');
          }
          else {
        	//set aria-invalid to reflect invalid entry
        	$(input).attr('aria-invalid','true');
        	if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
            	quantity_obj.valid = false;
                if(quantity_int <= 0) {
                	quantity_obj.message = err_msgs.min;
                }
                if(quantity_int > maxQnty) {
                	quantity_obj.message = err_msgs.max;
                }
        	}
          }
        });
        if (product_indices.length == 0) {
          quantity_obj.valid = false;
        }
      } else {
        var quantity_str = $('input[name=quantity]').val();
        var quantity_int = parseInt(quantity_str);
        if (COSTCO.Product.testInput(quantity_str, quantity_int, maxQnty, quantityStep)) {
          $('input[name=quantity]').attr('aria-invalid','true');
      	if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
          quantity_obj.valid = false;
          $('input[name=quantity]').addClass('error-qty');
          if(quantity_int <= 0) {
        	  quantity_obj.message = err_msgs.min;
          } else if(quantity_int > maxQnty) {
        	  quantity_obj.message = err_msgs.max;
          } else if(quantity_int%quantityStep != 0) {
        	  quantity_obj.message = err_msgs.badQtyIncrement;
          }
      	}
        }
        else {
        	$('input[name=quantity]').attr('aria-invalid','false');
        	if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
        		$('input[name=quantity]').removeClass('error-qty');
        	}
        }
      }
      quantity_obj.product_indices = product_indices;
      return quantity_obj;
    },
    /**
     * Returns unit of measure of input quantity value (empty string if there is no unit of measure)
     * @param quantityId quantity input element reference
     * @return quantity value unit of measure
     */
    getUnitOfMeasure: function(quantityId) {
    	return quantityId.next('.unit').text();
    },
    /**
     * Returns true if iput value is vlaid or false otherwise
     * @param quantity_str quantity input value in form of string
     * @param quantity_int quantity input value in form of integer
     * @param maxQty maximum quantity input value
     * @param increment increment/step of quantity input value
     * @return true if iput value is vlaid or false otherwise
     */
    testInput: function(quantity_str,quantity_int, maxQty, increment) {
      	if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
      		return isNaN(quantity_int) || 
      				quantity_int <= 0 ||
      				quantity_int > maxQty || 
      				quantity_int.toString() != quantity_str ||
      				quantity_int%increment != 0;
      	} else {
      		return isNaN(quantity_int) || 
      				quantity_int <= 0 ||
      				quantity_int > maxQty || 
      				quantity_int.toString() != quantity_str;
      	}
    },
    
    backorder_modal: function(product) {
      // The user must select "add to cart" in the backorder modal to switch this to true
      var add_obj = {
        isAdd: false
      };
      COSTCO.dialog.showModal({
        title: messages.RWD_ITEM_BACKORDERED,
        body: this.backorder_message(product),
        secondary: messages.JS_DIALOG_CANCEL,
        primary: messages.ADDTOCART,
        primary_event: function() { // user selected "add to cart"
          this.isAdd = true;
          $('#costcoModal').modal('hide');
        }.bind(add_obj),
        afterclose: function() {
          if (this.isAdd) { // If primary event was selected, add to cart
            $('#ProductForm').submit();
          }
          this.isAdd = false; // reset state
        }.bind(add_obj)
      });
    },
    backorder_message: function(product) {
		if (isBDApplication && isBDApplication === 'BC'){
	  		var message = product.backorderMessage+ ' ' + messages.BACKORDER_TEXT_ADD;
	  		var locmessage =  $('#backorder-message').text();
	  		if(product.isLocInvItem || (typeof locmessage !== undefined && null != locmessage)){
	  			message = locmessage+ ' ' + messages.BACKORDER_TEXT_ADD;
	  		}
	  		return message;
	  	}
      var message_key = 'BACKORDER_TEXT_',
        message_num = product && product.message || '5',
        date_1 = product && product.date || '',
        date_2 = product && product.date2 || '';

      if (product) {
        if (product.allBackorderable == 0) {
          message_key += 'PART_MSG'
        } else {
          message_key += 'MSG'
        }
        switch (message_num) {
          case '1':
            message_key += message_num;
            break;
          case '2':
            message_key += message_num;
            break;
          case '3':
            date_1 == date_2 ?
              message_key += 1 :
              message_key += message_num
            break;
          case '4':
            date_1 == date_2 ?
              message_key += 2 :
              message_key += message_num
            break;
          default:
            message_key += message_num
        }
      } else {
        message_key += 'MSG' + message_num
      }
      return messages[message_key]
        .replace('{0}', date_1).replace('{1}', date_2) + ' ' + messages.BACKORDER_TEXT_ADD
    },
    /**
     * Add to cart modal. Invoked after the "done" promise resolves
     * when calling AddToCart.ajaxAddToCart.
     * @param  {[array]} selected_products Array of objects representing
     * the items that went into the cart
     * @return {[void]}
     */
    added_modal: function(selected_products, orderItemId, qtyBought, originalQty) {
      this.related_products_member_pricing();
      $('.modal-footer').addClass('hide');
      var items_html = "",
        partsandservices = this.getPartsAndServices($('#configuredInfo').val()) ,
        partsandservicesType = $('#configuredInfoType').val() ,
        service_html="",
        parts_html="",
        remark_html="",
        parts_and_services_html="",
        partandserviceArray="";
      if($('#reactkitsandbundle').val() != 'true'){
    	  var $related_products_template = $('#product-page .related-products');
    	  $('#product-page .related-products').remove();
      }else{
    	  var  selectedVirtualParentPartnumber = $('#productPartnumberVal').val();
    	  $related_products_template = $('#product-page #RelatedProducts_'+selectedVirtualParentPartnumber);
      }
      var installationFlag = undefined;
      if (partsandservices != "") {
        var installationFlag = JSON.parse(partsandservices).installationAvailable;
      }
        
      //show if installation is not available
      if (installationFlag != undefined && !installationFlag) {
        remark_html += COSTCO.util.tmpl('tmpl_selected_delivery_parts_no_installation', {
          remark: messages.SCHED_DELIV_NO_INSTALLATION_ALERT
        });
      } 
    
      //Parts and service section for Added to cart model box
      if (partsandservicesType == 7) {
        if (partsandservices!='undefined' && partsandservices.length > 0 && partsandservices!="" ) {
          partandserviceArray = JSON.parse(partsandservices).services;
          if (partandserviceArray!='undefined' && partandserviceArray !="" && partandserviceArray.length >0 ) {
          $.each(partandserviceArray, function(index, value) {
            if (value.serviceType=='Service') {
              service_html += COSTCO.util.tmpl('tmpl_services', {
                description:value.description,
                selected:value.selected ? "Yes" : "No"
              })
            } else if (value.serviceType=='Part') {
              if (!value.hidden && value.selected && value.availabilityType != 'hidden') {
                      parts_html += COSTCO.util.tmpl('tmpl_delivery_parts_service_list', {
                        description:value.description
                        })
                    }
              else if(!value.hidden && !value.selected && value.availabilityType != 'hidden'){
                	parts_html += COSTCO.util.tmpl('tmpl_delivery_parts_service_list', {
                    description:value.description + " : No"
                    })
                }
              }
          });

          parts_and_services_html = COSTCO.util.tmpl('tmpl_parts_and_services_addedtocart', {
            services: service_html,
              parts: parts_html,
              remarks: remark_html != "" ? remark_html:""
            })
          }
        }
      } 
      
      selected_products.forEach(function(product, orderItemId) {
        // this is for the added to cart review modal
    	  var ecofeeIncludedPrice = (document.getElementById("ecoFeeHiddenLayout_" + product.catentry) || {}).value || "0";
        items_html += COSTCO.util.tmpl(product.isFsaChdItem == 'true' ? 'tmpl_addtocart_item_FsaChd':'tmpl_addtocart_item', {
          img_url: product.img_url ? product.img_url : product.parent_img_url,
          item_name: product.productName,
          item_url: product.productUrl,
          item_number: product.item_number,
          model_number: product.manufacturerPartNumber,
          price: (ecofeeIncludedPrice != "0") ? ecofeeIncludedPrice : product.final_price,
          quantity: product.quantity,
          orderItemId: orderItemId,
          parts_and_services_html:parts_and_services_html != "" ? parts_and_services_html:"",
          linkFee: COSTCO.Product.displayLinkFee(product.feeOptions)
        })
      });
      
      COSTCO.dialog.createExtDialogBox({
        title: messages.RELATED_PRODUCT_ADDED_TO_CART,
        dialogclasses : 'medium',
        body: COSTCO.util.tmpl('tmpl_addtocart_modal', {
          items: items_html,
          related_products: $related_products_template.length > 0 ?
            $related_products_template[0].outerHTML : ''
        }),
        onclose: function() {
        //COSTCO.Header.refreshMiniBanner();
          $('.modal-footer').removeClass('hide');
          if ($related_products_template.length > 0) {
            $('#product-page').append($related_products_template[0].outerHTML);
          }
          window.wioEventBus.publish('focusPickUpButton', {focusPickUpButton:true});
        }
      });
      $('input[name="parentOrderItemId"]').val(orderItemId);
      $('input[name="relatedQty"]').val(originalQty);
      console.log("Related Quantity Incoming :: " + originalQty + " :: Document source "+$('input[name="relatedQty"]').val());
      if ($('#related-products-container:not(.hide)').find('div[name="RelatedProductFormDiv"]:not(.hide)').length > 0) {
    	  $('.modal-body .related-products').removeClass('hide');
    	  
    	  if(relProductLinkFee !== undefined && relProductLinkFee != null) {
    		  Object.entries(relProductLinkFee).forEach(([key, value]) => {
    			  if($('#relLinkFee_'+key).length > 0){
    				  $('#relLinkFee_'+key).html(COSTCO.Product.displayLinkFee(value));
    			  }
    		  });
    	  }
      }
      $('.co-help.eco-fee').popover();
      
    },
    /**
     * If a related product is a member only item, show pricing based on member cookie.
     * @return {[void]}
     */
    related_products_member_pricing: function() {
      var userInfo = COSTCO.util.getMemberCookie(),
        signedIn = userInfo.signedIn,
        costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,
        validated = userInfo.validated != 'undefined' ? userInfo.validated : false;
        active = userInfo.active != 'undefined' ? userInfo.active : false;
      // This check is added to keep BD flow unaffected by the change in BC flow
      var showPricingForMember = COSTCO.util.isBusinessDelivery() ? costcoMember : costcoMember && validated && active;
      if (!signedIn) {
        $('.sign-in').show();
        $('.price-details.moi,.productFormContent.moi-atcf,.mem-button.moi').hide();
      } else {
        if (showPricingForMember) {
          $('.sign-in, .mem-button').hide();
        } else {
          $('.price-details.moi,.productFormContent.moi-atcf,.sign-in').hide();
        }
      }
    },
    
    displayLinkFee: function(feeOptions) {
    	var linkFeeContenty='';
    	if(feeOptions !== 'undefined' && feeOptions != null) {
    		let region = $.cookie('C_LOC');
    		var feesConfiguration = (typeof feesConfigurations !== 'undefined') ? feesConfigurations : null;
    		if(feesConfiguration !== 'undefined' && feesConfiguration != null) {
	    		let regionalFeeConfig = feesConfiguration[region] || feesConfiguration["ALL"];
	    		if(regionalFeeConfig !== undefined && regionalFeeConfig != null) {
		    		for (var i=0;i<regionalFeeConfig.length;i++) {
		    			let feeCatConfig =  regionalFeeConfig[i];
		    			let feeTypeLis = feeCatConfig.feeType.split(','); 
		    			let categoryWiseFeeOpt = feeOptions.filter((fee) => (fee.region == region && fee.feeCategory == feeCatConfig.feeCategory));
		    			if(categoryWiseFeeOpt !== undefined && categoryWiseFeeOpt != null) {
		    				let hasHybridFee = categoryWiseFeeOpt.some((fee) => (feeTypeLis[0] != 'ALL' && !feeTypeLis.includes(fee.feeType)));
		    				let isRegionFee = categoryWiseFeeOpt.some((fee) => (feeTypeLis[0] != 'ALL' && feeTypeLis.includes(fee.feeType)));
		    				let feeCategory = '', display = '', feeDesc = '';
		    				let feeAmount = 0, sameFeeCategoryCount = 0;
			    			for (const feeOption of categoryWiseFeeOpt) {
		    					if(feeOption.feeCategory === feeCatConfig.feeCategory) {
		    						if(feeTypeLis.includes(feeOption.feeType) || feeCatConfig.feeType === "ALL" || (hasHybridFee && !isRegionFee)) {
		    							sameFeeCategoryCount++;
										if(!hasHybridFee || (hasHybridFee && !isRegionFee)) {
											feeAmount += parseFloat(feeOption.price);
										}
		    							feeCategory = feeOption.feeCategory;
			    						display = hasHybridFee ? 'STANDARD' : feeCatConfig.display.Browse;
		    							feeDesc = COSTCO.util.sentenceToPascalCase(feeOption.desc.trim())
		    						} else if(hasHybridFee) {
		    							feeAmount += parseFloat(feeOption.price);
		    						}
		    					}
			    			}
		    				if(sameFeeCategoryCount > 0) {
		    					linkFeeContenty += COSTCO.util.tmpl('tmpl_addtocart_linkFee_display', {
		    						"feeCategory" : feeCategory,
		    						"display" : display,
		    						"fee" : (feeAmount > 0) ? this.formatMoney(this.processPrice(feeAmount), true) : '',
		    						"feeDesc" : feeDesc,
		    						"ecoFeeToolTipContent" : ecoFeeToolTipContent
		    					});
		    				}
		    			}
		    		}
	    		}
    		}
    	}
    	return linkFeeContenty;
    },
    
    /**
     * Gets an array of item objects that are selected on the page with positive quantity
     * @return {[array]} an array of item objects
     */
    getSelectedBundleAndVariantItems: function() {
      var selectedItems = [];
      $('.variantContainer').each(function(index) {
        var qty = $('input[name=quantity]').val(); //for non-bundle
        var bundleQty = $(this).find('input[name^=quantity-]').val(); //for bundle
        if (qty > 0 || bundleQty > 0) {
          if ($(this).find('.swatchDropdown').length > 0) { //variant
            var options = [];
            $(this).find('.varis :selected').each(function() {
              options.push($(this).val());
            });
            selectedItems.push(COSTCO.Product.findItem(products[index], options));
          } else { //not a variant
            selectedItems.push(products[index][0]);
          }
        }
      });
      return selectedItems;
    },
    /**
     * Shows plain packaging option on variant selection and/or bundle quantity change
     * based on plainPackaging property of selected item(s) on the page. Immediately
     * shows plain packaging option for a single item page.
     * @return {[void]}
     */
    enablePlainPackagingMessage: function() {
      //shows or hides plain packaging message based on given option
      function showHideMessage(ppOption) {
        //for bundles and variants ppOption will be array.
        //call the function again based on what's in the array.
        if ($.isArray(ppOption)) {
          if ($.inArray("0", ppOption) > -1) {
            showHideMessage("0");
          } else if ($.inArray("1", ppOption) > -1) {
            showHideMessage("1");
          } else if ($.inArray("3", ppOption) > -1) {
        	  showHideMessage("3");
          } else {
            showHideMessage(null);
          }
          return;
        }
        if (ppOption == "1") { //available
          $("#plain-packaging-available").show();
          $("#plain-packaging-not-available").hide();
          $("#plain-packaging-mandatory").hide();
        } else if (ppOption == "0") { //not available
          $("#plain-packaging-available").hide();
          $("#plain-packaging-not-available").show();
          $("#plain-packaging-mandatory").hide();
        } else if (ppOption == "3") { //mandatory plain packaging option
        	$("#plain-packaging-available").hide();
        	$("#plain-packaging-not-available").hide();
        	$("#plain-packaging-mandatory").show();
        } else { //don't show a message. This will be a value of null for item's plainPackaging property
          $("#plain-packaging-available").hide();
          $("#plain-packaging-not-available").hide();
          $("#plain-packaging-mandatory").hide();
        }
      }

      //returns an array of plainPackaging properties of the given items
      function getPPOptions(items) {
        var ppOptions = [];
        $(items).each(function() {
          ppOptions.push(this.plainPackaging);
        });

        return ppOptions;
      }

      if (typeof products == 'undefined') {
        return;
      }
      if (COSTCO.Product.isSingleItem(products)) {
        showHideMessage(products[0][0].plainPackaging);
      } else { //bind change event on variant selection and quantity change
        $('.variantContainer').on('change', '.swatchDropdown:last, input[name^=quantity]', function() {
          var selectedItems = COSTCO.Product.getSelectedBundleAndVariantItems();
          showHideMessage(getPPOptions(selectedItems));
        });
      }
    },

    addToWishList: function(baseURL) {
      if ($('#ProductForm').valid()) {
        var target = baseURL + '&catentryId=' + $('#ProductForm .catentryInput').map(function() {
          return $(this).val();
        }).get().join(',');
        window.location = (target);
      }
    },

    openWishListSuccess: function() {
      var queryString = COSTCO.util.getQueryStringArray();
      if (queryString['addToWishlistSuccessMessageKey']) {
        COSTCO.dialog.createExtDialogBox({
          title: messages.RWD_WISH_LIST_CONFIRM_TITLE,
          body: messages.WISHLIST_ITEM_ADD_CONFIRMATION_MESSAGE,
          primary: messages.RWD_VIEW_WISH_LIST,
          primary_event: function() {
            window.location = '/NonAjaxAccountWishListDisplayView?listId=.'
          },
          secondary: messages.CONTINUE_SHOPPING
        });
      }
    },
    /**
     * Select options modal for GE. Invoked after the "done" promise resolves
     * @param data = Parts and Services JSON
     * @return {[void]}
     */
    show_options_modal : function(data) {
    	 var locale = COSTCO.util.getLocale();
    	 let selected_product = undefined;
    	 if (this.isSingleItem(products))
    		 selected_product = this.findItem(products[0],[]);
    	 else
    		 selected_product = this.getSelectedBundleAndVariantItems()[0];

         selected_product.quantity = messages.RWD_QUANTITY + ' ' + $('input[name=quantity]').val();
         selected_product.item_number = $('span.item-number').text();
         selected_product.final_price = (locale=='en-US'||locale=='en-CA'?' $':'')  +$('.your-price .value').text()+(locale=='fr-CA'?' $':'');

        this.related_products_member_pricing();
    	$('.modal-footer').addClass('hide');
    	var items_html = "",
    		$related_products_template = $('#product-page .related-products');
        $('#product-page .related-products').remove();


        //call function to create parts and services form
        var options_htmls = COSTCO.ScheduledDeliverable.create_parts_and_services_list(data);

        partsservices_html = options_htmls['partsservices_html'];
        remark_html = options_htmls['remark_html'];

        items_html += COSTCO.util.tmpl('tmpl_selected_delivery_Item', {
                img_url : selected_product.img_url ? selected_product.img_url : selected_product.parent_img_url,
                item_name : selected_product.productName,
                item_url : selected_product.productUrl,
                item_number : selected_product.item_number,
                price : selected_product.final_price,
                quantity : selected_product.quantity,
                partsservices : partsservices_html,
                remarksContainer : remark_html,
                model_number: null
        });



    	COSTCO.dialog.createExtDialogBox({
            title : messages.SCHED_DELIV_SELECT_OPTIONS_HEADING,
            body : COSTCO.util.tmpl('tmpl_select_options_modal',{
            	items : items_html,
            	related_products : $related_products_template.length > 0
            		? $related_products_template[0].outerHTML : ''
            }),
            onclose : function() {
            	$('.modal-footer').removeClass('hide');
              if ($related_products_template.length > 0) {
                $('#product-page').append($related_products_template[0].outerHTML);
              }
            }
        });
        $('.modal-body .related-products').removeClass('hide');
    },
    /**
     * this function is to prevent rich media from injecting swatches
     * onto our page when product has no buyable items or is out of stock.
     * We don't include theSwatches div in these cases on the jsp so we add
     * it here.
     */
    injectHiddenSwatchesDiv: function() {
    	if ($('#theSwatches').length == 0) {
    		$('<div id="theSwatches" class="hide"></div>').appendTo('#zoomViewer');
    	}
    },
    /**
     * Function used to check if any modifications have been appended
     * to the product details accordion
     */

	startMutationObserver: function() {
		//STRY0141473 - fire showViewMore() anyway if none of the mutations occur
		COSTCO.Product.showViewMore(observerObject);
		
		var targetObject = (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) ? $('#product-info')[0] : $('#accordion-product-details')[0];
		try {
			if (!$('#CostcoBVContainer').length > 0){
				var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
				  mutationRecordsList.forEach(function(mutation) {
					  if ("attributes" === mutation.type) {
						  COSTCO.Product.showViewMore(observerObject);
					  }
				  });
				});
				// Register the target node to observe and specify which DOM changes to watch
				observerObject.observe(targetObject, {
				  attributes: true,
				  attributeOldValue: true,
				  childList: true,
				  subtree: true,
				  characterData: true
				});
				
				//INC3616033 add a seperate mutationObserver for product-info-description
				var prodInfoObserverObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
					  mutationRecordsList.forEach(function(mutation) {
						  if ("attributes" === mutation.type || "childList" === mutation.type) {
							  COSTCO.Product.showViewMore(prodInfoObserverObject);
						  }
					  });
					});
					// Register the target node to observe and specify which DOM changes to watch
				prodInfoObserverObject.observe($('.product-info-description')[0], {
					  attributes: true,
					  attributeOldValue: true,
					  childList: true,
					  subtree: true,
					  characterData: true
					});
				
			} else {
				// Observe Reviews section on PDP
				var observerObjectReview = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
					  mutationRecordsList.forEach(function(mutation) {
						  if ("childList" === mutation.type && ($(mutation.target).find('#bv_review_maincontainer').length > 0 ||
								  $(mutation.target).find('.bv-content-list-container').length > 0)) {
							  COSTCO.Product.showViewMore(observerObjectReview);

							  if(isBVv2Enabled === 'false') {
								  // Auto popup BV Write a Review for relogin user
								  // bveventid is appended to logonform by BV when not logged in user tries WAR
								  var bveventid = COSTCO.util.getParameterByName('bveventid');
								  var summaryWAR =  $('#WAR');
								  if (bveventid !== null && summaryWAR.length>0){	
									  summaryWAR.trigger('click');	
								  }
							  }
						  }
					  });
					});
					// Register the target node to observe and specify which DOM changes to watch
					observerObjectReview.observe(targetObject, {
						attributes: true,
						attributeOldValue: true,
						childList: true,
						subtree: true,
						characterData: true
					});
					
					
					//INC3616033 add a seperate mutationObserver for product-info-description
					var prodInfoObserverObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
						  mutationRecordsList.forEach(function(mutation) {
							  if ("attributes" === mutation.type || "childList" === mutation.type) {
								  COSTCO.Product.showViewMore(prodInfoObserverObject);
				}
						  });
						});
						// Register the target node to observe and specify which DOM changes to watch
					prodInfoObserverObject.observe($('.product-info-description')[0], {
						  attributes: true,
						  attributeOldValue: true,
						  childList: true,
						  subtree: true,
						  characterData: true
						});
				}
		//If < IE 10 then display the product details in its entirety
		} catch(e) {
			COSTCO.Product.view_more(this);
			return;
		}
	},

    /**
     * Function used to show the View More Details button
     * depend on the the height of the product info content.
     */
    showViewMore: function(observer) {
    	var integrationContentIds = ['#wc-power-page', '#wc-pp', '#SP_ProductImage', '#wc-button', '#easy2-demo', '#ccslogos', '#inline_showcase', '#flix-minisite', '#flix-inpage'];
		var doesnIntegrationIdExists = false;
        for (var i = 0; i < integrationContentIds.length; i++) {
           if($(integrationContentIds[i]).length > 0) {
                   doesnIntegrationIdExists = true;
                   break;
           }
        }
    	if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
    		$('.product-info-description').each(function(index) {
    	    	var height = $(this).prop('scrollHeight');
    	    	var productType = $('#product-info').data('product');
    	    	var screenSize = screen.width;
    	
    	    	//for BD specific, we do want to show the product info in its entirety for tobacco product
    	    	if ((height > 600 || (index == 0 && doesnIntegrationIdExists)) && productType !== 'tobacco') {
    	    		$(this).next().removeClass("hide");
    	    		if (observer) {
    	    			observer.disconnect();
    	    		}
    	    	}
    	    });
    	} else {
    		var height = $('.product-info-description').prop('scrollHeight');
        	var productType = $('#product-info').data('product');
        	var screenSize = screen.width;
        	//need to take into account the height of the product manual
        	var $productManual = $('.product-info-description').find('.product-manuals');
        	//if item has product manual and it is view on screen larger than 768
        	//product manual should be taken into account because it would be hidden
        	if ($productManual.length && screenSize > 768) {
        		var productManualHeight = $productManual.prop('scrollHeight');
            	//if product manual is hidden in case of large display, do not count its height
            	height = height - productManualHeight;
        	}

        	//for BD specific, we do want to show the product info in its entirety for tobacco product
        	if ((height > 600 || doesnIntegrationIdExists) && productType !== 'tobacco') {
        		$('.view-more').removeClass("hide");
        		if (observer) {
        			observer.disconnect();
        		}
        	} else {
        		if (!$('.view-more').hasClass('hide')) {
        			$('.view-more').addClass('hide');
        		}
        	}
    	}
    	
    },
    getPartsAndServices: function(data) {
      var configuredInfoArray = [];
      var showablePartsAndServices = [];

      if (data && data.length > 0) {
        configuredInfoArray = JSON.parse(data);

        //determine which GE dishwasher parts are not to be displayed
        if (configuredInfoArray.services.length > 0) {
            $.each(configuredInfoArray.services, function(index, value) {
              if (!(value.groupId == 1 && value.serviceType.toUpperCase() == 'PART' && value.dependent_service_ids.length > 0) &&
                 !(value.groupId == 1 && value.serviceType.toUpperCase() == 'PART' && value.selected == false)) {
                   showablePartsAndServices.push(value);
              }
            });
            if (showablePartsAndServices.length > 0) {
                configuredInfoArray.services = showablePartsAndServices.slice(0);
            }
            data = JSON.stringify(configuredInfoArray);
        }
      }

      return data;
    },
    
    showReplacementProductModal: function(partNumber) {
      var $relatedProducts = partNumber ? $('#RelatedProducts_' + partNumber) : $('.related-products');
      COSTCO.dialog.createExtDialogBox({
        title: messages.TEMP_REPLACED_ITEM_MODAL_TITLE,
        dialogclasses: 'medium',
        onshow: function() {
        	if (window.checkoutPage) {
        		$('#costcoModal .close').hide();
        	}
        },
        preventClose: window.checkoutPage ? true : false,
        body: COSTCO.util.tmpl('tmpl_related_products', {
          related_products: $relatedProducts.html(),
        }),
      });
    },
    /**
     * Triggers click event, binded to social images, by pressing Enter key
     * @return {[void]}
     */
    makeSocialIconsAdaCompliant: function(){
      $(".social.list-inline.social-icons img").each(function(){
        $(this).on('keydown', function(event){
          if(event.which === 13){
            $(this).click();
          }
        })
      })   
    },

	showSuccessMessage: function(message) {
    	var messsages_html = '';
		messsages_html += COSTCO.util.tmpl('tmpl_succes_notification', { message: message })
		$('#message-area').html(messsages_html);
    },		
    /**
     * Changes the quantity displayed in input element on plus/minus click
     * @param element element user clicked on (plus or minus button)
     * @return void
     */
    changeQuantityValue: function(element) {
    	let $inputElement = $('[name=quantity]');
		let qtyValue = parseInt($inputElement.val());
		if (!qtyValue && qtyValue != 0) {
			qtyValue = 0;
		}else{
			let quantityStep = COSTCO.Product.getQuantityStep($inputElement);
			let isIncrement = undefined;
			if ($(element).attr('name') === 'plusQty') {
				isIncrement = true;
				var maxQnty = COSTCO.Product.maxQuantity();
		        qtyValue += quantityStep;
		        let residual = qtyValue % quantityStep;
		        qtyValue = qtyValue - residual;
			} else if ($(element).attr('name') === 'minusQty') {
				isIncrement = false;
				let residual = qtyValue % quantityStep;
				if(residual == 0) {
					qtyValue -= quantityStep;
				} else {
					qtyValue -= residual;
				}
			}else if(qtyValue == 0){
				isIncrement = false;
			}
			
			$inputElement.val(qtyValue);
			
			COSTCO.Product.validateQuantityValue($inputElement, '.product-error', 'span');
		    COSTCO.Product.expendErrorOnQtyUnit($inputElement, 'span');
			COSTCO.Product.discardInvalidQtyValues(qtyValue, $inputElement, isIncrement);
		}
		COSTCO.util.announceSRMessage("Quantity " + qtyValue);
		
	},
	ChangeQuantityField :function(element){
		let $inputElement = $('[name=quantity]');
		let qtyValue = parseInt($inputElement.val());
		COSTCO.Product.validateQuantityValue($inputElement, '.product-error', 'span');
		if(qtyValue == 0){
			$inputElement.val(1);
		}
		COSTCO.util.announceSRMessage("Quantity " + qtyValue);
	},
    /** /reset error class if it is applyed/reseted on quanty value itself
     * @param quantityId quantity value element reference
     * @param nextElement element behind input
     */
    expendErrorOnQtyUnit: function(quantityId, nextElement) {
		if (COSTCO.util.isPDPCartCheckoutEnabled()) {
	        let inputError = COSTCO.Product.getErrorArea(quantityId, nextElement);
	        if(inputError !== quantityId) {
	        	let inputParent = quantityId.parent();
	        	let hasError = quantityId.hasClass('error');
		    	if(hasError) {
		    		inputParent.addClass('error');
		    	} else {
		    		inputParent.removeClass('error');
		    	}
	        }
		}
    },
	  /**
	  * Get quantity step (which is also treated as minimal quantity value as well) plust (optional) unit of measure
	  * @param quantityId quantity value element reference
	  * @param unitOfMeasure unit of measure
	  * @return quantity step (min quantity value)
	  */
	 getQuantityStep: function(quantityId, unitOfMeasure) {
		 let stepIncrement = quantityId.attr('data-quantity-increment') ? parseInt(quantityId.attr('data-quantity-increment')) : 1;
		 if(typeof unitOfMeasure === "undefined") {
			 return stepIncrement;
		 } else return stepIncrement + " " + unitOfMeasure;
	 },
    /**
     * Discard invalid quantity values
     * @param value current value in quantity input element
     * @param quantityId quantity input element reference
     * @param isIncrement undefined value means value is entered not incremented/decremented
     * @return void
     */
	discardInvalidQtyValues: function(value, quantityId, isIncrement) {
		  let quantityStep = COSTCO.Product.getQuantityStep(quantityId);
	   	  if(isIncrement != undefined && value <= 0) {
	   		  quantityId.val(quantityStep);
	   	  }
	   	  let max = COSTCO.Product.maxQuantity();
	   	  if(value > max) {
	   		  let remainder = max % quantityStep;
	   		  quantityId.val(max - remainder); 
	   	  }
	},
	
    /**
     * Test validity of quantity value and applay result.
     * @param quantityId quantity input element reference
     * @param errorSelector elements, classes and IDs
     * @param nextElement if next element is label or span (they contain unit of measure) then error area is bigger then just input field
     * @return void
     */
	validateQuantityValue: function(quantityId, errorSelector, nextElement) {
		if (COSTCO.util.isPDPCartCheckoutEnabled()) {
		  let quantity_obj = COSTCO.Product.is_valid_quantity(COSTCO.Product.item_type, quantityId);
          let $product_error = $(errorSelector);
          let inputError = COSTCO.Product.getErrorArea(quantityId, nextElement);
          // Check if we have a valid quantity
          if (!quantity_obj.valid) {
        	$product_error.html(quantity_obj.message);
        	inputError.addClass('error');
        	if(quantityId !== inputError) {
            	quantityId.addClass('error');		
        	}
          } else {
        	$product_error.empty();
        	inputError.removeClass('error');
        	if(quantityId !== inputError) {
            	quantityId.removeClass('error');
        	}
          }
        }
	},
    /**
     * Find HTML element on which error class should be applyed.
     * @param quantityId quantity input element reference
     * @param qtyUnitElement possible next element with quantity unit
     * @return void
     */
	getErrorArea: function(quantityId, qtyUnitElement) {
		let errObj = quantityId;
		if (COSTCO.util.isPDPCartCheckoutEnabled() && qtyUnitElement) {
		  let nextElement = quantityId.next();
		  if(nextElement.is(qtyUnitElement)) {
		  	errObj = quantityId.parent();
		  }
		} 
		return errObj;
	},
	/**
     * Shows the sticky element on tablet/desktop view and makes sticky element for mobile view for BC and BD
     * @return void
     */
	pdpMakeElementSticky: function() {
      let userInfo = COSTCO.util.getMemberCookie();
      let signedIn = userInfo.signedIn;
      let costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false;
      let validated = userInfo.validated;
      let verified = userInfo.verified;
      let memberActive = userInfo.active;
      let $qtyInput = $('#qty-input');
      let isBundle = COSTCO.Product.item_type == 'bundle';
      let isTwoDayDeliveryZipIn = ($('.two-day-delivery').length > 0 || $('.frozen-foods-badge').length > 0) && COSTCO.Header.hasInvPostalCodeCookie();
      let $addButtonContainer = $('input[name="isOOSItem"]').length > 0 ? $('.notify-me-btn-area') : $('#ctas ul');//notify-me-btn-area
      let $isAppliance = $('#productCategory').val() === messages.APPLIANCES && ($('#submit-delivery-area').length > 0 || $('#edd-check-button').length > 0);
      let $addButtonGroup;

      if($isAppliance || COSTCO.CMath.iskitsbundle) {
        if ($('#edd-check-button').is(':visible') && !COSTCO.CMath.iskitsbundle) {
          $addButtonGroup = $('#check-availability-sticky');
          $('#sticky-price').hide();
          $('#sticky-qty').hide();
        } else if($('#add-to-cart').is(':visible')) {
          $addButtonGroup = $('#add-to-cart');
          $('#sticky-price').show();
          $('#sticky-qty').show();
        } else if( COSTCO.CMath.iskitsbundle && $('#bundle-button').is(':visible') ){
          $('#sticky-price').show();
          $('#sticky-qty').hide();     
          $('#bundle-button-container').append($('#bundle-button'));
          $addButtonGroup = $('#bundle-button-container');
        }else if($('#renew-membership-for-price').is(':visible')){
        	 $addButtonGroup = $('#renew-membership-for-price');
        	 $('#sticky-price').hide();
             $('#sticky-qty').hide();
        }else {
          if (!signedIn) {
        	  if($('#mapItem').val() == "true"){
        		  $addButtonGroup = $('#sign-in-to-buy');
        	  }else{
        		  $addButtonGroup = $('#sign-in-to-buy-button-v2');
        	  }
          } else {
            if (!costcoMember) {
              $addButtonGroup = $('#link-membership-for-price');
            }
          }
        }
      } else if($('input[name="isOOSItem"]').length > 0) {
        $addButtonGroup = $addButtonContainer.find('input');
      } else {
        $addButtonGroup = $addButtonContainer.children().not('#qty-input');
      }
	  let $detailsBazaarVoice = $('#details-bazaar-voice');
	  let $price = $('#pull-right-price');
	  let $clonedPrice = ($price).clone();
	  let $hiddenSticky = $('#hidden-sticky');
	  let $stickyAddBtn = $('#sticky-add-btn');
	  let isHidden = true;
	  let isSticky = false;
	  let topOfBottomContent;
	  let topOfWindow;
	  let bottomOfWindow;
      $('#pdp-sticky-desktop .tablist').hide();
	  
	  let showStickyElementForDesktopAndTablet = function() {
	    if ( topOfWindow < topOfBottomContent && isHidden == false ) {
	      if ( isBundle ) {
	        if ($('#addBundleBtn').attr('disabled')) {
	          $('#sticky-price').empty();
	          $('#bundle-button-container').append($('#bundle-button'));
	        } else {
	          $('#sticky-price').empty();
	          $('#bundle-items-container').append($('#addBundleBtn'));
	        }
	      } else {
	    	$addButtonContainer.prepend($addButtonGroup);
	    	$addButtonContainer.prepend($qtyInput);
	    	$addButtonContainer.prepend($('#sticky-add-btn li'));
	    	//2 day delivery not zipped in
	    	$('#postal-popup-form-inline').append($('#postal-code-submit-btn'));
	      }
	      if (isBDApplication && isBDApplication === 'BD') {
	    	  $('#delivery-zipcode-form .get-zip-code-form').append($('#formProductDetails'));
	    	  $('#formProductDetails .outline').removeClass('hide');
	    	  $('#formProductDetails').validate();
	      }
	      $('#sticky-qty #minQtyText').off();
	      $('#bazaar-container').append($detailsBazaarVoice);
	      $('.math-table .your-price').append($price);
	      $('#check-availability-sticky').hide();
	      $hiddenSticky.hide(500);
	      isHidden = true;
	      $('#pdp-sticky-desktop .tablist').hide();
	    } else if ( topOfWindow >= topOfBottomContent + 10 && isHidden == true) {
	    
	      let selected_product = undefined; 	
    	  if (COSTCO.Product.isSingleItem(products))
    		 selected_product = COSTCO.Product.findItem(products[0],[]);
    	  else
    		 selected_product = COSTCO.Product.getSelectedBundleAndVariantItems()[0];
	    
    	  let stickyImageUrl = typeof(selected_product) === 'undefined' ? products[0][0].img_url ? products[0][0].img_url : products[0][0].parent_img_url  : selected_product.img_url ? selected_product.img_url : selected_product.parent_img_url ;
	      $('#initialProductImageSticky').attr('src', stickyImageUrl);
	      	      
	      $('#sticky-qty').append($qtyInput);
	      if ( isBundle ) {
	        $stickyAddBtn.append($('#addBundleBtn').attr('disabled') ? $('#bundle-button') : $('#addBundleBtn'));
	      } else {
	      // If item is OOS, set variables again beacause of updated content after Ajax call
	      if($('input[name="isOOSItem"]').length > 0) {
	      	$addButtonContainer =  ($('input[name="isOOSItem"]').length > 0) ? $('.notify-me-btn-area') : $('#ctas ul');	
	  	    $addButtonGroup = $isAppliance ? $('#check-availability-sticky') : ( ($('input[name="isOOSItem"]').length > 0) ? $addButtonContainer.find('input'): $addButtonContainer.children().not('#qty-input') );
	      }
	    	$('#check-availability-sticky').show();
	    	$stickyAddBtn.append($addButtonGroup);
	    	$stickyAddBtn.append($('#ctas ul li'));
	    	//2 day delivery not zipped in
	    	if (!isTwoDayDeliveryZipIn || ($('.two-day-delivery').length > 0 && $price.text().includes("- -.- -"))) {
	    		$stickyAddBtn.on('click', function(event) {
	    			event.preventDefault();
	    			$(window).scrollTop(0);
	    		});
	    	}
	      }
	      if (isBDApplication && isBDApplication === 'BD' && !$('#bdZipCookie').val().length > 0) {
	    	  $stickyAddBtn.append($('#formProductDetails'));
	    	  $('#formProductDetails .outline').addClass('hide');
	    	  $stickyAddBtn.on('click', function(event) {
	    		  event.preventDefault();
	    		  $(window).scrollTop(0);
	    		  $('#formProductDetails').validate();
	    		  $('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').rules('add', {
						required: true,
						'countryspecificpostalcode': true,
						messages: {
							required: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER,
							countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER
						}
					});
	    	  })
	      }
	      $('#sticky-qty #minQtyText').on('keypress', function(event) {
	    	  	COSTCO.Product.ChangeQuantityField($('#sticky-qty #minQtyText'));
	            if (event.keyCode === 13) {
	            	console.log('test event')
	              $('#add-to-cart-btn').click();
	            }
	      });
	      $('#sticky-bazaar').append($detailsBazaarVoice);
	      if (isBundle) {
	    	  $clonedPrice = ($price).clone();
	    	  $('#sticky-price').append($clonedPrice);
	    	  let $isChecked = $('[id^="checkbox-bundle-"]').is(':checked');
	    	  ($isChecked) ? $('#sticky-price').show() : $('#sticky-price').hide();
	    	  ($isChecked) ? $('.product-numbers').show() : $('.product-numbers').hide();
	      }
	      else if ((isTwoDayDeliveryZipIn && !(($('.two-day-delivery').length > 0 || $('.frozen-foods-badge').length > 0) && $price.text().includes("- -.- -"))) || 
	    		  (($('.two-day-delivery').length === 0 && $('.frozen-foods-badge').length === 0) && $price.is(':visible'))) {
	    	  $('#sticky-price').append($price);
	    	  $('.product-numbers').hide();
	      }
	      else {
	    	  $('.product-numbers').show();
	      }
	      $hiddenSticky.show(500);
	      $hiddenSticky.css('display','flex');
	      isHidden = false;
	      $('#pdp-sticky-desktop .tablist').show();
	    }
		$('#sticky').css('width', $('#product_tabs').width());
	  };
	  
	  let makeElementStickyForMobile = function() {
		let $isChecked = $('[id^="checkbox-bundle-"]').is(':checked');
		let $stickyContent = $isChecked ? $('#bundle-items-container') : $('#build-bundle-sticky');
		let $addButtonContainer = isBundle ? $stickyContent : ( $('input[name="isOOSItem"]').length > 0 ? $('.notify-me-btn-area') : $('#ctas ul'));
		let $isWarningMsg = ($("#prod-page-delivery").length > 0 && !$("#prod-page-delivery").hasClass('hide')) ||
							($("#edd-form-block").length > 0 && !$("#edd-form-block").hasClass('hide')) ||
							($( "#edd-message-block .warning" ).length > $( "#edd-message-block .warning.hide" ).length) || 
							($("#deliveryFailMessage").length > 0 && !$("#deliveryFailMessage").hasClass('hide'));
		let $appContent = $isWarningMsg ? $('#check-availability-sticky') : $('input[name="isOOSItem"]').length > 0 ? $addButtonContainer.find('input') : $addButtonContainer;
	    if ( $('#ctas').val() !== undefined ) {
	      let $buildABundle = $('#build-a-bundle');
	      let bottomOfElement;
	      $('#mobile-bazaar').append($detailsBazaarVoice);
	      if($('input[name="isOOSItem"]').length > 0) {
	      	bottomOfElement = isBundle ? $buildABundle.offset().top + $buildABundle.outerHeight() : $('.notify-me-body').offset().top + $('.notify-me-body').outerHeight();
	      } else {
	      	bottomOfElement = isBundle ? $buildABundle.offset().top + $buildABundle.outerHeight() : $('#ctas').offset().top + $('#ctas').outerHeight();
	      }
	      if ( topOfWindow < bottomOfElement && isSticky == true ) {
	    	$('#build-bundle-sticky').attr("hidden",true);
	    	$('#check-availability-sticky').attr("hidden",true);
	        $addButtonContainer = isBundle ? $stickyContent : ( $('input[name="isOOSItem"]').length > 0 ? $('#pdp-sticky-mobile') : $('#pdp-sticky-mobile ul'));
	        $appContent = $isWarningMsg ? $('#check-availability-sticky') : $('input[name="isOOSItem"]').length > 0 ? $addButtonContainer.find('input') : $addButtonContainer;
	        $appContent.children('#product-social-print-mobile').length > 0 && $appContent.children('#product-social-print-mobile').removeClass('hide');
	        if ( isBundle ) {
	        	$('#bundle-container').prepend($appContent);
	        	$('#bundle-accordion-collapse').removeClass('collapse');
	        	$('#bundle-accordion-collapse').css('height','');
	        }
	        else {
	        	if($('input[name="isOOSItem"]').length > 0) {
	        		$('.notify-me-btn-area').prepend($appContent);
	        	} else {
	        		$('#ctas').prepend($appContent);
	        	}
	        }
	      //2 day delivery not zipped in
        	if (!isTwoDayDeliveryZipIn || ($('.two-day-delivery').length > 0 && $price.text().includes("- -.- -"))) {
        		$('#postal-popup-form-inline').append($('#postal-code-submit-btn'));
        	}
	        isSticky = false;
	        $('#chatInlay').removeClass('mobile-inlay-sticker-shown');
	      } else if ( topOfWindow  >= bottomOfElement && isSticky == false ) {
	    	$('#build-bundle-sticky').removeAttr('hidden');
	    	$('#check-availability-sticky').removeAttr('hidden');
	    	$appContent.children('#product-social-print-mobile').length > 0 && $appContent.children('#product-social-print-mobile').addClass('hide');
	    	$('#pdp-sticky-mobile').append($appContent);
	    	$('#footer-bottom').addClass('sticky-pdp-footer');
	    	if (!isTwoDayDeliveryZipIn || ($('.two-day-delivery').length > 0 && $price.text().includes("- -.- -"))) {
	    		$('#pdp-sticky-mobile').append($('#postal-code-submit-btn'));
	    		$('#pdp-sticky-mobile').on('click', function(event) {
	    			event.preventDefault();
	    			$(window).scrollTop($('.product-interaction').offset().top - 1.2 * $('.product-interaction').outerHeight());
	    		});
        	}
	        let interectionElement = $('#pdp-sticky-mobile ul li:visible').length > 0 ? $('#pdp-sticky-mobile ul li:visible') : $('#pdp-sticky-mobile ul div:visible').not('.error');
	        if ($('#ctas').hasClass('hide') || interectionElement.length === 0 && !isBundle && (!$isAppliance) && isTwoDayDeliveryZipIn && !($('.two-day-delivery').length > 0 && $price.text().includes("- -.- -")) && !$isWarningMsg) {
	          $('#pdp-sticky-mobile').hide();
	        }
	        if ( isBundle ) {
	        	$('#bundle-accordion-collapse').addClass('collapse');
	        }
	        isSticky = true;
	        $('#chatInlay').addClass('mobile-inlay-sticker-shown');
	      }
	  	}
	  };
	  
	  let makeElementStickyForMobileBD = function() {
		  let $stickyElement = $('#pdp-sticky-mobile');
		  let bottomOfElement = $('.product-interaction').offset().top + $('.product-interaction').outerHeight();
				  if (topOfWindow < bottomOfElement) {
					  $('#zipFormatterFlag').after($('#formProductDetails'));
			    	  $('#formProductDetails .outline').removeClass('hide');
			    	  $('#formProductDetails').validate();
				  } else if (topOfWindow  >= bottomOfElement) { //check out if sticky element should be displayed
					  $stickyElement.append($('#formProductDetails'));
					  $('#footer-bottom').addClass('sticky-pdp-footer');
			    	  $('#formProductDetails .outline').addClass('hide');
			    	  $stickyElement.on('click', function(event) {
			    		  event.preventDefault();
			    		  $(window).scrollTop(0);
			    		  //generate validation on input field of zip code
			    		  $('#formProductDetails').validate();
			    		  $('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').rules('add', {
								required: true,
								'countryspecificpostalcode': true,
								messages: {
									required: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER,
									countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER
								}
							});
			    	  })
				  }
	  };
  window.addEventListener('load', (event) => {
	  $(window).scroll(function (event) {
		if ($('#productPage').val() && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
		  if (isBundle) {
		    topOfBottomContent = $('#addBundleBtn').attr('disabled') ? $('.bottom-content').offset().top : $('#bundle-container').offset().top + $('#bundle-container').outerHeight(true);
		  } else if($('#displaybundle').length > 0) {
	            topOfBottomContent = $('.bottom-content').offset().top + $('#displaybundle').outerHeight();
		  } else {
		    topOfBottomContent = $('.bottom-content').offset().top;
		  }
		  topOfWindow = $(window).scrollTop();
		  bottomOfWindow = topOfWindow + $(window).height();
	    
		  //checks if page is in MOBILE or TABLET/DESKTOP display view, and calls the appropriate function
		  if ( window.innerWidth > 768 ) {
	        showStickyElementForDesktopAndTablet();
	      } else if (isBDApplication === 'BD')  {
	    	  if ($('#bdZipCookie').val().length > 0) {
		    	  makeElementStickyForMobile();
	    	  } else {
	    		  makeElementStickyForMobileBD();
	    	  }
	      } else {
	    	  window.onbeforeunload = function () {
	    		  window.scrollTo(0);
	    	  }
	    	  makeElementStickyForMobile();
	      }
	    }
	  });
	  var scheduledDeliverable = $('#scheduledDeliverable').val()=="true"?true:false;
	  if( (COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant') && !scheduledDeliverable
	  	&& $('#isBDAppVar').val() != 'BD' && !COSTCO.CMath.pdpPageloadComplete && isPDPVariantGreyOutEnabled == 'true' && !(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag)) {
		  if(COSTCO.CMath.isErrorlocationControlleditem){ 
			  if($('div.buyinstoreonly.MuiBox-root').length >0){
				  COSTCO.CMath.isWarehouseEnabled=true;
				}else{
					COSTCO.CMath.isWarehouseEnabled=false;
				}
		  }
		  if(!COSTCO.CMath.iskitsbundle){
			  COSTCO.Product.findOOSitem(true);
		  }
	  }else {
		  if( $('#isBDAppVar').val() != 'BD' && (isPDPVariantGreyOutEnabled == 'false' || (Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) ||scheduledDeliverable) && !COSTCO.CMath.pdpPageloadComplete && (COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant') ){
			  COSTCO.CMath.pdpPageloadComplete = true;
		  }
	  }
	  if(COSTCO.CMath.iskitsbundle){
		  let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
		  COSTCO.CMath.onloadSelectOption = optionsSelected; 
		  for(var i=0;i<=optionsSelected.length;i++){
    		  $('#swatchesID-productOption0'+i+' span.selection-item').each(function(){
                  var selectedTile = $(this).attr("automation-id");
                  var tileId = selectedTile.split('_')[1];
    			});
		  }
		  COSTCO.CMath.setKbLabel();
		  $('#theSwatches').remove();
		  
		  if(COSTCO.Product.item_type === 'single_variant' || COSTCO.Product.item_type === 'multi_variant' ){
			  COSTCO.CMath.hideKBSkeletone()
		  }
	  }
	  var currentUrl  = window.location.href;
	  var swatchParam = window.location.href.split('?')[1];
	  if(COSTCO.CMath.iskitsbundle && swatchParam == 'isSwatchReload'){
		  COSTCO.Product.focusToNavPdpTabHeader15();
	  }
	  COSTCO.CMath.kbPageloadComplete = true;
	  if ( window.innerWidth > 768 ) {
		 if($('#bazaar-container').length > 0 && $('#bazaar-container').html().trim() == '' ){
			 $('#bazaar-container').append($detailsBazaarVoice);
		 }
	  } else {
		  if($('#mobile-bazaar').length > 0 && $('#mobile-bazaar').html().trim() == ''){
		  	$('#mobile-bazaar').append($detailsBazaarVoice);
  		  }
	  }
  });
		
  $(window).resize(function() {
	  if (!$("input").is(":focus")) {
		if ($('#productPage').val() && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	      if (isBundle) {
	        topOfBottomContent = $('#addBundleBtn').attr('disabled') ? $('.bottom-content').offset().top : $('#bundle-container').offset().top + $('#bundle-container').outerHeight(true);
	      } else if($('#displaybundle').length > 0) {
	            topOfBottomContent = $('.bottom-content').offset().top + $('#displaybundle').outerHeight();
		  } else {
	        topOfBottomContent = $('.bottom-content').offset().top;
	      }
	      topOfWindow = $(window).scrollTop();
	      bottomOfWindow = topOfWindow + $(window).height();
		
  		  //checks if page is in MOBILE or TABLET/DESKTOP display view, and modifies sticky element accordingly
  		  if ( window.innerWidth > 768 && isBDApplication === 'BC' ) {
  		    if ( $('#pdp-sticky-mobile ul').length > 0 || $('#bundle-container').hasClass('fixed-footer-bundle') ) {
  		      $addButtonContainer = isBundle ? $('#bundle-items-container') : $('#pdp-sticky-mobile ul');
  	          isBundle ? $('#bundle-container').prepend($addButtonContainer) : $('#ctas').prepend($addButtonContainer);
  	          if ( isBundle ) {
        	    $('#bundle-accordion-collapse').removeClass('collapse');
        	    $('#bundle-accordion-collapse').css('height','');
              }
              isSticky = false;
              showStickyElementForDesktopAndTablet();
            }
	  		if($('#bazaar-container').length > 0 && $('#bazaar-container').html().trim() == '' ){
	 			 $('#bazaar-container').append($detailsBazaarVoice);
	 		}
          } else {
            if ( isBundle ) {
              $('#bundle-button-container').append($('#addBundleBtn').attr('disabled') ? $('#bundle-button') : $('#addBundleBtn'));
            } else {
              if(!($('input[name="isOOSItem"]').length > 0)) {
                $addButtonContainer.prepend($addButtonGroup);
                $addButtonContainer.prepend($qtyInput);
                $addButtonContainer.prepend($('#sticky-add-btn li'));
              }
            }
            $('.math-table .your-price').append($price);
            $('#product-body-model-number').after($detailsBazaarVoice);
            $hiddenSticky.hide();
            isHidden = true;
            if (isBDApplication && isBDApplication === 'BD'){
        	    makeElementStickyForMobileBD();
            } else {
        	  makeElementStickyForMobile();
            }
          }
        }
	  }
	  });
	  
	  $(document).on("click", '.tablist a', function() {
		  let clickedTab = $(this);
		  let clickedTabHref = $(this).attr('href');
		  $('.tablist li').removeClass("active");
		  $('.tablist li a').removeClass("active");
		  $('.tablist li a').attr("aria-current", "false");
		  $('.tablist a[href=' + clickedTabHref +']').addClass("active");
		  $('.tablist a[href=' + clickedTabHref +']').parent().addClass("active");
		  $('.tablist a[href=' + clickedTabHref +']').attr("aria-current", "true");
		  
	  });
	  
	  $(document).on('keydown', '.tablist a', function(e) {
	  	if(e.which === 13) {
	  		let clickedTabHref = $(this).attr('href');
	  		this.click();
	  		$('div'+clickedTabHref+' h3').attr('tabindex','0');
	  		$('div'+clickedTabHref+' h3').focus().on('focusout', function() {
	  			$(this).attr('tabindex','-1');
	  		});
		  }
	  });
	},
	
	
	invokeInventoryBatchAPIcallforSingleitem: function(itemId){
		var isBopiw = $('#isBOPIWItemForMemberInfo').val();
		var selectedWarehouse  = "";
		if (isEnableBOPIWUpdatesSync == 'true' && isBopiw == 'true') {
			selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
		}
		else if(COSTCO.CMath.isBopiwEnabled && !COSTCO.CMath.isWioEnabled && isBopiw == 'true'){
			selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
		}
		else if (COSTCO.CMath.isWioEnabled && !COSTCO.CMath.isBopiwEnabled && isBopiw == 'false'){
			selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
		}
		else if(COSTCO.CMath.isWioEnabled && COSTCO.CMath.isBopiwEnabled){
			selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
		}
		  let _data = {
				  "distributionCenters":[""],   
				  "selectedWarehouse": selectedWarehouse, 
				      "itemNumbers": [itemId]
				}
			var clientIdentifier=$('#besBatchCLientIdentifier').val();
		   	var batchApiURL=$('#baseUriForInventoryBatch').val();
			var costcoEnv = $('#costcoEnvironmentForBatchInv').val(); //COSTCO.Product.validateCostcoEnv();
			var costcoEnvECOMEnabled = $('#batchApiCostcoEnvECOMEnabled').val();
            if(typeof costcoEnvECOMEnabled !== "undefined" && costcoEnvECOMEnabled === "true"){ 
				if(costcoEnv === "" || costcoEnv === null || costcoEnv === 'null'){
					costcoEnv = "ECOM";
				}
            }
			var costcoService="restInventory";	
			
			 var inventoryBatchAkamaiCacheEnabled = $('#inventoryBatchAkamaiCacheEnabled').val();
			 var inventoryBatchEnabledV2 = $('#inventoryBatchEnabledV2').val();
			 var akamaiHeaders = {};
			 akamaiHeaders["Content-type"] = "application/json; charset=UTF-8";
			 akamaiHeaders["costco.env"] = costcoEnv;
			 akamaiHeaders["client-identifier"] = clientIdentifier;
			 akamaiHeaders["costco.service"] = costcoService;
			 
			 if(inventoryBatchAkamaiCacheEnabled === "true"){
				 var batchVariantCacheKey = itemId+"-"+COSTCO.Product.getZipcode()+"-"+selectedWarehouse;;
				 akamaiHeaders["batch-variant-cache-key"] = batchVariantCacheKey;
			 } 
			 var batchApiURL;
			    if(inventoryBatchEnabledV2 === "true"){
					 batchApiURL = $('#baseUriForInventoryBatchV2').val();
				 }
				 else{
					 batchApiURL = $('#baseUriForInventoryBatch').val();
				 }
			 
				fetch(batchApiURL, {
				  method: "POST",
				  body: JSON.stringify(_data),
				  headers: akamaiHeaders
				})
				.then(response => {
				 if (response.status >= 200 && response.status <= 299) {
					 		return response.json();
				 } else {
					 		throw Error(response.statusText);
				 }
				 })
				.then(jsonResponse => {
					var programType = jsonResponse[0].programTypes;
					var inwarehousepgType;
				   if(programType!=null && programType.hasOwnProperty("inWarehouse") && Array.isArray(programType.inWarehouse)){
					   if(programType.inWarehouse[0].length!=0){
						   inwarehousepgType = programType.inWarehouse[0]; 
					   }
				   }
				   else {
					   inwarehousepgType =  programType.inWarehouse;
					   }
				   if( (null != inwarehousepgType && (inwarehousepgType.availability =='NOSTOCK'  )&&  (COSTCO.CMath.isWarehouseEnabled)) || (null == inwarehousepgType ||  !COSTCO.CMath.isWarehouseEnabled )){
							   $('.crumbs').show();
			        			$('#product-page').addClass('hide');
			        			$('#not_found_error_pdp').removeClass('hide');
			        			
			        			// set city and zip code
			        			var storeLocation = COSTCO.LWSearch.getCookie('STORELOCATION');
			        			console.log("storeLocation : "+storeLocation)
			    				if (storeLocation !== "" || storeLocation != null) {
			    					var storeLocation_ = JSON.parse(unescape(storeLocation));
			    					var notfound_deliveryWarehouse = storeLocation_.storeLocation.city;
			    					$('#notfound_deliveryWarehouse').html(notfound_deliveryWarehouse);
			    				}
			    				var notfound_deliveryLocation = COSTCO.LWSearch.getCookie('invCheckPostalCode');
			    				$('#notfound_deliveryLocation').html(notfound_deliveryLocation);
			        			
                                $('#pdp-sticky-desktop').hide();
                                $('#pdp-sticky-mobile').hide();
						   }
						}).catch((error) => {
					 console.log(error);
					 
					});
				
	},
	
	pickUpinDistribution: function(cookieDistributionCenters, pickUpCenters){
		for(let centers of pickUpCenters){
			if(!cookieDistributionCenters.includes(centers))
				cookieDistributionCenters.push(centers);
		}
		return cookieDistributionCenters;
	},
	/**
	 * This method is for checkingwarehouse cookie to see whether 3pl location and pickupcenters is present and 
	 * return flag
	 */
	checkifOutofNetworkLocation:function(){
		var cookieDistributionCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('distributionCenters');
		var pickUpCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('pickUpCenters');
		var isOutOfNetworkLocation = false;
		if(pickUpCenters != undefined && pickUpCenters.length != 0 && cookieDistributionCenters != undefined && cookieDistributionCenters.length != 0 && !cookieDistributionCenters.includes('-3pl')) {
			for(let centers of pickUpCenters) {
				if(!cookieDistributionCenters.includes(centers)) {
					isOutOfNetworkLocation = true;
				}
			}
		}
		return isOutOfNetworkLocation;
	},
	/**
     * This method is for call inventory batch API call
     * @return void
     */
	invokeInventoryBatchAPIcall: function(optionsSelected){
		var isBopiw = $('#isVariantBopiw').val();
		var ltlFeatureFlag = $('#isLtlFeatureFlagOn').val();
		var selectedWarehouse  = "";
		if (isEnableBOPIWUpdatesSync == 'true' && isBopiw == 'true') {
			selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
		}
		else if(COSTCO.CMath.isBopiwEnabled && !COSTCO.CMath.isWioEnabled && isBopiw == 'true'){
			selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
		}
		else if (COSTCO.CMath.isWioEnabled && !COSTCO.CMath.isBopiwEnabled && isBopiw == 'false'){
			selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
		}
		else if(COSTCO.CMath.isWioEnabled && COSTCO.CMath.isBopiwEnabled){
			selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
		}
		  var distributionCenters = [];
		  var cookieDistributionCenters = [];
		  var cookieGroceryCenters = [];
		  var pickUpCenters = [];
		  var hasLTLPgType = false;
		  cookieDistributionCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('distributionCenters');
		  pickUpCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('pickUpCenters');
		  if(ltlFeatureFlag === "true" && pickUpCenters != undefined && pickUpCenters.length != 0 ){
			  for(let i=0;i<listOfObjects.length;i++){
				  if(listOfObjects[i].programType.includes('LTLPickUp')){
					  hasLTLPgType = true;
					  break;
				  }
			  }
		  }
		  if(hasLTLPgType == true){
			  cookieDistributionCenters = COSTCO.Product.pickUpinDistribution(cookieDistributionCenters,pickUpCenters);
		  }
		  cookieGroceryCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('groceryCenters');
		  distributionCenters =  cookieDistributionCenters.concat(cookieGroceryCenters);
		  var JsonResponseSum = 0;
		 itemIdMap.forEach((itemIdArray,keys)=>{
		  let _data = {
				  "distributionCenters":distributionCenters,   
				  "selectedWarehouse": selectedWarehouse, 
				      "itemNumbers": itemIdArray
				}
		  
		 var costcoEnv = $('#costcoEnvironmentForBatchInv').val(); //COSTCO.Product.validateCostcoEnv();
		 var costcoEnvECOMEnabled = $('#batchApiCostcoEnvECOMEnabled').val();
		 if(typeof costcoEnvECOMEnabled !== "undefined" && costcoEnvECOMEnabled === "true"){ 
				if(costcoEnv === "" || costcoEnv === null || costcoEnv === 'null'){
					costcoEnv = "ECOM";
				}	
         }
		 var costcoService="restInventory";	 
		 var clientIdentifier=$('#besBatchCLientIdentifier').val();
		 
		 var inventoryBatchAkamaiCacheEnabled = $('#inventoryBatchAkamaiCacheEnabled').val();
		 var inventoryBatchEnabledV2 = $('#inventoryBatchEnabledV2').val();
		 var akamaiHeaders = {};
		 akamaiHeaders["Content-type"] = "application/json; charset=UTF-8";
		 akamaiHeaders["costco.env"] = costcoEnv;
		 akamaiHeaders["client-identifier"] = clientIdentifier;
		 akamaiHeaders["costco.service"] = costcoService;
		 var itemIdArraysort=  itemIdArray.sort((a, b) => a - b);
		 if(inventoryBatchAkamaiCacheEnabled === "true"){
			 var batchVariantCacheKey = itemIdArraysort+"-"+COSTCO.Product.getZipcode()+"-"+selectedWarehouse;;
			 akamaiHeaders["batch-variant-cache-key"] = batchVariantCacheKey;
		 } 
		 
		 var batchApiURL;
		 if(inventoryBatchEnabledV2 === "true"){
			 batchApiURL =$('#baseUriForInventoryBatchV2').val();
		 }
		 else{
			 batchApiURL=$('#baseUriForInventoryBatch').val();
		 }
				fetch(batchApiURL, {
				  method: "POST",
				  body: JSON.stringify(_data),
				  headers: akamaiHeaders
				})
				.then((response) => {
				    if (response.status >= 200 && response.status <= 299) {
				        return response.json();
				      } else {
				        throw Error(response.statusText);
				      }
				    }) 
				.then(jsonResponse => {
						if(!window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi){
							COSTCO.CMath.varItemJSON.push(jsonResponse);
							window.reactObj.batchApiResponse.apiResponse = COSTCO.CMath.varItemJSON;
							try {
								if(COSTCO.CMath.varItemJSON.length >0) {
									window.wioEventBus.publish('notifyBatchApiComplete',COSTCO.CMath.varItemJSON);
								}
							} catch(e) {
								console.log(e);
							}
						}
						Object.entries(jsonResponse).forEach((entry) => {
						   const [key, value] = entry;
				  
						   var itemarrayStatus = {};
						  var variantitemArray ={};
						  const valuesToCheck = ['NOSTOCK'];
						   var	programType = value.programTypes;
						   var siteControlledpgType,locationControlledpgType,inwarehousepgType,ltlPickUpPgType;
							  
						   if(programType!=null && programType.hasOwnProperty("locationControlledInventory") && Array.isArray(programType.locationControlledInventory)){
							   const locationControlledList = (programType && programType.locationControlledInventory) || [];
							   const locationControlledpgType = Array.isArray(locationControlledList) &&
							   locationControlledList.every(item => valuesToCheck.includes(item.availability));
						   }
						   else if(programType.locationControlledInventory!=undefined){
							   locationControlledpgType = programType.locationControlledInventory;
						   }
						   if(programType!=null && programType.hasOwnProperty("siteControlledInventory") &&  Array.isArray(programType.siteControlledInventory)){
							   const siteControlledList  = (programType && programType.siteControlledInventory) || [];
							   siteControlledpgType = Array.isArray(siteControlledList) &&
							   siteControlledList.every(item => valuesToCheck.includes(item.availability));
							  
						   }
						   else if(programType.siteControlledInventory!=undefined){
							   siteControlledpgType = programType.siteControlledInventory;
						   }
						   if(programType!=null && programType.hasOwnProperty("inWarehouse") && Array.isArray(programType.inWarehouse)){
							   if(programType.inWarehouse[0].length!=0){
								   inWarehousepgType = programType.inWarehouse[0]; 
							   }  
						   }
						   else {
							   inWarehousepgType = programType.inWarehouse;
						   }
						   if(programType!=null && programType.hasOwnProperty("ltlPickUp") && Array.isArray(programType.ltlPickUp)){
							   ltlPickUpPgType = programType.ltlPickUp[0]; 
							   const ltlPickUpList  = (programType && programType.ltlPickUp) || [];
							   ltlPickUpPgType = Array.isArray(ltlPickUpList) &&
							   ltlPickUpList.every(item => valuesToCheck.includes(item.availability));
						   }
						   else if(programType.ltlPickup!=undefined){
							   ltlPickUpPgType = programType.ltlPickUp;
						   }
						   
						   if((undefined !=  siteControlledpgType && (siteControlledpgType || siteControlledpgType.availability == 'NOSTOCK') )
									   || (undefined != locationControlledpgType && (locationControlledpgType || locationControlledpgType.availability=='NOSTOCK')) || COSTCO.CMath.isErrorlocationControlleditem){
								 
								itemarrayStatus ["OL"] = '0';
						   }else {
							   itemarrayStatus ["OL"] = '1';
						   }
							   
						   if((null != inWarehousepgType && (inWarehousepgType.availability == 'INSTOCK' || inWarehousepgType.availability == 'LOWSTOCK') &&  COSTCO.CMath.isWarehouseEnabled) 
								   || (ltlPickUpPgType != undefined && (!ltlPickUpPgType ||ltlPickUpPgType.availability == 'INSTOCK'))){
							  
							   itemarrayStatus ["WH"] = '1';
						   }
						   else if((null != inWarehousepgType && inWarehousepgType.availability == 'NOSTOCK' &&  COSTCO.CMath.isWarehouseEnabled )|| null == inWarehousepgType || !COSTCO.CMath.isWarehouseEnabled){
							   itemarrayStatus ["WH"] = '0';
						   }
							   variantitemArray[value.itemNumber] =itemarrayStatus;
							   COSTCO.CMath.variantJSON.push(variantitemArray);
							  
						   JsonResponseSum++;
						   if(JsonResponseSum == listOfObjects.length ){				
							  
								   var len = optionsSelected.length;
								   localStorage.setItem("variantStatus",JSON.stringify(COSTCO.CMath.variantJSON));
								  if($('#swatches-productOption0'+parseInt(len-1)+'').length > 0 ){
							   		COSTCO.Product.strikeOosSwatches(optionsSelected);
								   }else if($('.varis-v2[automation-id=varisSwatch_0'+parseInt(len-1)+']').length>0 ){
									   COSTCO.Product.grayOutDropDown(optionsSelected);
								   }
							   	}
						 });
						
					
				})
				.catch(err => console.log(err));
					   
	});
		  
	

					
					
	},
	/**
     * This method is for Strike out lower level Swatches
     * @return void
     */
	strikeOosSwatches : function(optionsSelected){
		var len = optionsSelected.length;
		var option ="option"+parseInt(len);
		if(len ==3){
			var option0 ="option"+parseInt(len-2);
			var level0 =optionsSelected[len-3] ;
			var option1 ="option"+parseInt(len-1);
			var level1 =optionsSelected[len-2] ;
		}else if(len ==2){
			var option0 ="option"+parseInt(len-1);
			var level0 =optionsSelected[len-2] ;
		}

for(var i = 0; i < listOfObjects.length; i++) {
	 var obj = listOfObjects[i];
	 for(var k in COSTCO.CMath.variantJSON){
	   var val = COSTCO.CMath.variantJSON[k];
	  for(var j in val){
       var sub_key = j;
       var sub_val = val[j];
       if(sub_key == listOfObjects[i].itemId){
    	 
       	
       	if( COSTCO.CMath.isWarehouseEnabled){
       	 var uptitemarrayStatus = {};
   	  var uptvariantitemArray ={};
       	
       	  uptitemarrayStatus ["OL"] = sub_val.OL;
       		if(listOfObjects[i].isaVariant == 'true'){
       			uptitemarrayStatus ["WH"] ='0';
       		}else{
       			 uptitemarrayStatus ["WH"] =sub_val.WH;
       		}
       	 uptvariantitemArray[listOfObjects[i].itemId] =uptitemarrayStatus;
 	    COSTCO.CMath.variantJSON[k] =uptvariantitemArray;
 	    localStorage.setItem('variantStatus',JSON.stringify(COSTCO.CMath.variantJSON));
       	}
       }
	  }}
       	/*following if condtion for skipping strike out for current selected. 
    	 * Even selected product is NOSTOCK in batch API call and it is INSTOCK in Ajax call(means INSTOCK in wcs DB) prioprity is given to WCS response
    	 *  */
	 if(COSTCO.CMath.invokeAjaxCall){
	 for(var k in COSTCO.CMath.variantJSON){
		   var val = COSTCO.CMath.variantJSON[k];
		  for(var j in val){
	       var sub_key = j;
	       var sub_val = val[j];
	       if(sub_key == listOfObjects[i].itemId){
    	 if(optionsSelected[len-1] == obj[option] && level0 == obj[option0] && ((COSTCO.CMath.invAvailableAjax || COSTCO.CMath.isBackOrderFlag) && COSTCO.Product.isEDDStatusAvailable )){
    		 if(len==3 &&  level1 == obj[option1]){
    			 var uptitemarrayStatus = {};
       		  var uptvariantitemArray ={};
	       	  uptitemarrayStatus ["OL"] = '1';
       		 uptitemarrayStatus ["WH"] =sub_val.WH;
       		 uptvariantitemArray[listOfObjects[i].itemId] =uptitemarrayStatus;
           	 COSTCO.CMath.variantJSON[k] =uptvariantitemArray;
     		    localStorage.setItem('variantStatus',JSON.stringify( COSTCO.CMath.variantJSON));
    		 }else{
    	
    		 var uptitemarrayStatus = {};
    		  var uptvariantitemArray ={};
	    	 uptitemarrayStatus ["OL"] = '1';
    		 uptitemarrayStatus ["WH"] =sub_val.WH;
    		 uptvariantitemArray[listOfObjects[i].itemId] =uptitemarrayStatus;
        	 COSTCO.CMath.variantJSON[k] =uptvariantitemArray;
  		    localStorage.setItem('variantStatus',JSON.stringify( COSTCO.CMath.variantJSON));
    		 }
       }else{
    	  
    	   if(optionsSelected[len-1] == obj[option] && level0 == obj[option0] && (((!COSTCO.CMath.invAvailableAjax || !COSTCO.CMath.isBackOrderFlag ) && !COSTCO.Product.isEddItem) || !COSTCO.Product.isEDDStatusAvailable  || (!COSTCO.CMath.invAvailableAjax && COSTCO.Product.isEDDStatusAvailable)  )){
    		   if(len==3 &&  level1 == obj[option1]){
    	   var uptitemarrayStatus = {};
 		  var uptvariantitemArray ={};
 		  uptitemarrayStatus ["OL"] = '0';
 		 uptitemarrayStatus ["WH"] =sub_val.WH;
 		 uptvariantitemArray[listOfObjects[i].itemId] =uptitemarrayStatus;
     	 COSTCO.CMath.variantJSON[k] =uptvariantitemArray;
		    localStorage.setItem('variantStatus',JSON.stringify( COSTCO.CMath.variantJSON));
    		   }else{
    		    	 var uptitemarrayStatus = {};
    	    		  var uptvariantitemArray ={};
    	    		  uptitemarrayStatus ["OL"] = '0';
    	    		 uptitemarrayStatus ["WH"] =sub_val.WH;
    	    		 uptvariantitemArray[listOfObjects[i].itemId] =uptitemarrayStatus;
    	        	 COSTCO.CMath.variantJSON[k] =uptvariantitemArray;
    	  		    localStorage.setItem('variantStatus',JSON.stringify( COSTCO.CMath.variantJSON));
    	    		 }
       }
       }
       }
	  }
	   
	  }
	 }
	 for(var k in COSTCO.CMath.variantJSON){
		   var val = COSTCO.CMath.variantJSON[k];
		  for(var j in val){
	       var sub_key = j;
	       var sub_val = val[j];
	       if(sub_key == listOfObjects[i].itemId){
	    	   if(sub_val.OL ==  '0' && sub_val.WH == '0' ){
		      let variable;
  			  variable= $('input[value=' +obj[option]+ ']').next().attr("automation-id");
  		   if(COSTCO.Product.item_type === 'multi_variant' ){
  			   if($("input[automation-id='variationOptions_"+obj[option]+"']:checked").length ){
  					$('span[automation-id='+variable+']').addClass("select-span1-OOS");
  					//folowing  code for appending OOS label in lower level
  						var $selectedOptionLabel = $('label[for=productOption0'+parseInt(len-1)+']');
  						var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue'); 
  						if(! $selectedOptionValue.text().includes(' - '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT )){
  						$selectedOptionValue.append(' - '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
  						}
  						$selectedOptionValue.show();
  				}else{
  					$('span[automation-id='+variable+']').removeClass("select-span1-OOS");
  					
  				}
  			   if(!$('span[automation-id='+variable+']').hasClass('span1-outofstock')) {
  				   $('span[automation-id='+variable+']').addClass("span1-outofstock");
  				 
  			   }
  			   if(! $('span[automation-id='+variable+']').children('p').length){
  	                $('span[automation-id='+variable+']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
  	                $('span[automation-id='+variable+']').find('.p-outofstock span.sr-only').text(' '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
  	                }  
  			}else if(COSTCO.Product.item_type === 'single_variant') {
  				// $('.selection-item').removeClass("select-span1-OOS");
  				  if($("input[automation-id='variationOptions_"+obj[option]+"']:checked").length ){
  						$('span[automation-id='+variable+']').addClass("select-span1-OOS");
  						//folowing  code for appending OOS label in lower level
  							var $selectedOptionLabel = $('label[for=productOption00]');
  							var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue'); 
  							if(! $selectedOptionValue.text().includes(' - '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)){
  							$selectedOptionValue.append(' - '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
  							}
  							$selectedOptionValue.show();
  					}else{
  						$('span[automation-id='+variable+']').removeClass("select-span1-OOS");
  						
  					}
  				  if(!$('span[automation-id='+variable+']').hasClass('span1-outofstock')) {
  					  $('span[automation-id='+variable+']').addClass("span1-outofstock");
  					  if(! $('span[automation-id='+variable+']').children('p').length){
  			                $('span[automation-id='+variable+']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
  			                $('span[automation-id='+variable+']').find('.p-outofstock span.sr-only').text(' '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
  			                }  
  				  }
  			}
  	   }
	       }
		  }
	 }	   
}

	// following code striking upper swatch and dropdown

		if($('#swatches-productOption0'+parseInt(optionsSelected.length-2)+'').length > 0 ){
			COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
		}else if($('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-2)+']').length>0 ){
			COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
		}
		//For 3 level varaints in order to retain  top level strike when swaping between other top levels
		COSTCO.CMath.strikealllevelvariants();
    	
	},
	/**
     * This method is for OOS Drop down
     * @return void
     */
	grayOutDropDown : function(optionsSelected){
		 var len = optionsSelected.length;
		 var option ="option"+parseInt(len);
		 if(len ==3){
			 var option0 ="option"+parseInt(len-2);
			 var level0 =optionsSelected[len-3] ;
			 var option1 ="option"+parseInt(len-1);
				var level1 =optionsSelected[len-2] ;
			 }else if(len ==2){
			 	var option0 ="option"+parseInt(len-1);
			 	var level0 =optionsSelected[len-2] ;
			 }
	for(var i = 0; i < listOfObjects.length; i++) {
		 var option ="option"+parseInt(len);
		 var obj = listOfObjects[i];
		for(var k in COSTCO.CMath.variantJSON){
		   var val = COSTCO.CMath.variantJSON[k];
		  for(var j in val){
	       var sub_key = j;
	       var sub_val = val[j];
	       if(sub_key == listOfObjects[i].itemId){
	    	 
	       	if( COSTCO.CMath.isWarehouseEnabled){
	       	 var uptitemarrayStatus = {};
	   	  var uptvariantitemArray ={};
	       	
	       	  uptitemarrayStatus ["OL"] = sub_val.OL;
	       		if(listOfObjects[i].isaVariant == 'true'){
	       			uptitemarrayStatus ["WH"] ='0';
	       		}else{
	       			 uptitemarrayStatus ["WH"] =sub_val.WH;
	       		}
	       	 uptvariantitemArray[listOfObjects[i].itemId] =uptitemarrayStatus;
	 	    COSTCO.CMath.variantJSON[k] =uptvariantitemArray;
	 	    localStorage.setItem('variantStatus',JSON.stringify(COSTCO.CMath.variantJSON));
	       	}}
		  }
		}
		/*following if condtion for skipping strike out for current selected. 
	    	 * Even selected product is NOSTOCK in batch API call and it is INSTOCK in Ajax call(means INSTOCK in wcs DB) prioprity is given to WCS response
	    	 *  */
		 if(COSTCO.CMath.invokeAjaxCall){
		for(var k in COSTCO.CMath.variantJSON){
			   var val = COSTCO.CMath.variantJSON[k];
			  for(var j in val){
		       var sub_key = j;
		       var sub_val = val[j];
		       if(sub_key == listOfObjects[i].itemId){
	    	 
	    		 if(optionsSelected[len-1] == obj[option] && level0 == obj[option0] && ((COSTCO.CMath.invAvailableAjax || COSTCO.CMath.isBackOrderFlag) && COSTCO.Product.isEDDStatusAvailable )){
	    		 if(len==3 &&  level1 == obj[option1]){
	    			 var uptitemarrayStatus = {};
	       		  var uptvariantitemArray ={};
	       		  uptitemarrayStatus ["OL"] = '1';
	       		 uptitemarrayStatus ["WH"] =sub_val.WH;
	       		 uptvariantitemArray[listOfObjects[i].itemId] =uptitemarrayStatus;
	           	 COSTCO.CMath.variantJSON[k] =uptvariantitemArray;
	     		    localStorage.setItem('variantStatus',JSON.stringify( COSTCO.CMath.variantJSON));
	    		 }else{
	    	
	    		 var uptitemarrayStatus = {};
	    		  var uptvariantitemArray ={};
	    		  uptitemarrayStatus ["OL"] = '1';
	    		 uptitemarrayStatus ["WH"] =sub_val.WH;
	    		 uptvariantitemArray[listOfObjects[i].itemId] =uptitemarrayStatus;
	        	 COSTCO.CMath.variantJSON[k] =uptvariantitemArray;
	  		    localStorage.setItem('variantStatus',JSON.stringify( COSTCO.CMath.variantJSON));
	    		 }
	       }else{
	    	   if(optionsSelected[len-1] == obj[option] && level0 == obj[option0] && (((!COSTCO.CMath.invAvailableAjax || !COSTCO.CMath.isBackOrderFlag ) && !COSTCO.Product.isEddItem) || !COSTCO.Product.isEDDStatusAvailable || (!COSTCO.CMath.invAvailableAjax && COSTCO.Product.isEDDStatusAvailable))){
	    	  if(len==3 &&  level1 == obj[option1]){
	    	   var uptitemarrayStatus = {};
	 		  var uptvariantitemArray ={};
	 		  uptitemarrayStatus ["OL"] = '0';
	 		 uptitemarrayStatus ["WH"] =sub_val.WH;
	 		 uptvariantitemArray[listOfObjects[i].itemId] =uptitemarrayStatus;
	     	 COSTCO.CMath.variantJSON[k] =uptvariantitemArray;
			    localStorage.setItem('variantStatus',JSON.stringify( COSTCO.CMath.variantJSON));
	    		   }else{
	    		    	 var uptitemarrayStatus = {};
	    	    		  var uptvariantitemArray ={};
	    	    		  uptitemarrayStatus ["OL"] = '0';
	    	    		 uptitemarrayStatus ["WH"] =sub_val.WH;
	    	    		 uptvariantitemArray[listOfObjects[i].itemId] =uptitemarrayStatus;
	    	        	 COSTCO.CMath.variantJSON[k] =uptvariantitemArray;
	    	  		    localStorage.setItem('variantStatus',JSON.stringify( COSTCO.CMath.variantJSON));
	    	    		 }
	       }
	       }
	       }
	       }
			}
			}
		 for(var k in COSTCO.CMath.variantJSON){
			   var val = COSTCO.CMath.variantJSON[k];
			  for(var j in val){
		       var sub_key = j;
		       var sub_val = val[j];
		       if(sub_key == listOfObjects[i].itemId){
				if(sub_val.OL ==  '0' && sub_val.WH == '0' ){
				let variable;
			   var obj = listOfObjects[i];
			   var len = optionsSelected.length;
			   if(! $('.varis-v2 option[automation-id=varisOption_'+obj[option]+']').hasClass('out-of-stock')) {
			   $('.varis-v2 option[automation-id=varisOption_'+obj[option]+']').append('<span class="out-of-stock-text"></span>');
			   $('.varis-v2 option[automation-id=varisOption_'+obj[option]+']').find('.out-of-stock-text').text('  '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
		       $('.varis-v2 option[automation-id=varisOption_'+obj[option]+']').addClass("out-of-stock");
		   	var $selectedOptionLabel = $('label[for=productOption0'+parseInt(len-1)+']');
			var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
			if(optionsSelected[len-1] == obj[option] && !$selectedOptionValue.text().includes(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)){
				const textToReplace =  $selectedOptionValue.text();
				const newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
				$selectedOptionValue.text(newText);
				$selectedOptionValue.append(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);

			}
			$selectedOptionValue.show();
			   }
	   }
		       }
			  }
		 }
	
	}
	  if($('#swatches-productOption0'+parseInt(optionsSelected.length-2)+'').length > 0 ){
	   		COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
		   }else if($('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-2)+']').length>0 ){
			   COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
		   }
	//For 3 level varaints in order to retain  top level strike when swaping between other top levels
		COSTCO.CMath.strikealllevelvariants();
	},
	/**
     * This method is for strike upper level swatch
     * @return void
     */
	grayOutUpperLevelDropDown : function(optionsSelected){
		var lowerLevelOOSCount ;
		  var lowerLevelCount;
		  var lowerSwatch=$('#swatches-productOption0'+parseInt(optionsSelected.length-1)+'').length > 0 ;
			var lowerDropDown=$('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-1)+']').length>0 ;
			//following code for checking lower level is drop down or pills. if  all lower level items are OOS will strike out upper level
		 if(lowerDropDown){
			 lowerLevelCount = $('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-1)+']').find('option.opt:not(:disabled)').length;
		      lowerLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-1)+']').find('option.out-of-stock:not(:disabled)').length;
		}else if(lowerSwatch){
			  lowerLevelCount = $('#swatchesID-productOption0'+parseInt(optionsSelected.length-1)+'').find('.selection-box-v2:visible').length;
              lowerLevelOOSCount = $('#swatchesID-productOption0'+parseInt(optionsSelected.length-1)+'').find('.span1-outofstock').length;
		}
	      if (lowerLevelOOSCount !="" && lowerLevelCount != ""  && lowerLevelCount === lowerLevelOOSCount) {
	 	   var option ="option"+parseInt(optionsSelected.length-1);
	 	  if(! $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[optionsSelected.length-2]+']').hasClass('out-of-stock')) {
	 		  $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[optionsSelected.length-2]+']').append('<span class="out-of-stock-text"></span>');
	 		 $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[optionsSelected.length-2]+']').find('.out-of-stock-text').text('  '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
	 		  $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[optionsSelected.length-2]+']').addClass("out-of-stock");
		  	var $selectedOptionLabel = $('label[for=productOption0'+parseInt(optionsSelected.length-2)+']');
			var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue'); 
			if(! $selectedOptionValue.text().includes(' - '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)){
			//$selectedOptionValue.prepend('Out of Stock - ' );
				const textToReplace =  $selectedOptionValue.text();
				const newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
				$selectedOptionValue.text(newText);
				$selectedOptionValue.append(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
			}
			$selectedOptionValue.show();
	 	  	}
	 	  if(optionsSelected.length == 3){
	 		 var midLevelOOSCount ;
			  var midLevelCount;
			  var midSwatch=$('#swatches-productOption0'+parseInt(optionsSelected.length-2)+'').length > 0 ;
				var midDropDown=$('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-2)+']').length>0 ;
				//following code for checking mid level is drop down or pills. if  all mid level items are OOS will strike out upper level
			 if(midDropDown){
				 midLevelCount = $('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-2)+']').find('option.opt:not(:disabled)').length;
			      midLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-2)+']').find('option.out-of-stock:not(:disabled)').length;
			}else if(midSwatch){
				 midLevelCount = $('#swatchesID-productOption0'+parseInt(optionsSelected.length-2)+'').find('.selection-box-v2:visible').length;
	              midLevelOOSCount = $('#swatchesID-productOption0'+parseInt(optionsSelected.length-2)+'').find('.span1-outofstock').length;
			}
			 if (midLevelOOSCount !="" && midLevelCount != ""  && midLevelCount === midLevelOOSCount) {
			 	   var option ="option"+parseInt(optionsSelected.length-2);
			 	  if(! $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[optionsSelected.length-3]+']').hasClass('out-of-stock')) {
			 		  $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[optionsSelected.length-3]+']').append('<span class="out-of-stock-text"></span>');
			 		 $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[optionsSelected.length-3]+']').find('.out-of-stock-text').text('  '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
			 		  $('.varis-v2 option[automation-id=varisOption_'+optionsSelected[optionsSelected.length-3]+']').addClass("out-of-stock");
				  	var $selectedOptionLabel = $('label[for=productOption0'+parseInt(optionsSelected.length-3)+']');
					var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue'); 
					if(! $selectedOptionValue.text().includes(' - '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)){
					//$selectedOptionValue.prepend('Out of Stock - ' );
						const textToReplace =  $selectedOptionValue.text();
						const newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
						$selectedOptionValue.text(newText);
						$selectedOptionValue.append(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
					}
					$selectedOptionValue.show();
			 	  	}
			 }
	 	  }
	      }	else {
	    	    var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length-2) + ']');
	    	    var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	    	    $dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);

	    	 

	    	    var $dropDownOOSOption = $('.varis-v2 option[value=' + optionsSelected[optionsSelected.length-2] + ']').attr("automation-id");
	    	    $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
	    	    $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
	    	    if(optionsSelected.length == 3){
	    	    	 var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length-3) + ']');
	 	    	    var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	 	    	    $dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);

	 	    	 

	 	    	    var $dropDownOOSOption = $('.varis-v2 option[value=' + optionsSelected[optionsSelected.length-3] + ']').attr("automation-id");
	 	    	    $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
	 	    	    $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
	    	    }

	    	}	
	},
	/**
     * This method is for strike upper level swatch
     * @return void
     */
	strikeUpperLevelVariant : function(optionsSelected){
		var element;
		var noOfLevel= optionsSelected.length;
		// below code for appending OOS label in upper level swatch if all
		// item in lower level is OOS
		var lowerLevelOOSCount ;
		  var lowerLevelCount;
		  var lowerSwatch=$('#swatches-productOption0'+parseInt(optionsSelected.length-1)+'').length > 0 ;
			var lowerDropDown=$('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-1)+']').length>0 ;
			//following code for checking lower level is drop down or pills. if  all lower level items are OOS will strike out upper level
		 if(lowerDropDown){
			 lowerLevelCount = $('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-1)+']').find('option.opt:not(:disabled)').length;
		      lowerLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-1)+']').find('option.out-of-stock:not(:disabled)').length;
		}else if(lowerSwatch){
			  lowerLevelCount = $('#swatchesID-productOption0'+parseInt(optionsSelected.length-1)+'').find('.selection-box-v2:visible').length;
            lowerLevelOOSCount = $('#swatchesID-productOption0'+parseInt(optionsSelected.length-1)+'').find('.span1-outofstock').length;
		}
	      if (lowerLevelOOSCount !="" && lowerLevelCount !="" && lowerLevelCount === lowerLevelOOSCount) {
	    	 
		
		 if($('#swatches-productOption0'+parseInt(noOfLevel-2)+'').length > 0 ){// if upper layer is pills
			 element= $('input[value=' +optionsSelected[noOfLevel-2]+ ']').next().attr("automation-id");
				if($('input[value=' +optionsSelected[noOfLevel-2]+ ']').attr('checked') === 'checked'){
					$('span[automation-id='+element+']').addClass("select-span1-OOS");
					
				}
				if(!$('span[automation-id='+element+']').hasClass('span1-outofstock')) {
					$('span[automation-id='+element+']').addClass("span1-outofstock");
					if(! $('span[automation-id='+element+']').children('p').length){ // if upper layer is dropdown
		                $('span[automation-id='+element+']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
		                $('span[automation-id='+element+']').find('.p-outofstock span.sr-only').text(' '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
		                } 
				}
		 }
	    	 COSTCO.Product.appendLabelSwatches(noOfLevel-2);
	    	 if(noOfLevel==3){
	    		 var midLevelOOSCount ;
	   		  var midLevelCount;
	    		 var midSwatch=$('#swatches-productOption0'+parseInt(optionsSelected.length-2)+'').length > 0 ;
	 			var midDropDown=$('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-2)+']').length>0 ;
	 			 if(midDropDown){
	 				 midLevelCount = $('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-2)+']').find('option.opt:not(:disabled)').length;
	 			      midLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0'+parseInt(optionsSelected.length-2)+']').find('option.out-of-stock:not(:disabled)').length;
	 			}else if(midSwatch){
	 				  midLevelCount = $('#swatchesID-productOption0'+parseInt(optionsSelected.length-2)+'').find('.selection-box-v2:visible').length;
	 	            midLevelOOSCount = $('#swatchesID-productOption0'+parseInt(optionsSelected.length-2)+'').find('.span1-outofstock').length;
	 			}
	 			 if (midLevelOOSCount !="" && midLevelCount !="" && midLevelOOSCount === midLevelCount) {
	 		    	 
	 				
	 				 if($('#swatches-productOption0'+parseInt(noOfLevel-3)+'').length > 0 ){// if upper layer is pills
	 					 element= $('input[value=' +optionsSelected[noOfLevel-3]+ ']').next().attr("automation-id");
	 						if($('input[value=' +optionsSelected[noOfLevel-3]+ ']').attr('checked') === 'checked'){
	 							$('span[automation-id='+element+']').addClass("select-span1-OOS");
	 							
	 						}
	 						if(!$('span[automation-id='+element+']').hasClass('span1-outofstock')) {
	 							$('span[automation-id='+element+']').addClass("span1-outofstock");
	 						}
	 							if(! $('span[automation-id='+element+']').children('p').length){ // if upper layer is dropdown
	 				                $('span[automation-id='+element+']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	 				                $('span[automation-id='+element+']').find('.p-outofstock span.sr-only').text(' '+messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	 				                } 
	 				 }
	 			    	 COSTCO.Product.appendLabelSwatches(noOfLevel-3);
	    	 }
	    	 }
	      }else{
        	  var $selectedUpperLabel = $('label[for=productOption0'+parseInt(noOfLevel-2)+']');
              var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
              $selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS); 

              var $selectedOOSOption = $('input[value=' + optionsSelected[noOfLevel-2] + ']').next().attr("automation-id");
              $('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
              $('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
              $('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
              if(noOfLevel==3){
            	  var $selectedUpperLabel = $('label[for=productOption0'+parseInt(noOfLevel-3)+']');
                  var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
                  $selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS); 

                  var $selectedOOSOption = $('input[value=' + optionsSelected[noOfLevel-3] + ']').next().attr("automation-id");
                  $('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
                  $('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
                  $('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
              }
          }
			
	},
	/**
     * This method is for getting array of object
     * object having item id and what are the options associated with the item
     * @return void
     */
	  getLowerLevelItemDetails: function(optionsSelected){
		  //following for loop for getting item and option associated with that item 
		  var selected_first=$('#productOption00').val();
		 var count50 = 0;
		
		  var numberOfChunks =0;
		  var itemIdchunk = [] ;
		  for(var i = 0; i < product.length; i++) {
			for(var j = 0;j < products[i].length; j++){
				var singleObj = {}; // this object for holding item id and what are the options belong to that item ID
				singleObj['itemId'] = products[i][j].partNumber;
				singleObj['isaVariant'] = products[i][j].isaVariant;
				singleObj['programType'] = products[i][j].programType;
				// following for lopp for ordering options in object
				if(COSTCO.Product.item_type === 'multi_variant'){
					for(var m = 0;m < optionsSelected.length-1; m++){
						if(products[i][j].options.includes(optionsSelected[m])){
							if(m==optionsSelected.length-2){// if upto 2nd last layer all options are macthed then only we are passing that item to batch API
									for(var m = 0;m < optionsSelected.length; m++){
										if(products[i][j].options.includes(optionsSelected[m])){
											// folloeing code finding common elements and adding accoding to the index of selected option
											const findCommonOption = products[i][j].options.find(element => element == optionsSelected[m]); 
											singleObj['option'+parseInt(m+1)] = findCommonOption; 
										}else{
											//finding different option and adding to the bottom of the array
											var differentElement = products[i][j].options.filter(x => ! optionsSelected.includes(x));
											singleObj['option'+parseInt(optionsSelected.length)] = differentElement[0]; 
										}
										
								}
									 
									listOfObjects.push(singleObj);
									itemIdchunk.push(products[i] [j].partNumber);
									count50++;
							}
						}else{
							break;
						}
					}
			
				}else{
					for(var k = 0;k < products[i][j].options.length; k++){
					singleObj['option'+parseInt(k+1)] = products[i][j].options[k]; 
				}
					listOfObjects.push(singleObj);
					itemIdchunk.push(products[i] [j].partNumber);
					count50++;
				}
				
				/*following code for check item pushed in the array reached the limit(which is configured in appconfigparam) or it loop is completed
				 * in bot scenario pushing all element to the map. this map later used for callling batch API
				*/
				if(count50 == numberOfBatchApiIds || ( j == products[i].length-1 && itemIdchunk.length > 0)){
					count50 = 0;
					numberOfChunks++;
					itemIdMap.set(numberOfChunks,itemIdchunk);
					itemIdchunk = [];
				}
			}
		  }
	},
	/**
     * This method is for OOS item using batch API
     * @return void
     */
	appendLabelSwatches: function(labelLevel) {
		var $selectedOptionLabel = $('label[for=productOption0'+parseInt(labelLevel)+']');
		var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue'); 
		if(! $selectedOptionValue.text().includes(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT )){
		$selectedOptionValue.append(' - '+ messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT );
		}
		$selectedOptionValue.show();
	},
	
	/**
     * This method is for OOS item using batch API
     * @return void
     */
	findOOSitem: function(invokeBatchAPICall) {
		  itemIdMap=new Map();
		   listOfObjects = [];
		  OOSMap= new Map();
		 
		  //folowing code for avoiding 2nd method call
		  let optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
		  COSTCO.CMath.selectedswatches = optionsSelected; 
		  
		  // following code for setting 2nd swatch items for selected first swatch
		 
		  COSTCO.Product.getLowerLevelItemDetails(optionsSelected);//for setting array of item id and listOfObjects which has  itemid and option associated with that item 
		 if(invokeBatchAPICall){
		  COSTCO.Product.invokeInventoryBatchAPIcall(optionsSelected);// following code for call bact API call
		 }else{
			  var len = optionsSelected.length;
			  if($('#swatches-productOption0'+parseInt(len-1)+'').length > 0 ){
		   		COSTCO.Product.strikeOosSwatches(optionsSelected);
			   }else if($('.varis-v2[automation-id=varisSwatch_0'+parseInt(len-1)+']').length>0 ){
				   COSTCO.Product.grayOutDropDown(optionsSelected);
			   }
		 }
		//following code for remove lower skeleton and append swatches
			$('#PDPSwatchSkeletone-productOption0'+parseInt(optionsSelected.length-1)+'').hide();
			$('#swatchesID-productOption0'+parseInt(optionsSelected.length-1)+'').show();
			$('.dropdown-skeleton-productOption0'+parseInt(optionsSelected.length-1)+'').hide();
			$('[name=productOption0'+parseInt(optionsSelected.length-1)+']').show();
			COSTCO.CMath.pdpPageloadComplete = true;
			COSTCO.CMath.invokebatchCall = false;
	},
	/**
     * Changes the variance value displayed in bundle element
     * @param id of variance select element user changed
     * @param  variance label
     * @param new variance value
     * @param product price
     * @param varianceIsBackordered
     * @param varianceBackorderMessage
     * @return void
     */
	changeBundleItemVarianceValue: function(varianceId,varianceLabel,varianceValue, variancePrice, varianceIsBackordered, varianceBackorderMessage) {
		let $varianceValue = $('#bundle-item-value-' + varianceId);
		$varianceValue.find('span').text(varianceLabel+': '+varianceValue);
		let $variancePrice = $('#bundle-item-price-' + varianceId);
		$variancePrice.find('span').text(COSTCO.Product.formatMoney(variancePrice,true));
		let $bundleItem = $('#bundle-item-' + varianceId);
		$bundleItem.find('#backorder-message').remove();
		if(varianceIsBackordered && varianceBackorderMessage){
			$bundleItem.append($('<div id="backorder-message" class="warning"></div>').text(varianceBackorderMessage));
		}
	},

	/**
     * Changes the quantity displayed in bundle input element on plus/minus click
     * @param index ID of quantity element user clicked on
     * @param isIncrement boolean showing if user clicked on plus or minus button
     * @return void
     */
	changeBundleItemQuantityValue: function(index, isIncrement) {
		let qtyInput = $('#bundle-quantity-' + index);
		let qtyValue = parseInt(qtyInput.val());
		let quantityStep = 1;
		
		if (isIncrement === true) {
			let maxQnty = COSTCO.Product.maxQuantity();
	        if (qtyValue + quantityStep <= maxQnty + 1) {
	        	qtyValue += quantityStep;
		    }
		} else if (isIncrement === false) {
	        if (qtyValue - quantityStep >= 0) {
	        	qtyValue -= quantityStep;
		    }
		}
	    
    qtyInput.val(qtyValue);
		
	COSTCO.Product.validateQuantityValue(qtyInput, '.bundle-item #bundle-error-'+index);
    COSTCO.Product.discardInvalidQtyValues(qtyValue, qtyInput, isIncrement);
    
    if(!qtyInput.hasClass("error")) {
		  $('[name=quantity-' + index + ']').val(qtyValue);
		  $('[name=quantity-' + index + ']').trigger('change');
    }
	},
    
    /**
     * Adds item to the bundle and shows it in the bundle section
     * @param bundleItemObj product that is added to bundle
     * @return void
     */
    addBundleItem: function(bundleItemObj) {
    	$('#bundle-div-empty').hide();
    	if (bundleItemObj.varianceLabel && bundleItemObj.varianceValue ) {
        	$('#bundle-div').append(COSTCO.util.tmpl('tmpl_bundle_item_variance', {
                item_desc : bundleItemObj.desc,
                item_url : bundleItemObj.url,
                item_price : bundleItemObj.price,
                item_id : bundleItemObj.itemId,
                item_label: bundleItemObj.varianceLabel,
                item_value: bundleItemObj.varianceValue,
                item_data_product: parseInt(bundleItemObj.itemId) - 1
        	}));
        	if(bundleItemObj.backordered){
				if (typeof bundleItemObj.beckorderedMessage !== "undefined"){
	        		$('#bundle-item-'+bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(bundleItemObj.beckorderedMessage));
            	} else{
            		$('#bundle-item-'+bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
            	}
        	}
    	} else {
        	$('#bundle-div').append(COSTCO.util.tmpl('tmpl_bundle_item', {
                item_desc : bundleItemObj.desc,
                item_url : bundleItemObj.url,
                item_price : bundleItemObj.price,
                item_id : bundleItemObj.itemId,
                item_data_product: parseInt(bundleItemObj.itemId) - 1
        	}));
        	if(bundleItemObj.backordered){
				if (typeof backorderMessage !== "undefined"){
	        		$('#bundle-item-'+bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(backorderMessage));
            	} else{
            		$('#bundle-item-'+bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
            	}        	
			}
    	}
    	let $qtyInput = $('#bundle-quantity-' + bundleItemObj.itemId);
    	COSTCO.Product.changeBundleItemQuantityValue(bundleItemObj.itemId);
    	let numberOfItems = $('.bundle-item').length;
    	if ( numberOfItems == 1 ) {
    		$('#bundle-caption').text( messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.ITEM + ')' );
    		$('#accordion-item-number').text( '(' + numberOfItems + ' ' + messages.ITEM + ')' );
    	} else {
    		$('#bundle-caption').text( messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')' );
    		$('#accordion-item-number').text( '(' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')' );
    	}
    	$('#bundle-container').append($('#bundle-items-container'));
    	$('#bundle-items-container').show();
    	let topOfWindow = $(window).scrollTop();
		let $buildABundle = $('#build-a-bundle');
		let bottomOfElement = $buildABundle.offset().top + $buildABundle.outerHeight();
		if (topOfWindow  >= bottomOfElement && $(window).width() < 769) {
			$('#pdp-sticky-mobile').append($('#bundle-items-container'));
			$('#build-bundle-sticky').detach();
		}
		$('#addBundleBtn').removeAttr('disabled');
    },
    
    /**
     * Removes the item from the bundle section
     * @param bundleItemNumber ID number of bundle item that is being removed
     * @return void
     */
    removeBundleItem: function(bundleItemNumber) {
    	$('#ProductForm #quantity-' + bundleItemNumber).val('0');
    	$('#ProductForm #quantity-' + bundleItemNumber).trigger('change');
    	if ( $('#checkbox-bundle-' + bundleItemNumber).is(':checked') ) {
    		$('#checkbox-bundle-' + bundleItemNumber).prop('checked', false);
    		$('#checkbox-bundle-' + bundleItemNumber).closest('a').find('span').text(messages.PDP_REDESIGN_V2_ADD_TO_BUNDLE);
    	}
    	$('#bundle-item-' + bundleItemNumber).remove();
    	let numberOfItems = $('.bundle-item').length;
    	if ( numberOfItems == 0 ) {
    		$('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE_ITEMS);
    		$('#accordion-item-number').text('');
    		$('#bundle-div-empty').show();
    		let topOfWindow = $(window).scrollTop();
    		let $buildABundle = $('#build-a-bundle');
    		let bottomOfElement = $buildABundle.offset().top + $buildABundle.outerHeight();
    		if (topOfWindow  >= bottomOfElement && $(window).width() < 769) {
    			$('#bundle-container').append($('#bundle-items-container'));
    			$('#pdp-sticky-mobile').append($('#build-bundle-sticky'));
    		}
    		$('#addBundleBtn').attr('disabled', true);
    	} else {
    		if ( numberOfItems == 1 ) {
        		$('#bundle-caption').text( messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.ITEM + ')' );
        		$('#accordion-item-number').text( '(' + numberOfItems + ' ' + messages.ITEM + ')' );
        	} else {
        		$('#bundle-caption').text( messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')' );
        		$('#accordion-item-number').text( '(' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')' );
        	}
    	}
    },
    
    /**
     * Calls addBundleItem/removeBundleItem when the bundle checkbox is clicked
     * @param element checkbox element that is being clicked
     * @param bundleItemNumber ID number of bundle item
     * @return void
     */
    bundleCheckboxClick: function(element, bundleItemNumber) {
    	if ( $(element).is(':checked') ) {
			let clonedVarArr = document.getElementsByClassName('cloned');
    		var select = $("select[data-product="+(bundleItemNumber-1)+"]");
        	//Check if item is backordered
    		var isBackordered = false;
        	if($(element).closest('.bundle-product').find('#backorder-message').length > 0){
        		isBackordered = true;
        	}
    		if (clonedVarArr.length > 0 && select.length>0) {
        		var selectedOption = $("select[data-product="+(bundleItemNumber-1)+"] option:selected");
            	let selectVariantName = $(select).prop('name');
            	var labels ='';
            	//check if bundle item has variance to select
            	labels = $("label[for='" + select[1].id + "']");
            	//check value of the cloned select 
            	if (selectedOption[1].value == "unselected") {
            		$(element). prop("checked", false);
            		select.addClass("error-in-bundle");
            		labels.addClass("label-outline-error");
            		labels.show();
           			return ;
           		} else {
        	        $('#' + selectVariantName).val(selectedOption[1].value);
       		        $('#' + selectVariantName).trigger('change.vari');
           		}  			
        		let $bundleItemLink = $(element).closest('.vari').find('.desc');
        		let bundleItemObj = {
    					desc: $bundleItemLink.text(),
    					url: $bundleItemLink.attr('href'),
    					price: $(element).closest('.vari').find('.price span').text(),
    					itemId: bundleItemNumber,
    					varianceLabel: labels[1].textContent.trim(),
    					varianceValue: selectedOption[1].text,
    					backordered: isBackordered,
    					beckorderedMessage: $(element).closest('.bundle-product').find('#backorder-message').text()
        		};
        		$(element).closest('a').find('span').text( messages.PDP_REDESIGN_V2_ADDED_TO_BUNDLE );
        		COSTCO.Product.addBundleItem(bundleItemObj);
    		} else {
        		let $bundleItemLink = $(element).closest('.vari').find('.desc');
        		let bundleItemObj = {
    					desc: $bundleItemLink.text(),
    					url: $bundleItemLink.attr('href'),
    					price: $(element).closest('.vari').find('.price span').text(),
    					itemId: bundleItemNumber,
    					backordered: isBackordered
        		};
        		$(element).closest('a').find('span').text( messages.PDP_REDESIGN_V2_ADDED_TO_BUNDLE );
        		COSTCO.Product.addBundleItem(bundleItemObj);
    		}

    	} else {
    		$(element).closest('a').find('span').text( messages.PDP_REDESIGN_V2_ADD_TO_BUNDLE );
    		COSTCO.Product.removeBundleItem(bundleItemNumber);
    	}
    },
    
    /**
     * Scroll to section from product info sticky element. 
     * Sets offset approximately for the width of sticky element.   
     */
    scrollToElementOnPdpWithOffset: function() {
    	$('a.scrollLink').click(function(event) {
            event.preventDefault();
            let stickyOffset = $('#hidden-sticky').is(':hidden') ? 190 : 140;
            $('html, body').animate({scrollTop: $($(this).attr('href')).offset().top - stickyOffset}, 500);
        });
    },
    
    /**
     * Changes bundle accordion header text when accordion is expanded/collapsed
     * @return void
     */
    bundleAccordionClick: function() {
    	if ( $('#bundle-accordion-collapse').hasClass('in') ) {
    		$('#accordion-header-text').text( messages.PDP_REDESIGN_V2_VIEW_ORDER_SUMMARY );
    		$('#bundle-accordion-header a i').removeClass('rotate270');
    		$('#bundle-accordion-header a i').addClass('rotate90');
    	} else {
    		$('#accordion-header-text').text( messages.PDP_REDESIGN_V2_HIDE_ORDER_SUMMARY );
    		$('#bundle-accordion-header a i').removeClass('rotate90');
    		$('#bundle-accordion-header a i').addClass('rotate270');
    	}
    },
    /**
     * Scrolls the page to tablist and shows the buld a bundle tab
     * @return void
     */
    focusBuildABundle: function() {
    	$('html, body').scrollToElem($('.bottom-content'), 500);
    	$('#build-bundle-tab').focus();
    	setTimeout(function() {
    		$('#tablist li').removeClass('active');
        	$('.tab-content div').removeClass('active in');
        	$('#tab-header-bundle').addClass('active');
        	$('.bundle-tab').addClass('active in');
    	}, 500);
    },
    /**
     * Scrolls the page to the top and focuses on the Zip Code field
     * @return void
     */
    focusZipCodeField: function() {
    	var x = ($('#edd-message-block').length > 0) ? $("#edd-message-block").offset() : $('#delivery-zip').offset();
    	$('html, body').animate({ scrollTop: x.top - 200 }, 'slow');
    	if ($('#edd-message-block').length > 0) {
    		$('#edd-message-block').focus();
    	}
    	else {
    		$('#delivery-zip').focus();
    	}
    },
    
    
    
    
    /**
     * Makes Add to Registry button reachable by keyboard,
     * and enables click on the button via keyboard 
     */
    makeGiftRegistryAdaCompliant: function() {
      let addToRegistryDivContent = $('.mr-registry-container a');
      addToRegistryDivContent.attr('tabindex','0');
      addToRegistryDivContent.attr('role','button');
              
      addToRegistryDivContent.on('keypress click', function (event) {
        if (event.which === 13 || event.which === 1)  
         {
          addToRegistryDivContent.click();
           return false;  
         }
       });         
    },
    /**
     * ADA compliance
     * Initializes aria-current value for tab panel
     * @return void
     */
    initializeAdaForTabPanel: function() {
         $('.tablist li.active a').attr('aria-current', "true");
    },
    /**
     * Sets all bundle checkboxes to unchecked on load
     * @return void
     */
    bundlePageReload: function() {
	   $('[id^="checkbox-bundle-"]').prop('checked', false);
	   $('[id^="clonedproductOption"]').prop("selectedIndex", 0);
			      
    },
    
    arrangeBundleButtons: function() {
    	if (!$('#mr-registry-container').is(':empty')) {
    		$('#bundle-button').addClass('not-alone');
    	}
    },
    
    /** envent for determing if quantity-selector-v2 buttons shoud be enabled/disabled. This event is triggering when user changes quantity box
     * 
     */
    initializeQuantityBtns: function() {
	 $('#minQtyText').unbind('keyup').bind('keyup', function(){
		 COSTCO.Product.changeQuantityButtonsBehaviour();
	 });
    },
    
    /** function for disabling '+' and '-' buttons for quantity-selector-v2
     * @param disblebuttonSelector - selector for buttton which needs to be disabled.
     * @return void
     * 
     */
    disableButton: function(disblebuttonSelector) {
		disblebuttonSelector.get(0).setAttribute('disabled', true);
		disblebuttonSelector.addClass("disabled");
  	},
  	
  	 /** function for enabling '+' and '-' buttons for quantity-selector-v2
     * @param enablebuttonSelector - selector for buttton which needs to be enabled.
     * @return void
     * 
     */
    enableButton: function(enablebuttonSelector) {
    	enablebuttonSelector.removeAttr("disabled");
		enablebuttonSelector.removeClass("disabled");
  	},
  	/**
  	 * this function has logic for determing should '+' or '-' buttons be enabled or disabled
  	 * @return void
  	 */
  	changeQuantityButtonsBehaviour: function() {
  		let quantityStep = $('#minQtyText').attr('data-quantity-increment') ? parseInt($('#minQtyText').attr('data-quantity-increment')) : 1;
		let currentQut = $('[name=quantity]').val();
		if (currentQut > 999 - quantityStep) {
			COSTCO.Product.disableButton($("#plusQty"));
		} else if (currentQut <= quantityStep) {
			COSTCO.Product.disableButton($("#minusQty"));
		} else {
			COSTCO.Product.enableButton($("#minusQty"));
			COSTCO.Product.enableButton($("#plusQty"));
		}
  	},
  	makeTextNonClicableForSR : function () {
  		$('#product-details').off('click');
  		$('#product-details').find('*').off('click');
  	},
  	
  	initShippingStatementPopover: function() {
  		$('.popup-help').attr('aria-haspopup', 'true');
  		$('.popup-help').attr('aria-expanded', 'false');
  		let sr_message = messages.RWD_HELP;
  		$('.popup-help i').append( "<span class='sr-only'>" + sr_message +"</span>");
  		$('.popup-help').popover({
  			trigger: 'click'
  		}).on('keypress', function(e){
	  			if(e.which ===13 || e.which ===32 || e.which ===1) {
	  				// mozilla condition
	  				if($('.popover').length === 1) {
	  					return;
	  				}else {
		  				$(this).click();
	  				}
	  			}
  		})
    		.on('shown.bs.popover', function(){
    			COSTCO.util.announceSRMessage('expanded');
  				$('.popover').on('focusout ', function(e){
  					$('.popup-help').popover('hide').on('keydown', function(e){
  						if(event.shiftKey && event.keyCode === 9){
  							$('.popup-help').popover('hide');
  						}
  					});
  					
  				})
  				$('body').on('click', function (e) {
  			    let $popupContainer = $('.shipping-statement .popup-help');
			        if (!$popupContainer.is(e.target) && $popupContainer.has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
		            $popupContainer.popover('hide');
			        }
  			    
  			});
  				
  		});
  		
  	},
  	/**
     * this function has logic to show/hide review contents
     * param action
     * @return void
     */
  	changeVisibilityOfReviewContents : function (action) {
    	let $bvReviewContents = $('.bv-content-item.bv-content-top-review.bv-content-review');
    	$bvReviewContents.each( function(index) {
    	  if (index != 0 && action === "hide") {
    	    $(this).attr("style", "display: none !important");
    	  } else if (action === "show") {
    	    $(this).attr("style", "display: flex !important");
    	  }
      });
  	},
  	invokeAddedToCartModalData: function (sessionStorageDataModal) {
		let addedToCartModalData = $.parseJSON(sessionStorageDataModal);
		COSTCO.AddToCart.product_form_done(addedToCartModalData);
		sessionStorage.removeItem("AddedToCartModalData");
  	},
  	/**
	 * Show/Hide the EDD details and message based on whether Product is coming soon.
	 * @param product isComingSoon and feature flag are true shows the coming soon message else shows EDD details.
	 */
	toggleDeliveryMoleculeOnComingSoon: function() {
		if(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag){
			$('#comingsoon-alert-id').removeClass('hide');
			$('#product-form-and-action').addClass('hide');
			$('#product-estimated-date').addClass('hide');
			$('#sticky-content').addClass('hide');
		} else {
			$('#comingsoon-alert-id').addClass('hide');
			$('#product-form-and-action').removeClass('hide');
			if(!COSTCO.CMath.iskitsbundle){
				$('#product-estimated-date').removeClass('hide');
			}
			$('#sticky-content').removeClass('hide');
		}
	}
  }

  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = new Object();
  }
  window.COSTCO.Product = Product
  return Product;
});


// WEBPACK FOOTER //
// ./js/product/product_helper.js